'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

///////////////////////////////////////////////////////////////////////////
//move image to background 1.0
///////////////////////////////////////////////////////////////////////////
//
//  '.yourClass' all images inside parent will be put on the background-image
//  css property of their direct parent
/////////////////////////////////////////////////////////
//                                                    
//    moveImageToBg.call('.cover-image', {     
//      //destroyBelow: "600", //default  0            
//      //bgType: "cover",  // default cover                  
//      //bgRepeat: "no-repeat", //default no-repeat               
//      //bgPosition: "center"   //default center                         
//  });                                                
//                                                     
/////////////////////////////////////////////////////////
//

function moveImageToBg(elem, options) {
  const settings = {
    destroyBelow: "",
    pushContentDown: false,
    bgType: "cover",
    ...options
  };

  const elemParents = document.querySelectorAll(elem);

  if (!elemParents.length) {
    return {
      destroy() {}
    };
  }

  const moveThatImage = (e) => {
    if (window.innerWidth > settings.destroyBelow) {
      const images = e.querySelectorAll("img");
      for (const img of images) {
        const imgSrc = img.src;
        const imgParent = img.parentElement;

        function moveImage(parent) {
          parent.style.backgroundImage = `url(${imgSrc})`;
          parent.style.backgroundSize = settings.bgType;

        }

        moveImage(imgParent);
      }
    } else {
      const images = e.querySelectorAll("img");
      for (const img of images) {
        img.parentElement.style.backgroundImage = "none";
        img.style.display = "block";
      }
    }
  };

  const eventListeners = new Map();
  elemParents.forEach((elemParent) => {
    const boundResize = moveThatImage.bind(null, elemParent);
    eventListeners.set(elemParent, boundResize);
    window.addEventListener("resize", boundResize, { passive: true });
    moveThatImage(elemParent);
  });

  return {
    destroy() {
      elemParents.forEach((elemParent) => {
        const boundResize = eventListeners.get(elemParent);
        window.removeEventListener("resize", boundResize);
      });
    }
  };
}
  
///////////////////////////////////////////////////////////////////////////
//move image to background end 1.0
///////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////
  //effect On Scroll 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' is the element you would like .nonStick and .stick classs be added to
  /////////////////////////////////////////////////////////////////////
  //                                                                //
  //  effectOnScroll.call('header.fixed',{                         //
  //      detectDistance: 200 // default is 0                       //
  //      pushContentDown: true // default is false                 //
  //      fixed: true, // default is false                          //
  //      contentToPush: "main" //default the next element below    //
  //  });                                                          //
  //                                                               //
  ///////////////////////////////////////////////////////////////////
  //

  function effectOnScroll(selector, options = {}, callback = null) {
    const defaults = {
      detectDistance: 0,
      pushContentDown: false,
      contentToPush: 'main',
      fixed: false,
    };
    const settings = { ...defaults, ...options };
    const elements = document.querySelectorAll(selector);
    const contentToPush = document.querySelector(settings.contentToPush);
  
    // console.log(contentToPush);
    if (!elements.length) {
      return {
        destroy() {},
      };
    }
  
    const topStopDivs = [];
    const elementOffsets = [];
    for (let i = 0; i < elements.length; i++) {
      const topStopDiv = document.createElement('div');
      topStopDiv.classList.add('topstop');
      elements[i].parentNode.insertBefore(topStopDiv, elements[i]);
      topStopDivs.push(topStopDiv);
      elements[i].classList.add('scroll-off');
      elements[i].classList.add('scrolling-target');
      elementOffsets.push(elements[i].offsetTop);
    }
  
    function stickyElements() {
      const windowTop = window.scrollY + settings.detectDistance * 1000;
      const footer = document.querySelector('footer');
      const footerTop = footer.offsetTop + footer.offsetHeight;
      const mainBody = contentToPush;
  
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const topStopDiv = topStopDivs[i];
        const divTopFixed = topStopDiv.offsetTop;
        const divTop = elementOffsets[i];
        const divHeight = element.offsetHeight;
        const stickyArea = element;
  
        if (settings.fixed) {
          if (windowTop + divHeight > footerTop) {
            stickyArea.style.top = `${(windowTop + divHeight - footerTop) * 1}px`;
          } else if (windowTop > divTopFixed) {
            stickyArea.classList.remove('scroll-off');
            stickyArea.classList.add('scroll-on');
            mainBody.style.paddingTop = settings.pushContentDown ? `${divHeight}px` : '0';
          } else {
            stickyArea.classList.remove('scroll-on');
            stickyArea.classList.add('scroll-off');
            mainBody.style.paddingTop = '0';
          }
        } else {
          if (windowTop + divHeight > footerTop) {
            stickyArea.style.top = `${(windowTop + divHeight - footerTop) * 1}px`;
          } else if (windowTop > divTop) {
            stickyArea.classList.remove('scroll-off');
            stickyArea.classList.add('scroll-on');
            mainBody.style.paddingTop = settings.pushContentDown ? `${divHeight}px` : 'auto';
          } else {
            stickyArea.classList.remove('scroll-on');
            stickyArea.classList.add('scroll-off');
            mainBody.style.paddingTop = '0';
          }
        }
      }
    }
  
    const boundStickyElements = stickyElements.bind(null);
    window.addEventListener('scroll', boundStickyElements, { passive: true });
    boundStickyElements();
  
    if (typeof callback === 'function') {
      callback.call(this);
    }
  
    return {
      destroy() {
        window.removeEventListener('scroll', boundStickyElements);
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          element.classList.remove('scroll-off', 'scroll-on', 'scrolling-target');
          const topStopDiv = topStopDivs[i];
          topStopDiv.remove();
        }
      },
    };
  }

  ///////////////////////////////////////////////////////////////////////////
  //effectOnScroll 1.0 end
  ///////////////////////////////////////////////////////////////////////////

function ncrSlider(sliderParent, options){
  const settings = {
      sliderWrapper: '.feature-wrap',
      slide: '.feature',
      nav: "",
      arrows: "",
      arrowPrev: '<span class="icon-utility-caret-left" aria-label="previous" role="img"></span>',
      arrowNext: '<span class="icon-utility-caret-right" aria-label="next" role="img"></span>',
      fade: "true",
      touchScroll: "",
      autoplay: "",
      slides: "",
      speed: "7000",
      responsive: () => {},
      ...options,
  };
  const util = (t, c) => Object.assign(document.createElement(t), c);
  const mod = (n, m) => ((n % m) + m) % m;
  const slider = (carousel) => {
      const animation = 300;
      const carouselSlider = carousel;
      
      const sliderParentZone = carouselSlider.parentElement;
      const slideMinWidth = parseInt(carouselSlider.getAttribute('ncr-slider-min-width')) || 300; 
  
      function createSliderDiv() {
        const sliderParent = document.createElement('div');
        sliderParent.className = 'slider-parent';
        sliderParent.appendChild(carouselSlider);
        return sliderParent;
      }
  
      let sliderDiv = createSliderDiv();
      sliderParentZone.appendChild(sliderDiv);
  
      let sliderParentZoneWidth =  sliderDiv.offsetWidth;
      let actualSlide = sliderParentZoneWidth/slideMinWidth;
      let actualSlideNumber = Math.floor(actualSlide);
  
      const autoplay = carouselSlider.getAttribute('ncr-slider-autoplay') || false;
      const touchScroll = carouselSlider.getAttribute('ncr-slider-touch-scroll')|| false;
      const timeBetweenSlides = parseInt(carouselSlider.getAttribute('ncr-slider-speed')) || 0;
      const arrows = carouselSlider.getAttribute('ncr-slider-arrows') || false;
      const nav = carouselSlider.getAttribute('ncr-slider-nav') || false ;
      carouselSlider.getAttribute('ncr-slider-fade') || false;
      const random = carouselSlider.getAttribute('ncr-slider-random') || false;
      let slideNumber = settings.slides || parseInt(carouselSlider.getAttribute('ncr-slider-slides'));

      carouselSlider.attributes;
      
      const slides = carouselSlider.querySelectorAll(settings.slide) || '.feature';
      const btns = [];
      const sliderSlideAttrs = Array.from(carouselSlider.attributes).filter(attr => attr.name.includes('ncr-slider-slides-'));
      let c = 0;
      let totalSlides = slides.length;
      let initialMouseX = 0;
      let currentMouseX = 0;
      let initialTouchX = 0; 
      let currentTouchX = 0;
      if (totalSlides <  slideNumber) return; 
      var computedStyle = getComputedStyle(sliderDiv);
      let actualSliderParentWidth = sliderDiv.clientWidth;
      actualSliderParentWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
  


      if(random){
        // console.log(`is random ${random}`)
        var getRan = Math.floor(Math.random() * (totalSlides));
        c = getRan;
      }else {
        c = 0;
      }
  
  
      let newSlideNumber;
  
      if (slideNumber <=  actualSliderParentWidth/slideMinWidth){
        newSlideNumber = slideNumber;
      }
      else if (slideNumber >=  actualSliderParentWidth/slideMinWidth){
        newSlideNumber = actualSlideNumber;
      }else {
        newSlideNumber = actualSlideNumber;
      }
  
        
      function handleResize() {
        actualSliderParentWidth = sliderDiv.clientWidth;
        // console.log(actualSliderParentWidth,  'actual parent width')
        if (slideNumber <=  actualSliderParentWidth/slideMinWidth){
          newSlideNumber = slideNumber;
        }
        else if (slideNumber >=  actualSliderParentWidth/slideMinWidth){
          newSlideNumber = actualSlideNumber;
        }else {
          newSlideNumber = actualSlideNumber;
        }
        if(nav) {
          createNavButtons(carousel, totalSlides, newSlideNumber);
      }
        if(sliderSlideAttrs.length > 0){
          for (let i = 0; i < sliderSlideAttrs.length; i++) {
            const attr = sliderSlideAttrs[i];
            const queryWidth = attr.name.split('-').pop();
            if (parseInt(queryWidth) > actualSliderParentWidth) {
              newSlideNumber = attr.value;
            } else {
              newSlideNumber = settings.slides || parseInt(carouselSlider.getAttribute('ncr-slider-slides'));
            }
          }
        }
        
        const slideWidth = actualSliderParentWidth / newSlideNumber;
        // console.log(newSlideNumber, 'new slide')
        // console.log( slideWidth,'slide width')
  
        slides.forEach(slide => {
          slide.style.width = `${slideWidth}px`;
        });
        
        const totalWidth = slideWidth * totalSlides;
        carouselSlider.style.width = `${totalWidth}px`;
        carouselSlider.style.transform = `translateX(${-(c * slideWidth)}px)`;
  
      }
     
      const anim = (ms = animation) => {
        const cMod = mod(c, totalSlides);
  
        carouselSlider.style.transitionDuration = `${ms}ms`;
        carouselSlider.addEventListener('resize', handleResize);
        handleResize();
  
     
      
        slides.forEach((slide, i) => {
          const slideIndex = mod(i, totalSlides);
          let isActive = false;
          for (let j = 0; j < newSlideNumber; j++) {
            const targetIndex = mod(cMod + j, totalSlides);
            if (slideIndex === targetIndex || slideIndex === mod(targetIndex - totalSlides, totalSlides)) {
              isActive = true;
              break;
            }
          }

           // Update nav buttons
          const navButtons = document.querySelectorAll('.nav-btn');
          navButtons.forEach(btn => {
              const startSlide = parseInt(btn.getAttribute('data-start-slide'), 10);
              // Correcting the range check for active button
              const endSlide = startSlide + newSlideNumber; // calculates the end slide for the button's range
              const isActive = cMod >= startSlide && cMod < endSlide;
              // console.log(isActive, endSlide)
              btn.classList.toggle("is-active", isActive);
          });
          // if (slideIndex === totalSlides - 1 && cMod === 0) {
          //   // Special case: last slide in original set is active
          //   isActive = true;
          // } else if (slideIndex === 0 && cMod === totalSlides - 1) {
          //   // Special case: first slide in original set is active
          //   isActive = true;
          // }

          // Manage active state and video playback
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("tabindex", "-1");
          slide.querySelectorAll('a').forEach((e) => {
            e.setAttribute("tabindex", "-1");
          });
          // Find video elements and control playback
          const videos = slide.querySelectorAll('video');
          videos.forEach(video => {
            if (isActive) {
              video.play();
            } else {
              video.pause();
              video.currentTime = 0;

            }
          });
        });
  
        btns.forEach((btn, i) => btn.classList.toggle("is-active", cMod === i));
        const elements = document.querySelectorAll('.carousel-slide a');
        for (const element of elements) {
          element.setAttribute("tabindex", "-1");
        }
        const elementsActive = document.querySelectorAll('.is-active a');
        for (const element of elementsActive) {
          element.setAttribute("tabindex", "0");
        }
        // elementsActive[0].focus();
  
          // console.log(c, cMod);
      };
      const next = () => {
        // if (random) {
        //   // Go to a random slide instead of just the next one
        //   c = Math.floor(Math.random() * totalSlides);
        // } else {
          c = (c + newSlideNumber) % totalSlides;
        // }
        anim();
      };
      const prev = () => {
        // if (random) {
        //   // Go to a random slide instead of just the previous one
        //   c = Math.floor(Math.random() * totalSlides);
        // } else {
          c = (c - newSlideNumber + totalSlides) % totalSlides;
        // }
        anim();
      };

      const goto = (index) => {
        c = index;
        anim();
      };

      const play = () => {
        setInterval(next, timeBetweenSlides + animation);
      };

      const createArrows = (carouselSlider) => {
          const prevBtn = util("button", {
              type: "button",
              className: "ncr-slider-prev",
              innerHTML: settings.arrowPrev,
              onclick: () => prev(),
          });
          const nextBtn = util("button", {
              type: "button",
              className: "ncr-slider-next",
              innerHTML: settings.arrowNext,
              onclick: () => next(),
          });
          prevBtn.setAttribute("aria-label", "Go to previous slide");
          nextBtn.setAttribute("aria-label", "Go to next slide");
          carouselSlider.parentElement.appendChild(prevBtn);
          carouselSlider.parentElement.appendChild(nextBtn);
      };
      // Function to create and append navigation buttons
      const createNavButtons = (carouselSlider, totalSlides, newSlideNumber) => {
        const existingNav = carouselSlider.parentElement.querySelector('.ncr-slider-nav');
        if(existingNav){
            existingNav.remove();  // Clear previous nav buttons if they exist
        }
        const sliderNav = util("div", {
            className: "ncr-slider-nav",
        });
        for (let i = 0; i < Math.ceil(totalSlides / newSlideNumber); i++) {
            const startSlideIndex = i * newSlideNumber;
            const btn = util("button", {
                type: "button",
                className: "nav-btn",
                onclick: () => goto(startSlideIndex),
            });
            // Set attributes with dynamic values for accessibility
            btn.setAttribute("data-start-slide", startSlideIndex);
            btn.setAttribute("aria-label", `Go to slide ${startSlideIndex + 1}`);  // +1 to make it human-readable (1-indexed)
            sliderNav.appendChild(btn);
        }
        carouselSlider.parentElement.appendChild(sliderNav);
    };
  
      if(arrows) {
          createArrows(carousel);
      }
      if(nav) {
          createNavButtons(carousel, totalSlides, newSlideNumber);
      }
if(touchScroll) {  
    const MIN_DRAG_DISTANCE_MOUSE = 50;
    const MIN_DRAG_DISTANCE_TOUCH = 50;
    let distanceMoved = 0;
    let hasMoved = false;  // Flag to track if the user has moved the carousel
    
    carouselSlider.addEventListener("mousedown", (event) => {
      initialMouseX = event.clientX;
      hasMoved = false;  // Reset hasMoved flag
    },{ passive: true });
    
    carouselSlider.addEventListener("mousemove", (event) => {
      currentMouseX = event.clientX;
      hasMoved = true;  // Set hasMoved flag to true
    },{ passive: true });
    
    carouselSlider.addEventListener("mouseup", (event) => {
      distanceMoved = currentMouseX - initialMouseX;
      if (hasMoved && Math.abs(distanceMoved) > MIN_DRAG_DISTANCE_MOUSE) {
        if (distanceMoved > 0) {
          prev();
        } else {
          next();
        }
        distanceMoved = 0;  // Reset distanceMoved to 0 after calling prev or next
      }
    },{ passive: true });
    
    carouselSlider.addEventListener("touchstart", (event) => {
      initialTouchX = event.touches[0].clientX;
      hasMoved = false;  // Reset hasMoved flag
    },{ passive: true });
    
    carouselSlider.addEventListener("touchmove", (event) => {
      currentTouchX = event.touches[0].clientX;
      hasMoved = true;  // Set hasMoved flag to true
    },{ passive: true });
    
    carouselSlider.addEventListener("touchend", (event) => {
      distanceMoved = currentTouchX - initialTouchX;
      if (hasMoved && Math.abs(distanceMoved) > MIN_DRAG_DISTANCE_TOUCH) {
        if (distanceMoved > 0) {
          prev();
        } else {
          next();
        }
        distanceMoved = 0;  // Reset distanceMoved to 0 after calling prev or next
      }
    },{ passive: true });

  }
  if(autoplay){
    // carousel.addEventListener("pointerenter", () => stop());
    // carousel.addEventListener("pointerleave", () => play());
    play();
  }
  carouselSlider.addEventListener("transitionend", () => {
    if (c <= -1) c = totalSlides - 1;
    if (c >= totalSlides) c = 0;
    anim(0); 
  },{ passive: true });
 
  carouselSlider.addEventListener("keydown", (event) => {
    if (event.keyCode === 9 ) ; else if (event.keyCode === 9 && event.shiftKey) ;
    else if (event.keyCode === 37) { // Left arrow key
      prev();
    } else if (event.keyCode === 39) { // Right arrow key
      next();
    }
    
  },{ passive: true });
  anim();
  window.addEventListener("resize", handleResize);
};

document.querySelectorAll(sliderParent).forEach(slider);
}

///////////////////////////////////////////////////////////////////////////
  //slick
  ///////////////////////////////////////////////////////////////////////////
  //
  //
  //  put on '.hero .zone .feature-wrap' or just copy and paste below to initiate slick
  /////////////////////////////////////////////////////////
  //                                                     //
  //  $('.hero .zone .feature-wrap').initiateSlick();    //
  //                                                     //
  /////////////////////////////////////////////////////////
  //
  //
  function jquerySlider(elem, options, callback) {

    var settings = $.extend({
      slider_speed: 0,
      nextArrow: '',
      prevArrow: '',
      fade: true,
    }, options);

    var placeholder_speed = settings.slider_speed; //change this if you want to test different speeds
    var placeholder_initial_slide = 0; //change this if you want to test different starting slides
    var promo_speed = (typeof cfg_promo_speed == "undefined") ? placeholder_speed : cfg_promo_speed; //pull the global variable if it exists
    var initial_slide = (typeof cfg_promo_initial_slide == "undefined") ? placeholder_initial_slide : cfg_promo_initial_slide; //pull the global variable if it exists
    var autoplay = (promo_speed == 0) ? false : true;
    var slide_selector_class = elem;

    // Slick SLide
    $(document).ready(function () {
      $(slide_selector_class).slick({
       
        autoplay: autoplay,
        autoplaySpeed: promo_speed,
        initialSlide: initial_slide,
        dots: true,
        infinite: true,
        slide: ".feature",
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 0,
        fade: settings.fade,
        pauseOnHover: true,
        cssEase: 'linear',
        // Custom arrows
        nextArrow: settings.nextArrow,
        prevArrow: settings.prevArrow,
        arrows: true
      });
    });
    // END Slick SLide


    if (typeof callback == 'function') { // make sure the callback is a function
      callback.call(this); // brings the scope to the callback
    }
  }


  ///////////////////////////////////////////////////////////////////////////
  //slick end
  ///////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////
  //moveElementToAnother 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' is the element that will be moved to a specified element
  //
  /////////////////////////////////////////////////////////
  //
  // moveElementAround('header .band-utility-1 .feature-wrap', {
  //   // insideBefore: "header .band-menu-panel .feature-wrap-menu",
  //   insideAfter: 'header .band-menu-panel .feature-wrap-menu',
  //   // returnAbove: 1024, // Width in pixels
  //   returnBelow: 900,  // Width in pixels
  // });
  //                                                     
  /////////////////////////////////////////////////////////
  //

  function moveElementAround(mainElementSelector, options) {
    var settings = {
      insideBefore: "",
      insideAfter: "",
      returnAbove: null,
      returnBelow: null,
      ...options
    };
  
    const mainElements = document.querySelectorAll(mainElementSelector);
  
    if (!mainElements.length) {
      return {
        destroy() {}
      };
    }
  
    const moveElements = (mainElement) => {
      const insideBeforeElement = settings.insideBefore
        ? document.querySelector(settings.insideBefore)
        : null;
      const insideAfterElement = settings.insideAfter
        ? document.querySelector(settings.insideAfter)
        : null;
  
      const windowWidth = window.innerWidth;
      const originalPosition = mainElement.originalPosition;
  
      if (settings.returnBelow && windowWidth < settings.returnBelow) {
        if (insideBeforeElement) {
          insideBeforeElement.parentNode.insertBefore(mainElement, insideBeforeElement);
        } else if (insideAfterElement) {
          insideAfterElement.parentNode.insertBefore(mainElement, insideAfterElement.nextSibling);
        }
      } else if (originalPosition) {
        originalPosition.parentElement.insertBefore(mainElement, originalPosition.nextElementSibling);
      }
    };
  
    const eventListeners = new Map();
    mainElements.forEach(mainElement => {
      mainElement.originalPosition = {
        nextElementSibling: mainElement.nextElementSibling,
        parentElement: mainElement.parentElement
      };
      const boundResize = moveElements.bind(null, mainElement);
      eventListeners.set(mainElement, boundResize);
      window.addEventListener('resize', boundResize, { passive: true });
      moveElements(mainElement);
    });
  
    return {
      destroy() {
        mainElements.forEach(mainElement => {
          const boundResize = eventListeners.get(mainElement);
          window.removeEventListener('resize', boundResize);
        });
      }
    };
  }
  
  ///////////////////////////////////////////////////////////////////////////
  //moveElementToAnother 1.0
  ///////////////////////////////////////////////////////////////////////////

function utils() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  const browserClasses = {
    chrome: 'browser-chrome',
    firefox: 'browser-firefox',
    safari: 'browser-safari',
    edge: 'browser-edge',
    opera: 'browser-opera',
    trident: 'browser-ie',
    msie: 'browser-ie',
  };
  
  const browserName = Object.keys(browserClasses).find((browser) => userAgent.indexOf(browser) > -1);
  
  if (browserName) {
    document.body.classList.add(browserClasses[browserName]);
  }
  
  setTimeout(() => {
    document.body.classList.remove('preload');
  }, 500);
  window.addEventListener(
    'resize',
    function() {
      document.body.classList.add('resizing');
      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function() {
        document.body.classList.remove('resizing');
      }, 250);
    },
    { passive: true }
  );
  
  document.querySelectorAll('a[href*="#"]').forEach(function (link) {

    var href = link.getAttribute('href');
    if (href.startsWith('#')) {
      link.addEventListener('click', function(e) {
        var locationHref = location.href.split('#')[0];
        var linkHref = this.href.split('#')[0];

        if (locationHref === linkHref) {
          e.preventDefault();
          var targetSelector = this.hash || ('[name=' + this.hash.slice(1) + ']');
          var target = document.querySelector(targetSelector);
          $(target).siblings().trigger('ncr-close-panel');
          if (target !== null) {
            var scrollingTarget = document.querySelector('.scrolling-target');
            var offsetHeight = scrollingTarget !== null ? scrollingTarget.getBoundingClientRect().height: 0;
            var targetPosition = (target.getBoundingClientRect().top ) + window.pageYOffset;
            window.scroll({
              top: targetPosition - (offsetHeight + 50),
              left: 0,
              behavior: 'smooth'
            });
            history.pushState(null, null, this.hash);
            $(target).trigger('ncr-open-panel');
          }
        } else {
          window.location.href = this.href;
        }
      });
    }
  });
    
  if (window.location.hash) {
    var hash = window.location.hash;
    history.replaceState(null, null, ' ');


    setTimeout(function (event) {
      if (target !== null) {

        var target = document.querySelector(hash) || document.querySelector('[name=' + hash.slice(1) + ']');
        $(target).siblings().trigger('ncr-close-panel');
        $(target).siblings().find('[ncr-panel]').trigger('ncr-close-panel');
        $(target).trigger('ncr-open-panel');
        $(target).find('.panel-accordion[ncr-panel]:first').trigger('ncr-open-panel');
        history.replaceState(null, null, hash);
        setTimeout(() => {
          var target = document.querySelector(hash) || document.querySelector('[name=' + hash.slice(1) + ']');
          var scrollingTarget = document.querySelector('.scrolling-target');
          var offsetHeight = scrollingTarget !== null ? scrollingTarget.getBoundingClientRect().height: 0;
          var targetPosition = (target.getBoundingClientRect().top ) + window.pageYOffset;
          window.scroll({
            top: targetPosition -  (offsetHeight + 50),
            left: 0,
            behavior: 'smooth'
          });
        }, 500);
      }
    },100); 
  }
  }

const ncrIcons = Array(
    // Test Icon
    {
      prefix: 'ncr',
      iconName: 'test2',
      icon: [
        448, 448,
        [],
        null,
        'M163.006,417.598  L129.87,193.129 L63.506,105.159 L166.015,142.371 L163.006,31.402 L224.5,122.983 L285.995,31.402 L282.985,142.371 L385.495,105.159 L319.13,193.13 L423.5,224.5 L319.13,255.871 L385.494,343.841 L282.984,306.629 L285.994,417.598 L224.5,326.017 z'
      ]
    },
      //Candecents lgoo
    {
      prefix: 'logos',
      iconName: 'candescent',
      icon: [
        400, 65,
        [],
        null,
        'M122.4,45.6h0ZM124.2,40.9h0ZM166.4,14.5c-3.2,0-5.9.9-8,2.6-1.4,1.2-2.6,2.5-3.4,4.1v-5.7h-7.1v29.3h7.1v-18.1c.4-1.8,1.2-3.3,2.4-4.6,1.5-1.5,3.3-2.2,5.6-2.2s3.5.6,4.4,1.9c1,1.2,1.5,3,1.5,5.6v17.5h7v-18.8c0-4-.8-6.9-2.5-8.7-1.7-1.9-4-2.8-7-2.8h0ZM141.8,40.1c-.4-.4-.8-.9-1-1.7s-.4-1.8-.4-3.2v-10.8c0-3.5-1.1-6.1-3.2-7.6-2.1-1.6-5-2.4-8.5-2.4s-5.3.5-7.4,1.4-3.8,2.2-5.1,3.9c-1.2,1.6-2,3.5-2.2,5.7h6.4c0-1.9.8-3.4,2.1-4.4,1.4-1.1,3.2-1.6,5.6-1.6s3.1.3,4,.9c1,.6,1.4,1.4,1.4,2.6s-.3,1.6-.8,2.1-1.3,1-2.3,1.4-2.4.8-4.5,1.4l-.7.2c-2.9.8-5.1,1.7-6.8,2.4-1.7.8-3,1.7-3.9,2.9s-1.4,2.7-1.4,4.5.8,4.5,2.4,5.8c1.7,1.4,3.9,2,6.7,2h0c3.1,0,5.7-.8,7.7-2.4,1.6-1.3,2.8-2.8,3.6-4.5.2,2,.9,3.5,2,4.6,1.4,1.3,3,2,5,2s1.8,0,2.6-.3c.8-.2,1.5-.5,2-.8v-4.1c-.4.4-1,.5-1.7.5s-1.2-.2-1.7-.5h0ZM133.6,30.1c0,2.1-.4,3.9-1.3,5.6-.8,1.6-2,2.9-3.4,3.9-1.4.9-3,1.4-4.7,1.4h0c-1.2,0-2.2-.3-3-.9-.8-.6-1.2-1.5-1.2-2.7s.2-1.6.7-2.1c.5-.6,1.2-1.1,2.1-1.6.9-.4,2.3-1,4.1-1.6h.3c1.8-.7,3.1-1.2,3.9-1.6.9-.4,1.6-.9,2.1-1.5.1-.2.3-.4.4-.5v1.7h0ZM102.2,38.5c-1.4,1.4-3.3,2.1-6,2.1s-5.1-1-6.7-3-2.3-4.5-2.3-7.6.3-3.8,1-5.3c.7-1.6,1.7-2.8,3-3.7,1.4-.9,3-1.3,5-1.3s3.2.3,4.4,1c1.2.6,2.1,1.4,2.7,2.3.7,1,1.2,2,1.4,3h6.6c-.3-2.1-1.1-4.1-2.4-5.8-1.3-1.8-3.1-3.1-5.3-4.1-2.1-1-4.6-1.6-7.4-1.6s-5.7.6-8.1,1.9c-2.4,1.2-4.3,3-5.6,5.3-1.4,2.4-2,5.2-2,8.4s.7,6.1,2,8.5c1.4,2.4,3.2,4.2,5.6,5.4,2.3,1.2,5,1.9,7.9,1.9s5.7-.6,7.9-1.7c2.3-1.2,4-2.7,5.3-4.7,1.3-1.9,2.1-4.1,2.3-6.5h-6.6c-.4,2.2-1.2,4-2.6,5.5h-.1ZM203.4,19.6c-1-1.4-2.2-2.5-3.8-3.4-1.8-1.1-4-1.7-6.4-1.7s-5.2.7-7.2,2c-2,1.4-3.4,3.2-4.4,5.6-1,2.3-1.5,5-1.5,7.9s.5,5.5,1.4,7.8c1,2.3,2.4,4.1,4.2,5.4,1.9,1.3,4.1,2,6.7,2h0c2.7,0,5-.7,6.9-2.1,1.8-1.3,3.1-2.9,4.1-4.9v6.6h7.1V1.2h-7.1v18.4ZM203.4,29.1h0c0,2.1-.3,4-1,5.7-.6,1.7-1.5,3.1-2.8,4.1-1.2,1-2.7,1.5-4.5,1.5s-4.5-1-5.8-2.9c-1.3-2-1.9-4.4-1.9-7.5s.7-6,2.1-8c1.4-2,3.4-3,5.9-3s3.7.6,5.3,1.9c1.2.9,2.1,2,2.9,3.3v4.8h-.2ZM340.5,21.8c-1.3-2.4-3.1-4.2-5.5-5.5s-5.1-1.9-8.1-1.9-5.7.6-8.1,1.9-4.3,3.1-5.7,5.5c-1.4,2.4-2,5.2-2,8.4s.7,6.1,2,8.5c1.4,2.3,3.3,4.1,5.7,5.4,2.4,1.2,5.1,1.8,8.1,1.8h0c3,0,5.6-.6,7.7-1.7,2.2-1.1,3.9-2.6,5.1-4.4,1.3-1.8,2.1-3.7,2.4-5.8h-6.8c-.4,1.7-1.3,3.3-2.7,4.5-1.4,1.2-3.3,1.9-5.6,1.9s-3.6-.4-5-1.3c-1.4-.9-2.5-2.1-3.2-3.6s-1.1-3.4-1.1-5.4h24.7c0-3.1-.7-5.9-2-8.2h.1ZM318.4,25.5c.1-.4.3-.7.4-1.1.8-1.6,1.8-2.7,3.2-3.5,1.4-.8,3-1.3,4.8-1.3s3.5.4,4.8,1.2c1.3.8,2.3,1.8,3,3.2.2.5.4.9.6,1.4h-16.8ZM400.5,37.3c-1.4,1.9-3.3,2.8-5.7,2.8s-2.6-.4-3.5-1.3c-.8-.9-1.3-2.4-1.3-4.5v-13.8h9.4v-5h-9.4V2.9h-.2l-6.9,4.9v7.7h-6.2v5h6.2v13.8c0,3.9.8,6.8,2.5,8.5,1.7,1.8,4,2.6,7,2.6h0c2.1,0,3.9-.3,5.4-1s2.7-1.6,3.5-2.6l-.9-4.5h.1ZM365.2,14.5c-3.2,0-5.9.9-8,2.6-1.4,1.2-2.6,2.6-3.4,4.1v-5.7h-7.1v29.3h7.1v-18.1c.4-1.8,1.2-3.3,2.4-4.6,1.5-1.5,3.3-2.2,5.6-2.2s3.5.6,4.4,1.9c1,1.2,1.5,3,1.5,5.6v17.5h7v-18.8c0-4-.8-6.9-2.5-8.7-1.7-1.9-4-2.8-7-2.8h0ZM299.9,38.5c-1.4,1.4-3.3,2.1-6,2.1s-5.1-1-6.7-3-2.3-4.5-2.3-7.6.3-3.8,1-5.3c.7-1.6,1.7-2.8,3-3.7,1.4-.9,3-1.3,5-1.3s3.2.3,4.4,1c1.2.6,2.1,1.4,2.7,2.3.7,1,1.2,2,1.4,3h6.6c-.3-2.1-1.1-4.1-2.4-5.8-1.3-1.8-3.1-3.1-5.3-4.1-2.1-1-4.6-1.6-7.4-1.6s-5.7.6-8.1,1.9c-2.4,1.2-4.3,3-5.6,5.3-1.4,2.4-2,5.2-2,8.4s.7,6.1,2,8.5c1.4,2.4,3.2,4.2,5.5,5.4s5,1.9,7.9,1.9h0c3.1,0,5.7-.6,7.9-1.7,2.3-1.2,4-2.7,5.3-4.7,1.3-1.9,2.1-4.1,2.3-6.5h-6.6c-.4,2.2-1.2,4-2.6,5.5h0ZM244.3,21.8c-1.3-2.4-3.1-4.2-5.5-5.5-2.3-1.3-5.1-1.9-8.1-1.9s-5.7.6-8.1,1.9c-2.4,1.3-4.3,3.1-5.7,5.5s-2,5.2-2,8.4.7,6.1,2,8.5c1.4,2.3,3.3,4.1,5.7,5.4,2.4,1.2,5.1,1.8,8.1,1.8h0c3,0,5.6-.6,7.7-1.7,2.2-1.1,3.9-2.6,5.1-4.4,1.3-1.8,2.1-3.7,2.4-5.8h-6.8c-.4,1.7-1.3,3.3-2.7,4.5s-3.3,1.9-5.6,1.9-3.6-.4-5-1.3c-1.4-.9-2.5-2.1-3.2-3.6s-1.1-3.4-1.1-5.4h24.7c0-3.1-.7-5.9-2-8.2h.1ZM222.2,25.5c.1-.4.3-.7.4-1.1.8-1.6,1.8-2.7,3.2-3.5s3-1.3,4.8-1.3,3.5.4,4.8,1.2c1.3.8,2.3,1.8,3,3.2.2.5.4.9.6,1.4h-16.8ZM270.9,30.2c-1.5-.8-3.6-1.6-6.2-2.4h-.2c-2.3-.8-4-1.4-5.1-1.9s-1.9-1-2.4-1.5c-.5-.6-.8-1.2-.8-2s.5-1.9,1.4-2.4c1-.6,2.3-.8,4.1-.8s3.6.4,4.8,1.3c1.2.9,2,2.1,2.2,3.6h6.6c-.5-3-1.9-5.3-4.2-7-2.3-1.7-5.5-2.6-9.4-2.6s-6.5.7-8.8,2.1c-2.2,1.4-3.3,3.5-3.3,6.2s.5,3.1,1.4,4.2,2.1,2,3.5,2.7,3.4,1.5,6,2.4h.4c2,.8,3.5,1.4,4.5,1.8,1.1.5,2,1,2.6,1.7.6.6,1,1.3,1,2.1s-.5,2-1.6,2.6c-1,.5-2.4.8-4.1.8s-4.3-.5-5.7-1.6c-1.4-1.1-2.2-2.6-2.6-4.6h-6.7c.4,3.4,2,6.1,4.6,8s6,2.9,10.2,2.9h0c3.7,0,6.7-.7,9.1-2.2,2.3-1.5,3.5-3.7,3.5-6.6s-.4-2.9-1.3-4c-.8-1.1-2-2-3.5-2.8h0ZM0,15v30l26,15,26-15V15L26,0,0,15Z'
      ]
    },
    {
      prefix: 'ncr',
      iconName: 'google-play',
      icon: [
        320, 100,
        [],
        null,
        'M242.83,53.29a5,5,0,0,1-5.07,5h-6.14V48.32h6.14A5,5,0,0,1,242.83,53.29ZM181.18,58a6,6,0,0,0,0,11.95c2.94,0,5.26-2.5,5.26-5.94S184.12,58,181.18,58Zm-43.09,0a6,6,0,1,0,5.56,6A5.68,5.68,0,0,0,138.09,58ZM260.56,67.5c0,1.75,2,2.46,3.39,2.46a5.25,5.25,0,0,0,5.15-4.58,7.7,7.7,0,0,0-4-1C263,64.41,260.56,65.27,260.56,67.5Zm57.77-52.75v70.5A14.8,14.8,0,0,1,303.58,100H14.75A14.8,14.8,0,0,1,0,85.25V14.75A14.8,14.8,0,0,1,14.75,0H303.58A14.8,14.8,0,0,1,318.33,14.75ZM176.66,34.1h2.25V25.21l-.06-1.95L185.55,34l.06.11h2.23V19.74h-2.25v8.37l.06,2-6.46-10.33h-2.53Zm-16.79-7.18A7.37,7.37,0,0,0,162,32.24a7.46,7.46,0,0,0,10.52,0,7.36,7.36,0,0,0,2.12-5.32,7.35,7.35,0,0,0-2.13-5.3,7.41,7.41,0,0,0-10.51,0A7.37,7.37,0,0,0,159.87,26.92ZM140.44,34.1h2.25V19.74h-2.25ZM114,34.1h8.58V31.93h-6.33V28H122V25.86h-5.71V21.91h6.33V19.74H114ZM97.39,26.92a7.38,7.38,0,0,0,7.45,7.49,7,7,0,0,0,5.27-2.12,6.52,6.52,0,0,0,1.79-4.8,5.82,5.82,0,0,0-.1-1.09l0-.19h-7.16v2.13h5a4.08,4.08,0,0,1-1.07,2.42,5.21,5.21,0,0,1-8.89-3.84,5.14,5.14,0,0,1,5.17-5.32,4.47,4.47,0,0,1,3.63,1.57l.16.19,1.55-1.55-.14-.16A6,6,0,0,0,107.78,20a7.4,7.4,0,0,0-2.94-.6,7.38,7.38,0,0,0-7.45,7.49Zm-19,23.17c0-1.21-.81-2.43-2.43-3.34l-10.4-5.91-.21.21-9,9,9,9,10.6-6a4.3,4.3,0,0,0,2.43-3ZM63.5,60.19l-8.62-8.62L27.13,79.35a4.45,4.45,0,0,0,3.69-.59ZM53.4,50.09,25.52,22.23l-.1-.11a3.17,3.17,0,0,0-.19.42s0,0,0,.05a5.72,5.72,0,0,0-.19.79,1.11,1.11,0,0,0,0,.19,6.32,6.32,0,0,0-.07.9h0V75.37A5.23,5.23,0,0,0,25.54,78ZM28.18,20.31a3,3,0,0,0-1.31.31l.22.21L54.88,48.61,63.49,40l.22-.21h0L30.82,21.08,30.7,21a4.32,4.32,0,0,0-.53-.26,2,2,0,0,0-.22-.09,3.52,3.52,0,0,0-.42-.15,1.66,1.66,0,0,0-.21-.06l-.43-.1-.16,0a4,4,0,0,0-.49,0ZM78.09,51.4a5,5,0,0,1-2.1,2l-10.38,5.9h0L76,53.43A5,5,0,0,0,78.09,51.4Zm48.63,8.38a13.47,13.47,0,0,0-.23-2.61H112.42v4.18h10a8.71,8.71,0,0,1-2.27,5.26,10.27,10.27,0,0,1-7.73,3.06,11.12,11.12,0,0,1,0-22.24,10.66,10.66,0,0,1,7.54,3l3-2.95a14.61,14.61,0,0,0-10.49-4.21,15.3,15.3,0,1,0,0,30.6,14,14,0,0,0,10.68-4.29A13.84,13.84,0,0,0,126.72,59.78Zm1.14-37.87V34.1h2.25V21.91H134V19.74H124v2.17ZM148,64a9.89,9.89,0,1,0-9.89,9.85A9.72,9.72,0,0,0,148,64Zm.38-42.09V34.1h2.25V21.91h3.88V19.74h-10v2.17ZM169.55,64a9.89,9.89,0,1,0-9.89,9.85A9.72,9.72,0,0,0,169.55,64Zm20.69-9.26h-4.1v1.61H186a6.83,6.83,0,0,0-5.19-2.21,9.86,9.86,0,0,0,0,19.71A6.74,6.74,0,0,0,186,71.61h.15V73c0,3.77-2,5.78-5.26,5.78a5.46,5.46,0,0,1-5-3.51l-3.76,1.57a9.38,9.38,0,0,0,8.73,5.82c5.07,0,9.36-3,9.36-10.26Zm7.32-10.45h-4.33v29h4.33ZM204.65,67l13.17-5.45-.45-1.12c-.82-2.2-3.32-6.27-8.43-6.27s-9.29,4-9.29,9.86a9.64,9.64,0,0,0,9.78,9.85,9.81,9.81,0,0,0,8.21-4.37l-3.36-2.24A5.64,5.64,0,0,1,209.43,70,5,5,0,0,1,204.65,67Zm42.5-13.69c0-5.53-4.71-9-9.5-9H227.3v29h4.32v-11h6C242.44,62.28,247.15,58.81,247.15,53.29Zm6.71-9h-4.32v29h4.32ZM273.27,62.1c0-5.14-3.84-8-8.79-8-3.13,0-6.38,1.38-7.72,4.43l3.84,1.61A4.09,4.09,0,0,1,264.55,58c2.24,0,4.51,1.34,4.55,3.73V62a9.56,9.56,0,0,0-4.51-1.12c-4.14,0-8.35,2.27-8.35,6.52,0,3.87,3.39,6.37,7.19,6.37A6.12,6.12,0,0,0,269,71h.15V73.2h4.17Zm20-7.38h-4.8l-5,12.56h-.15l-5.14-12.56h-4.65l7.71,17.55L276.88,82h4.51Zm-126-22.48a4.88,4.88,0,0,0,3.61-1.49,5.24,5.24,0,0,0,1.48-3.83,5.23,5.23,0,0,0-1.48-3.82,5.09,5.09,0,0,0-7.22,0,5.23,5.23,0,0,0-1.48,3.82,5.24,5.24,0,0,0,1.48,3.83A4.9,4.9,0,0,0,167.24,32.24ZM159.66,58a6,6,0,1,0,5.56,6A5.68,5.68,0,0,0,159.66,58ZM209.09,58a5.41,5.41,0,0,0-5.15,5.75L212.75,60A3.82,3.82,0,0,0,209.09,58Z'
      ]
    },
    {
      prefix: 'ncr',
      iconName: 'ncua',
      icon: [
        212, 100,
        [],
        null,
        'M 0 0 V 100 H 212.5 V 0 Z M 210.94 98.44 H 1.56 V 1.56 H 210.94 Z M 204.3 8.59 H 8.54 V 91.8 H 204.3 Z M 202 89.45 H 10.89 V 10.94 H 202 Z M 43.21 16.64 l -1.16 -2.71 h 1 l 0.59 1.73 h 0 l 0.63 -1.73 h 1 l -1.15 2.71 v 1.75 h -0.9 Z m 1.84 0.07 a 4.5 4.5 0 0 0 0.06 0.78 a 1.62 1.62 0 0 0 0.22 0.55 a 0.86 0.86 0 0 0 0.4 0.33 a 1.57 1.57 0 0 0 0.65 0.09 a 1.65 1.65 0 0 0 0.62 -0.1 a 0.94 0.94 0 0 0 0.41 -0.33 a 1.44 1.44 0 0 0 0.22 -0.55 a 3.55 3.55 0 0 0 0.07 -0.77 a 4.38 4.38 0 0 0 -0.06 -0.77 a 1.49 1.49 0 0 0 -0.21 -0.56 a 0.89 0.89 0 0 0 -0.41 -0.33 a 1.67 1.67 0 0 0 -0.64 -0.11 a 1.48 1.48 0 0 0 -0.63 0.12 a 1 1 0 0 0 -0.4 0.34 a 1.45 1.45 0 0 0 -0.23 0.55 A 3.51 3.51 0 0 0 45.05 16.71 Z m 0.88 -0.47 a 1.38 1.38 0 0 1 0.06 -0.38 a 0.48 0.48 0 0 1 0.14 -0.24 a 0.33 0.33 0 0 1 0.25 -0.09 a 0.37 0.37 0 0 1 0.36 0.28 a 2.76 2.76 0 0 1 0.1 0.9 a 2.83 2.83 0 0 1 -0.1 0.91 a 0.38 0.38 0 0 1 -0.36 0.28 a 0.33 0.33 0 0 1 -0.25 -0.09 a 0.47 0.47 0 0 1 -0.14 -0.25 a 1.3 1.3 0 0 1 -0.06 -0.37 c 0 -0.15 0 -0.31 0 -0.48 S 45.92 16.38 45.93 16.24 Z m 2.52 2 a 1 1 0 0 1 -0.22 -0.72 V 15 h 0.86 v 2.32 a 0.57 0.57 0 0 0 0.09 0.37 a 0.33 0.33 0 0 0 0.28 0.1 c 0.3 0 0.45 -0.19 0.45 -0.56 V 15 h 0.87 v 3.36 H 50 V 18 h 0 a 0.78 0.78 0 0 1 -0.36 0.36 a 1.12 1.12 0 0 1 -0.5 0.1 A 0.89 0.89 0 0 1 48.45 18.25 Z m 3.83 0.14 h -0.87 V 15 h 0.83 v 0.45 h 0 a 1.39 1.39 0 0 1 0.32 -0.39 a 0.73 0.73 0 0 1 0.46 -0.15 h 0.15 v 0.82 h -0.27 a 0.83 0.83 0 0 0 -0.22 0 a 0.81 0.81 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.15 0.19 a 0.79 0.79 0 0 0 0 0.29 Z M 55 17.85 a 1.9 1.9 0 0 1 -0.05 -0.44 v -0.12 h 0.77 v 0.12 a 0.51 0.51 0 0 0 0.12 0.35 a 0.41 0.41 0 0 0 0.33 0.14 a 0.48 0.48 0 0 0 0.32 -0.11 a 0.35 0.35 0 0 0 0.12 -0.3 a 0.31 0.31 0 0 0 -0.09 -0.24 a 1 1 0 0 0 -0.22 -0.14 l -0.61 -0.21 a 1.22 1.22 0 0 1 -0.54 -0.36 A 0.91 0.91 0 0 1 55 16 a 1 1 0 0 1 0.07 -0.39 a 0.91 0.91 0 0 1 0.22 -0.33 a 1.07 1.07 0 0 1 0.38 -0.21 a 1.62 1.62 0 0 1 0.57 -0.09 a 1.33 1.33 0 0 1 0.87 0.25 a 0.91 0.91 0 0 1 0.28 0.71 V 16 h -0.78 a 0.69 0.69 0 0 0 -0.08 -0.39 a 0.35 0.35 0 0 0 -0.3 -0.12 a 0.45 0.45 0 0 0 -0.28 0.09 a 0.32 0.32 0 0 0 -0.12 0.28 a 0.36 0.36 0 0 0 0.07 0.22 a 0.7 0.7 0 0 0 0.3 0.17 l 0.52 0.17 a 1.38 1.38 0 0 1 0.58 0.36 a 1 1 0 0 1 0.16 0.61 a 1.08 1.08 0 0 1 -0.09 0.46 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.19 a 2.67 2.67 0 0 1 -0.51 0.05 a 2.06 2.06 0 0 1 -0.6 -0.07 a 0.81 0.81 0 0 1 -0.38 -0.2 A 0.77 0.77 0 0 1 55 17.85 Z m 3 0.32 a 0.67 0.67 0 0 0 0.25 0.22 a 0.86 0.86 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.77 0.77 0 0 0 0.34 -0.35 h 0 a 1.16 1.16 0 0 0 0 0.18 a 0.49 0.49 0 0 0 0.06 0.17 h 0.83 a 1.8 1.8 0 0 1 -0.09 -0.28 a 3.12 3.12 0 0 1 0 -0.37 V 16 a 1.42 1.42 0 0 0 -0.05 -0.42 a 0.74 0.74 0 0 0 -0.17 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.15 2.15 0 0 0 -0.63 -0.08 a 1.76 1.76 0 0 0 -0.46 0.06 a 0.9 0.9 0 0 0 -0.37 0.17 a 0.92 0.92 0 0 0 -0.26 0.32 A 1.19 1.19 0 0 0 58 16 v 0.08 h 0.78 V 16 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.35 0.35 0 0 1 0.3 -0.12 a 0.4 0.4 0 0 1 0.31 0.11 a 0.47 0.47 0 0 1 0.09 0.3 a 0.38 0.38 0 0 1 -0.08 0.26 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.48 0.13 a 2.49 2.49 0 0 0 -0.39 0.14 a 0.92 0.92 0 0 0 -0.26 0.21 a 0.73 0.73 0 0 0 -0.15 0.29 a 1.28 1.28 0 0 0 0 0.41 a 1.32 1.32 0 0 0 0 0.34 A 0.8 0.8 0 0 0 58 18.17 Z m 0.75 -1.1 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.52 0.52 0 0 0 0.19 -0.11 v 0.67 a 0.52 0.52 0 0 1 -0.05 0.23 a 0.76 0.76 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 l -0.18 0 a 0.28 0.28 0 0 1 -0.26 -0.14 a 0.81 0.81 0 0 1 -0.07 -0.33 A 0.57 0.57 0 0 1 58.78 17.07 Z m 2.86 1.32 L 60.77 15 h 0.9 l 0.48 2.41 h 0 L 62.62 15 h 0.86 l -0.84 3.36 Z m 3.12 -3.77 h -0.87 v -0.74 h 0.87 Z m 0 3.77 h -0.87 V 15 h 0.87 Z m 1.53 0 h -0.86 V 15 h 0.82 v 0.4 h 0 a 0.92 0.92 0 0 1 0.36 -0.37 a 1 1 0 0 1 0.5 -0.12 a 0.84 0.84 0 0 1 0.63 0.23 a 1 1 0 0 1 0.23 0.73 v 2.49 h -0.87 V 16.08 a 0.65 0.65 0 0 0 -0.08 -0.37 a 0.37 0.37 0 0 0 -0.29 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 Z m 3.29 0 a 0.71 0.71 0 0 0 0.39 -0.12 a 0.84 0.84 0 0 0 0.32 -0.3 h 0 v 0.45 a 0.79 0.79 0 0 1 -0.11 0.42 a 0.46 0.46 0 0 1 -0.52 0.14 l -0.14 -0.07 a 0.31 0.31 0 0 1 -0.13 -0.25 h -0.82 a 0.79 0.79 0 0 0 0.3 0.66 a 1.29 1.29 0 0 0 0.84 0.24 a 1.45 1.45 0 0 0 1.08 -0.33 a 1.31 1.31 0 0 0 0.32 -1 V 15 h -0.82 v 0.38 h 0 A 0.73 0.73 0 0 0 70 15 a 0.94 0.94 0 0 0 -0.38 -0.1 a 1 1 0 0 0 -0.56 0.16 a 1.13 1.13 0 0 0 -0.32 0.4 a 1.92 1.92 0 0 0 -0.14 0.56 c 0 0.2 0 0.4 0 0.6 A 2.5 2.5 0 0 0 68.8 18 A 0.88 0.88 0 0 0 69.58 18.36 Z m -0.16 -2.11 a 1.62 1.62 0 0 1 0.07 -0.38 a 0.38 0.38 0 0 1 0.14 -0.2 a 0.37 0.37 0 0 1 0.23 -0.06 a 0.34 0.34 0 0 1 0.35 0.25 a 2.55 2.55 0 0 1 0.1 0.87 c 0 0.14 0 0.27 0 0.39 a 1.27 1.27 0 0 1 -0.08 0.31 a 0.4 0.4 0 0 1 -0.14 0.19 a 0.35 0.35 0 0 1 -0.23 0.07 a 0.31 0.31 0 0 1 -0.22 -0.07 a 0.38 0.38 0 0 1 -0.13 -0.19 a 0.77 0.77 0 0 1 -0.07 -0.28 c 0 -0.1 0 -0.21 0 -0.33 S 69.41 16.4 69.42 16.25 Z m 2.29 1.6 a 1.9 1.9 0 0 1 0 -0.44 v -0.12 h 0.77 v 0.12 a 0.51 0.51 0 0 0 0.12 0.35 a 0.41 0.41 0 0 0 0.33 0.14 a 0.46 0.46 0 0 0 0.32 -0.11 a 0.35 0.35 0 0 0 0.12 -0.3 a 0.31 0.31 0 0 0 -0.09 -0.24 a 1 1 0 0 0 -0.22 -0.14 l -0.61 -0.21 a 1.22 1.22 0 0 1 -0.54 -0.36 a 0.91 0.91 0 0 1 -0.18 -0.58 a 1.23 1.23 0 0 1 0.07 -0.39 a 0.91 0.91 0 0 1 0.22 -0.33 a 1.07 1.07 0 0 1 0.38 -0.21 a 1.62 1.62 0 0 1 0.57 -0.09 a 1.33 1.33 0 0 1 0.87 0.25 a 0.91 0.91 0 0 1 0.28 0.71 V 16 h -0.78 a 0.69 0.69 0 0 0 -0.08 -0.39 a 0.34 0.34 0 0 0 -0.3 -0.12 a 0.47 0.47 0 0 0 -0.28 0.09 a 0.32 0.32 0 0 0 -0.12 0.28 a 0.32 0.32 0 0 0 0.08 0.22 a 0.6 0.6 0 0 0 0.29 0.17 l 0.52 0.17 a 1.38 1.38 0 0 1 0.58 0.36 a 1 1 0 0 1 0.16 0.61 a 1.08 1.08 0 0 1 -0.09 0.46 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.19 a 2.59 2.59 0 0 1 -0.51 0.05 a 2.06 2.06 0 0 1 -0.6 -0.07 a 0.81 0.81 0 0 1 -0.38 -0.2 A 0.77 0.77 0 0 1 71.71 17.85 Z m 4.68 -2.23 H 76 V 15 h 0.44 v -0.38 a 1 1 0 0 1 0.06 -0.38 a 0.58 0.58 0 0 1 0.18 -0.25 a 0.66 0.66 0 0 1 0.28 -0.13 a 1.52 1.52 0 0 1 0.38 -0.05 l 0.46 0 v 0.62 h -0.17 a 0.4 0.4 0 0 0 -0.25 0.06 a 0.26 0.26 0 0 0 -0.08 0.21 V 15 h 0.5 v 0.59 h -0.5 v 2.77 h -0.86 Z m 1.78 2.28 a 1 1 0 0 0 0.39 0.41 a 1.47 1.47 0 0 0 0.73 0.15 a 1.19 1.19 0 0 0 0.9 -0.3 a 1.34 1.34 0 0 0 0.32 -0.9 h -0.78 a 1.05 1.05 0 0 1 -0.14 0.48 a 0.35 0.35 0 0 1 -0.31 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.44 0.44 0 0 1 -0.14 -0.18 a 1.26 1.26 0 0 1 -0.07 -0.25 a 2.64 2.64 0 0 1 0 -0.29 v -0.27 h 1.71 v -0.19 a 4.9 4.9 0 0 0 0 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.35 1.35 0 0 0 -0.61 -0.13 a 1.37 1.37 0 0 0 -0.7 0.15 a 1 1 0 0 0 -0.41 0.39 A 1.55 1.55 0 0 0 78 16 a 3.49 3.49 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.84 1.84 0 0 0 78.17 17.9 Z m 0.68 -1.7 a 1.94 1.94 0 0 1 0 -0.24 a 1 1 0 0 1 0.07 -0.21 a 0.44 0.44 0 0 1 0.14 -0.16 a 0.37 0.37 0 0 1 0.21 -0.06 a 0.38 0.38 0 0 1 0.22 0.06 a 0.28 0.28 0 0 1 0.13 0.15 a 1.26 1.26 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z M 82 18.46 a 1 1 0 0 0 0.44 -0.09 a 0.78 0.78 0 0 0 0.32 -0.33 h 0 v 0.35 h 0.83 V 13.93 h -0.86 v 1.41 h 0 a 1 1 0 0 0 -0.31 -0.3 a 0.86 0.86 0 0 0 -0.41 -0.1 a 0.84 0.84 0 0 0 -0.78 0.42 A 2.71 2.71 0 0 0 81 16.71 a 2.66 2.66 0 0 0 0.25 1.35 A 0.84 0.84 0 0 0 82 18.46 Z m -0.08 -2.57 a 0.34 0.34 0 0 1 0.36 -0.28 a 0.35 0.35 0 0 1 0.37 0.28 a 2.81 2.81 0 0 1 0.09 0.82 a 2.84 2.84 0 0 1 -0.09 0.83 a 0.35 0.35 0 0 1 -0.37 0.28 a 0.34 0.34 0 0 1 -0.36 -0.28 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 81.94 15.89 Z m 2.37 2 a 1.09 1.09 0 0 0 0.39 0.41 a 1.5 1.5 0 0 0 0.73 0.15 a 1.22 1.22 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.77 a 1.38 1.38 0 0 1 -0.14 0.48 a 0.36 0.36 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.42 0.42 0 0 1 -0.13 -0.18 A 0.61 0.61 0 0 1 85 17.4 a 1.36 1.36 0 0 1 0 -0.29 v -0.27 H 86.7 v -0.19 a 4.9 4.9 0 0 0 0 -0.7 a 1.44 1.44 0 0 0 -0.19 -0.54 a 0.87 0.87 0 0 0 -0.37 -0.34 a 1.42 1.42 0 0 0 -0.62 -0.13 a 1.4 1.4 0 0 0 -0.7 0.15 a 0.89 0.89 0 0 0 -0.4 0.39 a 1.38 1.38 0 0 0 -0.19 0.55 a 4.62 4.62 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.84 1.84 0 0 0 84.31 17.9 Z M 85 16.2 A 1 1 0 0 1 85 16 a 0.48 0.48 0 0 1 0.07 -0.21 a 0.42 0.42 0 0 1 0.13 -0.16 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.33 0.33 0 0 1 0.21 0.06 a 0.34 0.34 0 0 1 0.14 0.15 a 0.83 0.83 0 0 1 0.06 0.25 c 0 0.1 0 0.21 0 0.34 H 85 Z m 3.09 2.19 h -0.87 V 15 H 88 v 0.45 h 0 a 1.24 1.24 0 0 1 0.32 -0.39 a 0.71 0.71 0 0 1 0.46 -0.15 H 89 v 0.82 h -0.27 a 0.83 0.83 0 0 0 -0.22 0 a 0.68 0.68 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.15 0.19 a 0.63 0.63 0 0 0 0 0.29 Z m 1.35 -0.22 a 0.67 0.67 0 0 0 0.25 0.22 a 0.86 0.86 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.77 0.77 0 0 0 0.34 -0.35 h 0 a 1.16 1.16 0 0 0 0 0.18 a 0.49 0.49 0 0 0 0.06 0.17 h 0.83 a 1.8 1.8 0 0 1 -0.09 -0.28 a 3.12 3.12 0 0 1 0 -0.37 V 16 a 1.42 1.42 0 0 0 0 -0.42 a 0.74 0.74 0 0 0 -0.17 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.15 2.15 0 0 0 -0.63 -0.08 a 1.76 1.76 0 0 0 -0.46 0.06 a 0.9 0.9 0 0 0 -0.37 0.17 a 0.92 0.92 0 0 0 -0.26 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.78 V 16 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.35 0.35 0 0 1 0.3 -0.12 a 0.42 0.42 0 0 1 0.31 0.11 a 0.47 0.47 0 0 1 0.09 0.3 a 0.38 0.38 0 0 1 -0.08 0.26 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2.35 2.35 0 0 0 -0.38 0.14 a 0.92 0.92 0 0 0 -0.26 0.21 a 0.9 0.9 0 0 0 -0.16 0.29 a 1.64 1.64 0 0 0 -0.05 0.41 a 1.33 1.33 0 0 0 0.05 0.34 A 0.8 0.8 0 0 0 89.43 18.17 Z m 0.75 -1.1 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.62 0.62 0 0 0 0.19 -0.11 v 0.67 a 0.52 0.52 0 0 1 -0.05 0.23 a 0.76 0.76 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 l -0.19 0 a 0.27 0.27 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 A 0.57 0.57 0 0 1 90.18 17.07 Z m 3.14 1.32 h -0.86 V 13.93 h 0.86 Z m 1.56 0 H 94 V 13.93 h 0.86 Z m 1.36 0 L 95.29 15 h 0.9 l 0.5 2.33 h 0 L 97.14 15 H 98 l -0.82 3.14 a 5.14 5.14 0 0 1 -0.21 0.68 a 1.37 1.37 0 0 1 -0.24 0.4 a 0.75 0.75 0 0 1 -0.34 0.18 a 2.27 2.27 0 0 1 -0.5 0.05 h -0.35 v -0.65 l 0.23 0 a 0.44 0.44 0 0 0 0.34 -0.12 A 0.6 0.6 0 0 0 96.24 18.39 Z m 4.6 0 H 100 V 15 h 0.86 Z m 0 -3.77 H 100 v -0.74 h 0.86 Z m 1.54 3.77 h -0.87 V 15 h 0.83 v 0.4 h 0 a 0.86 0.86 0 0 1 0.36 -0.37 a 1 1 0 0 1 0.5 -0.12 a 0.85 0.85 0 0 1 0.63 0.23 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 16.08 a 0.57 0.57 0 0 0 -0.09 -0.37 a 0.34 0.34 0 0 0 -0.28 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 Z m 2.23 -0.54 a 1.9 1.9 0 0 1 0 -0.44 v -0.12 h 0.77 v 0.12 a 0.51 0.51 0 0 0 0.12 0.35 a 0.41 0.41 0 0 0 0.33 0.14 a 0.46 0.46 0 0 0 0.32 -0.11 a 0.35 0.35 0 0 0 0.12 -0.3 a 0.31 0.31 0 0 0 -0.09 -0.24 a 1 1 0 0 0 -0.22 -0.14 l -0.61 -0.21 a 1.22 1.22 0 0 1 -0.54 -0.36 a 0.91 0.91 0 0 1 -0.18 -0.58 a 1 1 0 0 1 0.07 -0.39 a 0.91 0.91 0 0 1 0.22 -0.33 a 1.07 1.07 0 0 1 0.38 -0.21 a 1.62 1.62 0 0 1 0.57 -0.09 a 1.33 1.33 0 0 1 0.87 0.25 a 0.91 0.91 0 0 1 0.28 0.71 V 16 h -0.78 a 0.69 0.69 0 0 0 -0.08 -0.39 a 0.35 0.35 0 0 0 -0.3 -0.12 a 0.45 0.45 0 0 0 -0.28 0.09 a 0.32 0.32 0 0 0 -0.12 0.28 a 0.36 0.36 0 0 0 0.07 0.22 a 0.7 0.7 0 0 0 0.3 0.17 l 0.52 0.17 a 1.38 1.38 0 0 1 0.58 0.36 a 1 1 0 0 1 0.16 0.61 a 1.08 1.08 0 0 1 -0.09 0.46 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.19 a 2.59 2.59 0 0 1 -0.51 0.05 a 2.06 2.06 0 0 1 -0.6 -0.07 a 0.81 0.81 0 0 1 -0.38 -0.2 A 0.77 0.77 0 0 1 104.61 17.85 Z m 3.15 0.4 a 1 1 0 0 1 -0.22 -0.72 V 15 h 0.86 v 2.32 a 0.57 0.57 0 0 0 0.09 0.37 a 0.34 0.34 0 0 0 0.28 0.1 c 0.3 0 0.46 -0.19 0.46 -0.56 V 15 h 0.86 v 3.36 h -0.83 V 18 h 0 a 0.78 0.78 0 0 1 -0.36 0.36 a 1.12 1.12 0 0 1 -0.5 0.1 A 0.89 0.89 0 0 1 107.76 18.25 Z m 3.83 0.14 h -0.86 V 15 h 0.82 v 0.45 h 0 a 1.39 1.39 0 0 1 0.32 -0.39 a 0.73 0.73 0 0 1 0.46 -0.15 h 0.15 v 0.82 h -0.26 a 0.91 0.91 0 0 0 -0.23 0 a 1 1 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.15 0.19 a 0.79 0.79 0 0 0 0 0.29 Z m 1.34 -0.49 a 1 1 0 0 0 0.38 0.41 a 1.5 1.5 0 0 0 0.73 0.15 a 1.2 1.2 0 0 0 0.91 -0.3 a 1.33 1.33 0 0 0 0.31 -0.9 h -0.77 a 1.19 1.19 0 0 1 -0.14 0.48 a 0.36 0.36 0 0 1 -0.32 0.16 a 0.35 0.35 0 0 1 -0.2 -0.07 a 0.42 0.42 0 0 1 -0.13 -0.18 a 0.82 0.82 0 0 1 -0.07 -0.25 a 1.37 1.37 0 0 1 0 -0.29 v -0.27 h 1.7 v -0.19 a 3.78 3.78 0 0 0 0 -0.7 a 1.43 1.43 0 0 0 -0.18 -0.54 a 1 1 0 0 0 -0.38 -0.34 a 1.39 1.39 0 0 0 -0.62 -0.13 a 1.43 1.43 0 0 0 -0.7 0.15 a 0.94 0.94 0 0 0 -0.4 0.39 a 1.56 1.56 0 0 0 -0.19 0.55 a 4.62 4.62 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.61 1.61 0 0 0 112.93 17.9 Z m 0.68 -1.7 a 1 1 0 0 1 0 -0.24 a 0.65 0.65 0 0 1 0.07 -0.21 a 0.42 0.42 0 0 1 0.13 -0.16 a 0.43 0.43 0 0 1 0.44 0 a 0.32 0.32 0 0 1 0.13 0.15 a 0.83 0.83 0 0 1 0.06 0.25 a 3.07 3.07 0 0 1 0 0.34 h -0.88 Z m 3.17 2.26 a 1 1 0 0 0 0.44 -0.09 a 0.92 0.92 0 0 0 0.32 -0.33 h 0 v 0.35 h 0.83 V 13.93 h -0.87 v 1.41 h 0 a 1 1 0 0 0 -0.31 -0.3 a 0.93 0.93 0 0 0 -1.2 0.32 a 2.83 2.83 0 0 0 -0.25 1.35 a 2.77 2.77 0 0 0 0.25 1.35 A 0.86 0.86 0 0 0 116.78 18.46 Z m -0.09 -2.57 a 0.38 0.38 0 0 1 0.74 0 a 3.29 3.29 0 0 1 0.08 0.82 a 3.33 3.33 0 0 1 -0.08 0.83 a 0.38 0.38 0 0 1 -0.74 0 a 2.91 2.91 0 0 1 -0.08 -0.83 A 2.87 2.87 0 0 1 116.69 15.89 Z m 4.07 -0.27 h -0.43 V 15 h 0.43 v -1 h 0.87 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.6 0.6 0 0 0 0.05 0.28 a 0.29 0.29 0 0 0 0.25 0.09 h 0.2 v 0.6 h -0.57 a 2.37 2.37 0 0 1 -0.41 0 a 0.42 0.42 0 0 1 -0.24 -0.14 a 0.67 0.67 0 0 1 -0.12 -0.27 a 2.46 2.46 0 0 1 0 -0.43 Z M 122.65 18 a 0.89 0.89 0 0 0 0.41 0.33 a 1.52 1.52 0 0 0 0.64 0.09 a 1.61 1.61 0 0 0 0.62 -0.1 a 0.89 0.89 0 0 0 0.41 -0.33 a 1.45 1.45 0 0 0 0.23 -0.55 a 4.27 4.27 0 0 0 0 -1.54 a 1.49 1.49 0 0 0 -0.21 -0.56 a 0.89 0.89 0 0 0 -0.41 -0.33 a 1.67 1.67 0 0 0 -0.64 -0.11 a 1.43 1.43 0 0 0 -0.62 0.12 a 1 1 0 0 0 -0.41 0.34 a 1.45 1.45 0 0 0 -0.23 0.55 a 4.34 4.34 0 0 0 -0.06 0.76 a 4.5 4.5 0 0 0 0.06 0.78 A 1.44 1.44 0 0 0 122.65 18 Z m 0.6 -1.8 a 1.89 1.89 0 0 1 0.06 -0.38 a 0.57 0.57 0 0 1 0.14 -0.24 a 0.38 0.38 0 0 1 0.61 0.19 a 2.76 2.76 0 0 1 0.1 0.9 a 2.83 2.83 0 0 1 -0.1 0.91 a 0.36 0.36 0 0 1 -0.36 0.28 a 0.35 0.35 0 0 1 -0.25 -0.09 a 0.55 0.55 0 0 1 -0.14 -0.25 a 1.79 1.79 0 0 1 -0.06 -0.37 c 0 -0.15 0 -0.31 0 -0.48 S 123.24 16.38 123.25 16.24 Z m 3.93 1.93 a 0.76 0.76 0 0 0 0.25 0.22 a 0.89 0.89 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.78 0.78 0 0 0 0.35 -0.35 h 0 c 0 0.06 0 0.12 0 0.18 a 0.87 0.87 0 0 0 0.07 0.17 h 0.82 a 1.09 1.09 0 0 1 -0.08 -0.28 a 1.84 1.84 0 0 1 0 -0.37 V 16 a 1.86 1.86 0 0 0 0 -0.42 a 0.67 0.67 0 0 0 -0.18 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.07 2.07 0 0 0 -0.62 -0.08 a 1.7 1.7 0 0 0 -0.46 0.06 a 0.94 0.94 0 0 0 -0.38 0.17 a 0.89 0.89 0 0 0 -0.25 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 16 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.39 0.39 0 0 1 0.31 0.11 a 0.47 0.47 0 0 1 0.09 0.3 a 0.38 0.38 0 0 1 -0.07 0.26 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2 2 0 0 0 -0.38 0.14 a 1 1 0 0 0 -0.27 0.21 a 0.73 0.73 0 0 0 -0.15 0.29 a 1.64 1.64 0 0 0 0 0.41 a 1.32 1.32 0 0 0 0 0.34 A 1 1 0 0 0 127.18 18.17 Z m 0.76 -1.1 a 0.65 0.65 0 0 1 0.37 -0.19 a 0.64 0.64 0 0 0 0.18 -0.06 a 0.52 0.52 0 0 0 0.19 -0.11 v 0.67 a 0.52 0.52 0 0 1 -0.05 0.23 a 0.43 0.43 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.08 -0.33 A 0.52 0.52 0 0 1 127.94 17.07 Z m 2.43 -1.45 h -0.44 V 15 h 0.44 v -1 h 0.86 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.29 2.29 0 0 1 -0.41 0 a 0.36 0.36 0 0 1 -0.24 -0.14 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.46 2.46 0 0 1 0 -0.43 Z m 4.18 2.77 h -0.86 V 13.93 h 0.86 Z m 0.72 -0.49 a 1.09 1.09 0 0 0 0.39 0.41 a 1.5 1.5 0 0 0 0.73 0.15 a 1.2 1.2 0 0 0 0.91 -0.3 a 1.33 1.33 0 0 0 0.31 -0.9 h -0.77 a 1.19 1.19 0 0 1 -0.14 0.48 a 0.36 0.36 0 0 1 -0.32 0.16 a 0.35 0.35 0 0 1 -0.2 -0.07 a 0.42 0.42 0 0 1 -0.13 -0.18 a 0.82 0.82 0 0 1 -0.07 -0.25 a 1.37 1.37 0 0 1 0 -0.29 v -0.27 h 1.7 v -0.19 a 3.78 3.78 0 0 0 0 -0.7 a 1.28 1.28 0 0 0 -0.19 -0.54 a 0.87 0.87 0 0 0 -0.37 -0.34 a 1.39 1.39 0 0 0 -0.62 -0.13 a 1.43 1.43 0 0 0 -0.7 0.15 a 0.94 0.94 0 0 0 -0.4 0.39 a 1.38 1.38 0 0 0 -0.19 0.55 a 4.62 4.62 0 0 0 0 0.65 c 0 0.22 0 0.43 0 0.64 A 1.84 1.84 0 0 0 135.27 17.9 Z m 0.69 -1.7 a 1 1 0 0 1 0 -0.24 a 0.65 0.65 0 0 1 0.07 -0.21 a 0.42 0.42 0 0 1 0.13 -0.16 a 0.43 0.43 0 0 1 0.44 0 a 0.32 0.32 0 0 1 0.13 0.15 a 0.83 0.83 0 0 1 0.06 0.25 c 0 0.1 0 0.21 0 0.34 H 136 Z m 2.28 2 a 0.68 0.68 0 0 0 0.63 0.29 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.74 0.74 0 0 0 0.35 -0.35 h 0 a 1.16 1.16 0 0 1 0 0.18 a 0.87 0.87 0 0 0 0.07 0.17 h 0.82 a 1.09 1.09 0 0 1 -0.08 -0.28 a 3.12 3.12 0 0 1 0 -0.37 V 16 a 1.86 1.86 0 0 0 0 -0.42 a 0.67 0.67 0 0 0 -0.18 -0.33 A 0.82 0.82 0 0 0 140 15 a 2 2 0 0 0 -0.62 -0.08 a 1.7 1.7 0 0 0 -0.46 0.06 a 0.9 0.9 0 0 0 -0.37 0.17 a 0.82 0.82 0 0 0 -0.26 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 16 a 0.53 0.53 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.39 0.39 0 0 1 0.31 0.11 a 0.47 0.47 0 0 1 0.09 0.3 a 0.38 0.38 0 0 1 -0.07 0.26 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2 2 0 0 0 -0.38 0.14 a 0.8 0.8 0 0 0 -0.26 0.21 a 0.9 0.9 0 0 0 -0.16 0.29 a 1.64 1.64 0 0 0 -0.05 0.41 a 1.33 1.33 0 0 0 0.05 0.34 A 1 1 0 0 0 138.24 18.17 Z m 0.76 -1.1 a 0.65 0.65 0 0 1 0.37 -0.19 l 0.19 -0.06 a 0.49 0.49 0 0 0 0.18 -0.11 v 0.67 a 0.41 0.41 0 0 1 -0.05 0.23 a 0.52 0.52 0 0 1 -0.12 0.17 a 0.61 0.61 0 0 1 -0.18 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.27 0.27 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 A 0.52 0.52 0 0 1 139 17.07 Z m 2.16 0.78 a 1.46 1.46 0 0 1 -0.06 -0.44 v -0.12 h 0.77 v 0.12 a 0.51 0.51 0 0 0 0.12 0.35 a 0.42 0.42 0 0 0 0.33 0.14 a 0.46 0.46 0 0 0 0.32 -0.11 a 0.35 0.35 0 0 0 0.12 -0.3 a 0.31 0.31 0 0 0 -0.09 -0.24 a 0.83 0.83 0 0 0 -0.22 -0.14 l -0.61 -0.21 a 1.24 1.24 0 0 1 -0.53 -0.36 a 0.92 0.92 0 0 1 -0.19 -0.58 a 1.23 1.23 0 0 1 0.07 -0.39 a 0.91 0.91 0 0 1 0.22 -0.33 a 1 1 0 0 1 0.39 -0.21 a 1.53 1.53 0 0 1 0.56 -0.09 a 1.33 1.33 0 0 1 0.87 0.25 a 0.91 0.91 0 0 1 0.28 0.71 V 16 h -0.77 a 0.68 0.68 0 0 0 -0.09 -0.39 a 0.32 0.32 0 0 0 -0.29 -0.12 a 0.48 0.48 0 0 0 -0.29 0.09 a 0.32 0.32 0 0 0 -0.12 0.28 a 0.37 0.37 0 0 0 0.08 0.22 a 0.6 0.6 0 0 0 0.29 0.17 l 0.52 0.17 a 1.31 1.31 0 0 1 0.58 0.36 a 1 1 0 0 1 0.17 0.61 a 1 1 0 0 1 -0.1 0.46 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.19 a 2.57 2.57 0 0 1 -0.5 0.05 a 2.13 2.13 0 0 1 -0.61 -0.07 a 0.86 0.86 0 0 1 -0.38 -0.2 A 0.67 0.67 0 0 1 141.16 17.85 Z m 3.11 -2.23 h -0.44 V 15 h 0.44 v -1 h 0.86 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.22 2.22 0 0 1 -0.41 0 a 0.41 0.41 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.46 2.46 0 0 1 0 -0.43 Z m 3.28 2.43 a 0.89 0.89 0 0 0 0.37 0.28 a 2 2 0 0 0 0.63 0.13 V 19 h 0.4 v -0.55 a 1.49 1.49 0 0 0 0.94 -0.34 a 1.31 1.31 0 0 0 0.32 -1 a 1.84 1.84 0 0 0 -0.05 -0.44 a 1 1 0 0 0 -0.16 -0.31 a 1 1 0 0 0 -0.24 -0.21 a 2.4 2.4 0 0 0 -0.32 -0.17 l -0.49 -0.2 V 14.63 a 0.35 0.35 0 0 1 0.22 0.21 a 1 1 0 0 1 0.07 0.4 h 0.87 v -0.09 a 1.92 1.92 0 0 0 -0.05 -0.41 a 1 1 0 0 0 -0.19 -0.36 a 0.89 0.89 0 0 0 -0.35 -0.27 A 1.7 1.7 0 0 0 149 14 v -0.43 h -0.4 V 14 a 1.38 1.38 0 0 0 -0.87 0.38 a 1.24 1.24 0 0 0 -0.3 0.89 a 1.34 1.34 0 0 0 0.2 0.74 a 1.19 1.19 0 0 0 0.66 0.46 l 0.31 0.12 v 1.26 a 0.54 0.54 0 0 1 -0.2 -0.1 a 0.54 0.54 0 0 1 -0.11 -0.18 a 0.72 0.72 0 0 1 0 -0.22 a 2 2 0 0 1 0 -0.25 h -0.87 v 0.13 a 2.24 2.24 0 0 0 0.05 0.46 A 0.88 0.88 0 0 0 147.55 18.05 Z m 1.4 -1.34 a 0.78 0.78 0 0 1 0.27 0.23 a 0.71 0.71 0 0 1 0.09 0.38 a 0.69 0.69 0 0 1 -0.08 0.32 a 0.43 0.43 0 0 1 -0.28 0.18 Z m -0.71 -1.6 a 0.43 0.43 0 0 1 0.31 -0.48 v 1 A 0.55 0.55 0 0 1 148.24 15.11 Z m 4 0.3 a 2.81 2.81 0 0 0 0 -0.3 c 0 -0.37 -0.14 -0.55 -0.43 -0.55 a 0.41 0.41 0 0 0 -0.27 0.07 a 0.45 0.45 0 0 0 -0.15 0.18 a 0.77 0.77 0 0 0 -0.07 0.28 c 0 0.1 0 0.21 0 0.33 h -0.87 v -0.17 a 1.29 1.29 0 0 1 0.33 -0.95 a 1.45 1.45 0 0 1 1 -0.33 a 1.39 1.39 0 0 1 1 0.31 a 1.22 1.22 0 0 1 0.32 0.9 a 2.38 2.38 0 0 1 0 0.39 a 2.17 2.17 0 0 1 -0.12 0.36 a 1.66 1.66 0 0 1 -0.22 0.32 a 2.34 2.34 0 0 1 -0.31 0.33 L 152 17 a 2 2 0 0 0 -0.32 0.36 a 1.07 1.07 0 0 0 -0.14 0.29 h 1.67 v 0.7 h -2.73 a 2.51 2.51 0 0 1 0.06 -0.55 a 2 2 0 0 1 0.18 -0.48 a 3.37 3.37 0 0 1 0.31 -0.46 a 5.83 5.83 0 0 1 0.43 -0.44 l 0.36 -0.34 l 0.24 -0.24 a 1 1 0 0 0 0.14 -0.23 A 0.67 0.67 0 0 0 152.23 15.41 Z m 1.32 2.24 a 1.87 1.87 0 0 1 0 -0.4 v -0.12 h 0.86 a 1.93 1.93 0 0 0 0 0.24 a 0.86 0.86 0 0 0 0.06 0.23 a 0.53 0.53 0 0 0 0.13 0.19 a 0.43 0.43 0 0 0 0.24 0.07 a 0.42 0.42 0 0 0 0.4 -0.22 a 1.36 1.36 0 0 0 0.12 -0.65 c 0 -0.18 0 -0.33 0 -0.45 a 0.9 0.9 0 0 0 -0.09 -0.29 a 0.33 0.33 0 0 0 -0.16 -0.15 a 0.6 0.6 0 0 0 -0.25 0 a 0.37 0.37 0 0 0 -0.3 0.11 a 0.51 0.51 0 0 0 -0.12 0.29 h -0.81 l 0.16 -2.4 h 2.31 v 0.7 h -1.63 l -0.1 1 h 0 a 0.72 0.72 0 0 1 0.32 -0.25 a 1.4 1.4 0 0 1 0.49 -0.08 a 1.07 1.07 0 0 1 0.53 0.12 a 1 1 0 0 1 0.33 0.33 a 1.28 1.28 0 0 1 0.17 0.45 a 2.94 2.94 0 0 1 0 0.51 a 3.4 3.4 0 0 1 -0.06 0.67 A 1.36 1.36 0 0 1 156 18 a 1 1 0 0 1 -0.44 0.32 a 1.74 1.74 0 0 1 -0.7 0.11 a 1.67 1.67 0 0 1 -0.68 -0.11 a 0.85 0.85 0 0 1 -0.39 -0.3 A 1 1 0 0 1 153.55 17.65 Z m 3.31 0.34 a 0.82 0.82 0 0 0 0.43 0.37 a 1.86 1.86 0 0 0 0.67 0.1 a 1.44 1.44 0 0 0 0.77 -0.18 a 1.18 1.18 0 0 0 0.41 -0.52 a 2.43 2.43 0 0 0 0.17 -0.75 c 0 -0.29 0 -0.58 0 -0.89 a 7.15 7.15 0 0 0 -0.06 -1 a 1.82 1.82 0 0 0 -0.23 -0.66 a 0.88 0.88 0 0 0 -0.42 -0.37 A 1.64 1.64 0 0 0 158 14 a 1.36 1.36 0 0 0 -0.78 0.2 a 1.18 1.18 0 0 0 -0.41 0.52 a 2.43 2.43 0 0 0 -0.17 0.75 c 0 0.29 0 0.58 0 0.89 a 7.05 7.05 0 0 0 0.06 1 A 1.82 1.82 0 0 0 156.86 18 Z m 0.61 -1.95 c 0 -0.28 0 -0.52 0 -0.71 a 2.36 2.36 0 0 1 0.07 -0.46 a 0.55 0.55 0 0 1 0.15 -0.24 a 0.39 0.39 0 0 1 0.25 -0.07 a 0.52 0.52 0 0 1 0.23 0 a 0.34 0.34 0 0 1 0.15 0.21 a 1.42 1.42 0 0 1 0.08 0.42 a 6.86 6.86 0 0 1 0 0.69 v 0.48 c 0 0.28 0 0.52 0 0.71 a 2.36 2.36 0 0 1 -0.07 0.46 a 0.5 0.5 0 0 1 -0.15 0.24 a 0.36 0.36 0 0 1 -0.24 0.08 a 0.43 0.43 0 0 1 -0.24 -0.06 a 0.44 0.44 0 0 1 -0.15 -0.21 a 1.36 1.36 0 0 1 -0.08 -0.42 c 0 -0.18 0 -0.4 0 -0.68 Z m 2.79 3.25 a 1 1 0 0 1 -0.4 0.12 V 19 a 0.36 0.36 0 0 0 0.24 -0.18 a 0.65 0.65 0 0 0 0.08 -0.31 v -0.09 h -0.32 v -1 h 0.82 v 0.81 a 3 3 0 0 1 0 0.44 a 1.35 1.35 0 0 1 -0.13 0.37 A 0.78 0.78 0 0 1 160.26 19.29 Z m 1.22 -1.3 a 0.85 0.85 0 0 0 0.43 0.37 a 1.86 1.86 0 0 0 0.67 0.1 a 1.39 1.39 0 0 0 0.77 -0.18 a 1.13 1.13 0 0 0 0.42 -0.52 a 2.43 2.43 0 0 0 0.17 -0.75 c 0 -0.29 0 -0.58 0 -0.89 a 5.79 5.79 0 0 0 -0.07 -1 a 1.83 1.83 0 0 0 -0.22 -0.66 a 0.91 0.91 0 0 0 -0.43 -0.37 a 1.64 1.64 0 0 0 -0.67 -0.12 a 1.31 1.31 0 0 0 -0.77 0.2 a 1.13 1.13 0 0 0 -0.42 0.52 a 2.43 2.43 0 0 0 -0.17 0.75 c 0 0.29 0 0.58 0 0.89 a 5.72 5.72 0 0 0 0.07 1 A 1.83 1.83 0 0 0 161.48 18 Z m 0.61 -1.95 c 0 -0.28 0 -0.52 0 -0.71 a 2.27 2.27 0 0 1 0.08 -0.46 a 0.42 0.42 0 0 1 0.15 -0.24 a 0.36 0.36 0 0 1 0.24 -0.07 a 0.57 0.57 0 0 1 0.24 0 a 0.44 0.44 0 0 1 0.15 0.21 a 2.63 2.63 0 0 1 0.08 0.42 c 0 0.18 0 0.41 0 0.69 v 0.48 c 0 0.28 0 0.52 0 0.71 a 2.27 2.27 0 0 1 -0.08 0.46 a 0.39 0.39 0 0 1 -0.15 0.24 a 0.36 0.36 0 0 1 -0.24 0.08 a 0.43 0.43 0 0 1 -0.24 -0.06 a 0.44 0.44 0 0 1 -0.15 -0.21 a 1.74 1.74 0 0 1 -0.08 -0.42 c 0 -0.18 0 -0.4 0 -0.68 Z M 164.55 18 a 0.8 0.8 0 0 0 0.42 0.37 a 1.89 1.89 0 0 0 0.67 0.1 a 1.39 1.39 0 0 0 0.77 -0.18 a 1.13 1.13 0 0 0 0.42 -0.52 A 2.43 2.43 0 0 0 167 17 c 0 -0.29 0 -0.58 0 -0.89 a 5.79 5.79 0 0 0 -0.07 -1 a 1.65 1.65 0 0 0 -0.22 -0.66 a 0.91 0.91 0 0 0 -0.43 -0.37 a 1.61 1.61 0 0 0 -0.67 -0.12 a 1.33 1.33 0 0 0 -0.77 0.2 a 1.28 1.28 0 0 0 -0.42 0.52 a 2.43 2.43 0 0 0 -0.16 0.75 c 0 0.29 0 0.58 0 0.89 a 6.89 6.89 0 0 0 0.07 1 A 1.65 1.65 0 0 0 164.55 18 Z m 0.6 -1.95 a 7 7 0 0 1 0 -0.71 a 2.36 2.36 0 0 1 0.07 -0.46 a 0.55 0.55 0 0 1 0.15 -0.24 a 0.36 0.36 0 0 1 0.24 -0.07 a 0.54 0.54 0 0 1 0.24 0 a 0.44 0.44 0 0 1 0.15 0.21 a 1.84 1.84 0 0 1 0.08 0.42 c 0 0.18 0 0.41 0 0.69 v 0.48 c 0 0.28 0 0.52 0 0.71 a 2.27 2.27 0 0 1 -0.08 0.46 a 0.43 0.43 0 0 1 -0.14 0.24 a 0.45 0.45 0 0 1 -0.48 0 a 0.39 0.39 0 0 1 -0.16 -0.21 a 1.81 1.81 0 0 1 -0.07 -0.42 a 6.26 6.26 0 0 1 0 -0.68 Z M 167.61 18 a 0.82 0.82 0 0 0 0.43 0.37 a 1.83 1.83 0 0 0 0.66 0.1 a 1.45 1.45 0 0 0 0.78 -0.18 a 1.18 1.18 0 0 0 0.41 -0.52 a 2.43 2.43 0 0 0 0.17 -0.75 c 0 -0.29 0 -0.58 0 -0.89 a 7.15 7.15 0 0 0 -0.06 -1 a 1.82 1.82 0 0 0 -0.23 -0.66 a 0.88 0.88 0 0 0 -0.42 -0.37 a 1.66 1.66 0 0 0 -0.68 -0.12 a 1.35 1.35 0 0 0 -0.77 0.2 a 1.18 1.18 0 0 0 -0.41 0.52 a 2.43 2.43 0 0 0 -0.17 0.75 c 0 0.29 0 0.58 0 0.89 a 7.05 7.05 0 0 0 0.06 1 A 1.82 1.82 0 0 0 167.61 18 Z m 0.61 -1.95 c 0 -0.28 0 -0.52 0 -0.71 a 2.36 2.36 0 0 1 0.07 -0.46 a 0.55 0.55 0 0 1 0.15 -0.24 a 0.36 0.36 0 0 1 0.24 -0.07 a 0.54 0.54 0 0 1 0.24 0 a 0.44 0.44 0 0 1 0.15 0.21 a 1.42 1.42 0 0 1 0.08 0.42 a 6.86 6.86 0 0 1 0 0.69 v 0.48 c 0 0.28 0 0.52 0 0.71 a 2.36 2.36 0 0 1 -0.07 0.46 a 0.5 0.5 0 0 1 -0.15 0.24 a 0.39 0.39 0 0 1 -0.25 0.08 a 0.41 0.41 0 0 1 -0.23 -0.06 a 0.34 0.34 0 0 1 -0.15 -0.21 a 1.36 1.36 0 0 1 -0.08 -0.42 a 6.65 6.65 0 0 1 0 -0.68 Z M 16.16 25.2 a 0.88 0.88 0 0 0 0.25 0.22 a 0.94 0.94 0 0 0 0.39 0.07 a 1.53 1.53 0 0 0 0.51 -0.07 a 0.79 0.79 0 0 0 0.34 -0.34 h 0 c 0 0.05 0 0.11 0.05 0.17 a 0.64 0.64 0 0 0 0.06 0.18 h 0.83 a 1.2 1.2 0 0 1 -0.09 -0.29 a 3.06 3.06 0 0 1 0 -0.36 V 23 a 1.86 1.86 0 0 0 0 -0.42 a 0.72 0.72 0 0 0 -0.18 -0.33 a 0.84 0.84 0 0 0 -0.36 -0.21 a 2.19 2.19 0 0 0 -0.63 -0.07 a 1.75 1.75 0 0 0 -0.46 0.05 a 0.9 0.9 0 0 0 -0.37 0.17 a 1 1 0 0 0 -0.26 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 23 a 0.53 0.53 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.39 0.39 0 0 1 0.31 0.11 a 0.5 0.5 0 0 1 0.09 0.31 a 0.37 0.37 0 0 1 -0.07 0.25 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2.35 2.35 0 0 0 -0.38 0.14 a 0.92 0.92 0 0 0 -0.26 0.21 a 0.9 0.9 0 0 0 -0.16 0.29 a 1.64 1.64 0 0 0 -0.05 0.41 a 1.33 1.33 0 0 0 0.05 0.34 A 1 1 0 0 0 16.16 25.2 Z m 0.76 -1.1 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.49 0.49 0 0 0 0.18 -0.11 v 0.67 a 0.41 0.41 0 0 1 -0.05 0.23 a 0.43 0.43 0 0 1 -0.12 0.17 a 0.61 0.61 0 0 1 -0.18 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.27 0.27 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 A 0.57 0.57 0 0 1 16.92 24.1 Z M 20 25.43 h -0.87 V 22.06 H 20 v 0.4 h 0 a 0.86 0.86 0 0 1 0.36 -0.37 a 1 1 0 0 1 0.5 -0.11 a 0.85 0.85 0 0 1 0.63 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 h -0.86 V 23.11 a 0.57 0.57 0 0 0 -0.09 -0.37 a 0.33 0.33 0 0 0 -0.28 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 Z m 3.27 0.06 a 1 1 0 0 0 0.44 -0.09 a 0.78 0.78 0 0 0 0.32 -0.33 h 0 v 0.36 h 0.82 V 21 H 24 v 1.42 h 0 a 0.88 0.88 0 0 0 -0.31 -0.3 a 0.82 0.82 0 0 0 -0.42 -0.1 a 0.84 0.84 0 0 0 -0.78 0.41 a 2.71 2.71 0 0 0 -0.25 1.35 a 2.66 2.66 0 0 0 0.25 1.35 A 0.85 0.85 0 0 0 23.3 25.49 Z m -0.08 -2.57 a 0.34 0.34 0 0 1 0.36 -0.28 a 0.35 0.35 0 0 1 0.37 0.28 a 2.81 2.81 0 0 1 0.09 0.82 a 2.84 2.84 0 0 1 -0.09 0.83 a 0.35 0.35 0 0 1 -0.37 0.28 a 0.34 0.34 0 0 1 -0.36 -0.28 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 23.22 22.92 Z m 4.71 2.15 h 0 a 0.85 0.85 0 0 0 0.32 0.33 a 1 1 0 0 0 0.44 0.09 a 0.83 0.83 0 0 0 0.78 -0.4 a 2.66 2.66 0 0 0 0.25 -1.35 a 2.71 2.71 0 0 0 -0.25 -1.35 A 0.82 0.82 0 0 0 28.7 22 a 0.76 0.76 0 0 0 -0.41 0.1 a 0.8 0.8 0 0 0 -0.31 0.3 h 0 V 21 H 27.1 v 4.47 h 0.83 Z m 0.12 -2.15 a 0.38 0.38 0 0 1 0.74 0 a 3.29 3.29 0 0 1 0.08 0.82 a 3.33 3.33 0 0 1 -0.08 0.83 a 0.38 0.38 0 0 1 -0.74 0 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 28.05 22.92 Z m 2.31 2.28 a 0.67 0.67 0 0 0 0.25 0.22 a 0.86 0.86 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.81 0.81 0 0 0 0.35 -0.34 h 0 a 1.36 1.36 0 0 0 0 0.17 a 1.27 1.27 0 0 0 0.06 0.18 h 0.83 a 1.9 1.9 0 0 1 -0.09 -0.29 a 3.06 3.06 0 0 1 0 -0.36 V 23 a 1.87 1.87 0 0 0 0 -0.42 a 0.82 0.82 0 0 0 -0.18 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.19 2.19 0 0 0 -0.63 -0.07 A 1.75 1.75 0 0 0 31 22 a 1 1 0 0 0 -0.37 0.17 a 0.87 0.87 0 0 0 -0.25 0.32 a 1 1 0 0 0 -0.1 0.49 v 0.08 h 0.78 V 23 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.35 0.35 0 0 1 0.3 -0.12 a 0.4 0.4 0 0 1 0.31 0.11 a 0.5 0.5 0 0 1 0.09 0.31 a 0.37 0.37 0 0 1 -0.08 0.25 a 0.49 0.49 0 0 1 -0.27 0.14 L 31 23.5 a 2.49 2.49 0 0 0 -0.39 0.14 a 1.09 1.09 0 0 0 -0.26 0.21 a 0.73 0.73 0 0 0 -0.15 0.29 a 1.28 1.28 0 0 0 -0.05 0.41 a 1.32 1.32 0 0 0 0 0.34 A 1 1 0 0 0 30.36 25.2 Z m 0.75 -1.1 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.52 0.52 0 0 0 0.19 -0.11 v 0.67 a 0.52 0.52 0 0 1 -0.05 0.23 a 0.59 0.59 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.08 -0.33 A 0.57 0.57 0 0 1 31.11 24.1 Z m 2.2 0.49 a 4 4 0 0 1 -0.08 -0.85 a 3.3 3.3 0 0 1 0.1 -0.85 a 1.5 1.5 0 0 1 0.28 -0.55 a 1 1 0 0 1 0.44 -0.28 A 1.59 1.59 0 0 1 34.6 22 a 1.1 1.1 0 0 1 0.9 0.35 a 1.41 1.41 0 0 1 0.3 1 H 35 A 2 2 0 0 0 35 23 a 0.65 0.65 0 0 0 -0.06 -0.21 a 0.31 0.31 0 0 0 -0.11 -0.16 a 0.32 0.32 0 0 0 -0.2 -0.06 a 0.53 0.53 0 0 0 -0.26 0.07 a 0.53 0.53 0 0 0 -0.15 0.22 a 2.15 2.15 0 0 0 -0.07 0.35 c 0 0.15 0 0.32 0 0.51 s 0 0.39 0 0.54 a 2.3 2.3 0 0 0 0.07 0.36 a 0.37 0.37 0 0 0 0.38 0.28 a 0.36 0.36 0 0 0 0.32 -0.19 a 1.48 1.48 0 0 0 0.1 -0.6 h 0.82 a 1.5 1.5 0 0 1 -0.3 1 a 1.21 1.21 0 0 1 -1 0.34 a 2 2 0 0 1 -0.57 -0.07 a 0.94 0.94 0 0 1 -0.4 -0.28 A 1.65 1.65 0 0 1 33.31 24.59 Z m 3.9 0.84 h -0.86 V 21 h 0.86 v 2.36 h 0 l 0.87 -1.26 H 39 l -1 1.33 l 1.11 2 h -1 L 37.51 24 l -0.3 0.4 Z m 2.35 -0.5 a 1 1 0 0 0 0.39 0.41 a 1.45 1.45 0 0 0 0.73 0.15 a 1.19 1.19 0 0 0 0.9 -0.3 a 1.39 1.39 0 0 0 0.32 -0.9 h -0.78 a 1 1 0 0 1 -0.14 0.48 a 0.35 0.35 0 0 1 -0.32 0.16 a 0.37 0.37 0 0 1 -0.2 -0.07 a 0.59 0.59 0 0 1 -0.13 -0.17 a 1.82 1.82 0 0 1 -0.07 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 H 42 v -0.2 a 4.9 4.9 0 0 0 -0.05 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.4 1.4 0 0 0 -0.62 -0.12 a 1.43 1.43 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.88 1.88 0 0 0 -0.19 0.55 a 4.63 4.63 0 0 0 0 0.65 c 0 0.22 0 0.43 0 0.64 A 1.56 1.56 0 0 0 39.56 24.93 Z m 0.68 -1.7 a 1.94 1.94 0 0 1 0 -0.24 a 1.29 1.29 0 0 1 0.07 -0.21 a 0.44 0.44 0 0 1 0.14 -0.16 a 0.35 0.35 0 0 1 0.21 -0.06 a 0.38 0.38 0 0 1 0.22 0.06 a 0.32 0.32 0 0 1 0.13 0.15 a 1.49 1.49 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z M 45 25.43 V 21 h -0.86 v 1.42 h 0 a 0.8 0.8 0 0 0 -0.31 -0.3 a 0.76 0.76 0 0 0 -0.41 -0.1 a 0.82 0.82 0 0 0 -0.78 0.41 a 2.71 2.71 0 0 0 -0.25 1.35 a 2.66 2.66 0 0 0 0.25 1.35 a 0.83 0.83 0 0 0 0.78 0.4 a 1 1 0 0 0 0.44 -0.09 a 0.85 0.85 0 0 0 0.32 -0.33 h 0 v 0.36 Z m -0.95 -0.86 a 0.38 0.38 0 0 1 -0.74 0 a 3.33 3.33 0 0 1 -0.08 -0.83 a 3.29 3.29 0 0 1 0.08 -0.82 a 0.38 0.38 0 0 1 0.74 0 a 2.81 2.81 0 0 1 0.09 0.82 A 2.84 2.84 0 0 1 44.06 24.57 Z M 47.21 21 v 4.47 H 48 v -0.36 h 0 a 0.78 0.78 0 0 0 0.32 0.33 a 1 1 0 0 0 0.44 0.09 a 0.85 0.85 0 0 0 0.78 -0.4 a 2.66 2.66 0 0 0 0.25 -1.35 a 2.71 2.71 0 0 0 -0.25 -1.35 a 0.84 0.84 0 0 0 -0.78 -0.41 a 0.82 0.82 0 0 0 -0.42 0.1 a 0.88 0.88 0 0 0 -0.31 0.3 h 0 V 21 Z m 0.95 2 a 0.35 0.35 0 0 1 0.37 -0.28 a 0.34 0.34 0 0 1 0.36 0.28 a 2.81 2.81 0 0 1 0.09 0.82 a 2.84 2.84 0 0 1 -0.09 0.83 a 0.34 0.34 0 0 1 -0.36 0.28 a 0.35 0.35 0 0 1 -0.37 -0.28 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 48.16 22.92 Z m 2 -0.86 H 51 l 0.5 2.33 h 0 L 52 22.06 h 0.86 L 52 25.2 a 6.91 6.91 0 0 1 -0.22 0.68 a 1.24 1.24 0 0 1 -0.24 0.4 a 0.7 0.7 0 0 1 -0.34 0.18 a 2.17 2.17 0 0 1 -0.49 0.05 H 50.4 v -0.65 a 0.82 0.82 0 0 0 0.22 0 a 0.43 0.43 0 0 0 0.34 -0.12 a 0.6 0.6 0 0 0 0.12 -0.33 Z m 4.84 0.59 h -0.43 v -0.59 H 55 v -1 h 0.87 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.6 0.6 0 0 0 0 0.28 a 0.29 0.29 0 0 0 0.25 0.09 h 0.2 v 0.6 h -0.57 a 2.37 2.37 0 0 1 -0.41 0 a 0.42 0.42 0 0 1 -0.24 -0.14 A 0.67 0.67 0 0 1 55 25 a 2.42 2.42 0 0 1 0 -0.42 Z M 57.57 21 v 1.45 h 0 A 0.87 0.87 0 0 1 58.4 22 a 0.86 0.86 0 0 1 0.64 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 H 58.4 V 23.11 a 0.57 0.57 0 0 0 -0.09 -0.37 a 0.34 0.34 0 0 0 -0.28 -0.1 c -0.31 0 -0.46 0.18 -0.46 0.55 v 2.24 h -0.86 V 21 Z m 4.77 2.92 v -0.2 a 4.9 4.9 0 0 0 -0.05 -0.7 a 1.44 1.44 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.41 1.41 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.41 0.39 a 1.62 1.62 0 0 0 -0.18 0.55 a 4.62 4.62 0 0 0 0 0.65 c 0 0.22 0 0.43 0 0.64 a 1.77 1.77 0 0 0 0.15 0.58 a 1 1 0 0 0 0.39 0.41 a 1.47 1.47 0 0 0 0.73 0.15 a 1.23 1.23 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.78 a 1.16 1.16 0 0 1 -0.13 0.48 a 0.38 0.38 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.37 0.37 0 0 1 -0.13 -0.17 a 1 1 0 0 1 -0.08 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 Z m -1.71 -0.65 a 1.94 1.94 0 0 1 0 -0.24 a 0.76 0.76 0 0 1 0.08 -0.21 a 0.34 0.34 0 0 1 0.13 -0.16 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.35 0.35 0 0 1 0.21 0.06 a 0.28 0.28 0 0 1 0.13 0.15 a 0.91 0.91 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z m 4 -1.93 a 0.67 0.67 0 0 1 0.18 -0.25 a 0.65 0.65 0 0 1 0.29 -0.13 a 1.4 1.4 0 0 1 0.37 0 H 66 v 0.62 H 65.8 a 0.41 0.41 0 0 0 -0.26 0.06 a 0.27 0.27 0 0 0 -0.08 0.21 v 0.29 H 66 v 0.59 h -0.5 v 2.78 H 64.6 V 22.65 h -0.44 v -0.59 h 0.44 v -0.38 A 1.08 1.08 0 0 1 64.66 21.3 Z m 3.35 3 V 22.06 h 0.87 v 3.37 h -0.83 V 25 h 0 a 0.78 0.78 0 0 1 -0.36 0.36 a 1.12 1.12 0 0 1 -0.5 0.1 a 0.89 0.89 0 0 1 -0.63 -0.21 a 1 1 0 0 1 -0.22 -0.72 v -2.5 h 0.86 v 2.32 a 0.57 0.57 0 0 0 0.09 0.37 a 0.33 0.33 0 0 0 0.28 0.1 C 67.86 24.85 68 24.67 68 24.29 Z m 2.4 1.14 h -0.86 V 21 h 0.86 Z m 1.56 0 h -0.86 V 21 H 72 Z m 2 -3.37 h 0.44 v -0.38 a 1.08 1.08 0 0 1 0.06 -0.38 a 0.58 0.58 0 0 1 0.18 -0.25 a 0.66 0.66 0 0 1 0.28 -0.13 a 1.53 1.53 0 0 1 0.38 0 h 0.46 v 0.62 h -0.17 a 0.4 0.4 0 0 0 -0.25 0.06 a 0.27 0.27 0 0 0 -0.08 0.21 v 0.29 h 0.5 v 0.59 h -0.5 v 2.78 h -0.86 V 22.65 H 74 Z m 2.88 0 a 1 1 0 0 0 -0.38 0.17 a 1 1 0 0 0 -0.25 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 23 a 0.53 0.53 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.39 0.39 0 0 1 0.31 0.11 a 0.5 0.5 0 0 1 0.09 0.31 a 0.37 0.37 0 0 1 -0.07 0.25 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2 2 0 0 0 -0.38 0.14 a 1 1 0 0 0 -0.27 0.21 a 0.89 0.89 0 0 0 -0.15 0.29 a 1.64 1.64 0 0 0 0 0.41 a 2 2 0 0 0 0 0.34 a 1 1 0 0 0 0.14 0.31 a 0.76 0.76 0 0 0 0.25 0.22 a 0.89 0.89 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.81 0.81 0 0 0 0.35 -0.34 h 0 c 0 0.05 0 0.11 0 0.17 a 1.34 1.34 0 0 0 0.07 0.18 h 0.82 a 1.15 1.15 0 0 1 -0.08 -0.29 a 1.78 1.78 0 0 1 0 -0.36 V 23 a 1.86 1.86 0 0 0 -0.05 -0.42 a 0.72 0.72 0 0 0 -0.18 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.07 2.07 0 0 0 -0.62 -0.07 A 1.71 1.71 0 0 0 76.83 22 Z m 0.85 2.38 a 0.41 0.41 0 0 1 -0.05 0.23 a 0.37 0.37 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 a 0.52 0.52 0 0 1 0.11 -0.36 a 0.65 0.65 0 0 1 0.37 -0.19 a 0.64 0.64 0 0 0 0.18 -0.06 a 0.52 0.52 0 0 0 0.19 -0.11 Z m 2.4 -2.76 h -0.87 v -0.74 h 0.87 Z m -0.87 0.41 h 0.87 v 3.37 h -0.87 Z m 1.28 0 h 0.44 v -1 h 0.86 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 a 0.29 0.29 0 0 0 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.37 2.37 0 0 1 -0.41 0 a 0.42 0.42 0 0 1 -0.24 -0.14 A 0.56 0.56 0 0 1 81 25 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 h -0.44 Z m 3 -1.1 v 1.45 h 0 a 0.87 0.87 0 0 1 0.82 -0.43 a 0.86 0.86 0 0 1 0.64 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 h -0.87 V 23.11 a 0.58 0.58 0 0 0 -0.08 -0.37 a 0.36 0.36 0 0 0 -0.28 -0.1 c -0.31 0 -0.46 0.18 -0.46 0.55 v 2.24 h -0.86 V 21 Z M 88.12 22 a 0.9 0.9 0 0 0 -0.37 0.17 a 1 1 0 0 0 -0.26 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.78 V 23 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.35 0.35 0 0 1 0.3 -0.12 a 0.42 0.42 0 0 1 0.31 0.11 A 0.5 0.5 0 0 1 89 23 a 0.37 0.37 0 0 1 -0.08 0.25 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2.35 2.35 0 0 0 -0.38 0.14 a 0.92 0.92 0 0 0 -0.26 0.21 a 0.9 0.9 0 0 0 -0.16 0.29 a 1.64 1.64 0 0 0 0 0.41 a 1.33 1.33 0 0 0 0 0.34 a 0.8 0.8 0 0 0 0.14 0.31 a 0.67 0.67 0 0 0 0.25 0.22 a 0.86 0.86 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.79 0.79 0 0 0 0.34 -0.34 h 0 a 1.36 1.36 0 0 0 0 0.17 a 0.64 0.64 0 0 0 0.06 0.18 h 0.83 a 1.9 1.9 0 0 1 -0.09 -0.29 a 3.06 3.06 0 0 1 0 -0.36 V 23 a 1.42 1.42 0 0 0 0 -0.42 a 0.8 0.8 0 0 0 -0.17 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.19 2.19 0 0 0 -0.63 -0.07 A 1.75 1.75 0 0 0 88.12 22 Z M 89 24.41 a 0.52 0.52 0 0 1 0 0.23 a 0.59 0.59 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 l -0.19 0 a 0.27 0.27 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 a 0.57 0.57 0 0 1 0.11 -0.36 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.62 0.62 0 0 0 0.19 -0.11 Z m 2.69 -2.32 a 1 1 0 0 1 0.5 -0.11 a 0.83 0.83 0 0 1 0.63 0.22 a 1 1 0 0 1 0.23 0.73 v 2.5 h -0.87 V 23.11 a 0.65 0.65 0 0 0 -0.08 -0.37 a 0.37 0.37 0 0 0 -0.29 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 v 2.24 h -0.86 V 22.06 h 0.82 v 0.4 h 0 A 0.86 0.86 0 0 1 91.67 22.09 Z m 2.94 3.4 a 0.93 0.93 0 0 0 0.44 -0.09 a 0.86 0.86 0 0 0 0.33 -0.33 h 0 v 0.36 h 0.82 V 21 h -0.86 v 1.42 h 0 a 0.88 0.88 0 0 0 -0.31 -0.3 a 0.79 0.79 0 0 0 -0.42 -0.1 a 0.84 0.84 0 0 0 -0.78 0.41 a 2.83 2.83 0 0 0 -0.25 1.35 a 2.77 2.77 0 0 0 0.25 1.35 A 0.85 0.85 0 0 0 94.61 25.49 Z m -0.08 -2.57 a 0.35 0.35 0 0 1 0.36 -0.28 a 0.36 0.36 0 0 1 0.38 0.28 a 3.29 3.29 0 0 1 0.08 0.82 a 3.33 3.33 0 0 1 -0.08 0.83 a 0.36 0.36 0 0 1 -0.38 0.28 a 0.35 0.35 0 0 1 -0.36 -0.28 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 94.53 22.92 Z m 3.84 1.67 a 4 4 0 0 1 -0.08 -0.85 a 2.91 2.91 0 0 1 0.1 -0.85 a 1.36 1.36 0 0 1 0.28 -0.55 a 1 1 0 0 1 0.43 -0.28 a 1.63 1.63 0 0 1 0.55 -0.08 a 1.1 1.1 0 0 1 0.9 0.35 a 1.36 1.36 0 0 1 0.31 1 H 100 a 2 2 0 0 0 0 -0.25 a 0.65 0.65 0 0 0 -0.06 -0.21 a 0.4 0.4 0 0 0 -0.12 -0.16 a 0.3 0.3 0 0 0 -0.2 -0.06 a 0.46 0.46 0 0 0 -0.25 0.07 a 0.4 0.4 0 0 0 -0.15 0.22 a 1.08 1.08 0 0 0 -0.07 0.35 c 0 0.15 0 0.32 0 0.51 s 0 0.39 0 0.54 a 1.15 1.15 0 0 0 0.07 0.36 a 0.37 0.37 0 0 0 0.14 0.21 a 0.42 0.42 0 0 0 0.23 0.07 a 0.34 0.34 0 0 0 0.32 -0.19 a 1.33 1.33 0 0 0 0.1 -0.6 h 0.83 a 1.5 1.5 0 0 1 -0.3 1 a 1.24 1.24 0 0 1 -1 0.34 a 1.93 1.93 0 0 1 -0.57 -0.07 a 0.94 0.94 0 0 1 -0.4 -0.28 A 1.33 1.33 0 0 1 98.37 24.59 Z m 3.86 0.84 h -0.86 V 22.06 h 0.82 v 0.45 h 0 a 1.12 1.12 0 0 1 0.32 -0.39 A 0.73 0.73 0 0 1 103 22 h 0.16 v 0.82 h -0.27 a 0.91 0.91 0 0 0 -0.23 0 a 0.56 0.56 0 0 0 -0.2 0.11 a 0.54 0.54 0 0 0 -0.15 0.18 a 0.62 0.62 0 0 0 -0.06 0.29 Z M 106 23.88 v -0.2 a 4.9 4.9 0 0 0 0 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.38 1.38 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.41 0.39 a 1.62 1.62 0 0 0 -0.18 0.55 a 3.49 3.49 0 0 0 0 0.65 c 0 0.22 0 0.43 0 0.64 a 1.77 1.77 0 0 0 0.15 0.58 a 1 1 0 0 0 0.39 0.41 a 1.47 1.47 0 0 0 0.73 0.15 a 1.19 1.19 0 0 0 0.9 -0.3 a 1.34 1.34 0 0 0 0.32 -0.9 h -0.78 a 1 1 0 0 1 -0.14 0.48 a 0.35 0.35 0 0 1 -0.31 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.47 0.47 0 0 1 -0.14 -0.17 a 1.82 1.82 0 0 1 -0.07 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 Z m -1.71 -0.65 a 1.94 1.94 0 0 1 0 -0.24 a 1.29 1.29 0 0 1 0.07 -0.21 a 0.44 0.44 0 0 1 0.14 -0.16 a 0.37 0.37 0 0 1 0.21 -0.06 a 0.38 0.38 0 0 1 0.22 0.06 a 0.28 0.28 0 0 1 0.13 0.15 a 1.49 1.49 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z m 2.14 0.51 a 2.66 2.66 0 0 0 0.25 1.35 a 0.84 0.84 0 0 0 0.78 0.4 a 1 1 0 0 0 0.44 -0.09 a 0.78 0.78 0 0 0 0.32 -0.33 h 0 v 0.36 H 109 V 21 h -0.86 v 1.42 h 0 a 0.86 0.86 0 0 0 -0.3 -0.3 a 0.82 0.82 0 0 0 -0.42 -0.1 a 0.83 0.83 0 0 0 -0.78 0.41 A 2.71 2.71 0 0 0 106.39 23.74 Z m 1 -0.82 a 0.34 0.34 0 0 1 0.36 -0.28 a 0.35 0.35 0 0 1 0.37 0.28 a 2.81 2.81 0 0 1 0.09 0.82 a 2.84 2.84 0 0 1 -0.09 0.83 a 0.35 0.35 0 0 1 -0.37 0.28 a 0.34 0.34 0 0 1 -0.36 -0.28 a 2.84 2.84 0 0 1 -0.09 -0.83 A 2.81 2.81 0 0 1 107.34 22.92 Z m 2.35 -0.86 h 0.86 v 3.37 h -0.86 Z m 0 -1.15 h 0.86 v 0.74 h -0.86 Z m 2.58 0.19 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.22 2.22 0 0 1 -0.41 0 a 0.41 0.41 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 H 111 v -0.59 h 0.44 v -1 Z m 3 4.3 a 1.57 1.57 0 0 0 0.65 0.09 a 1.65 1.65 0 0 0 0.62 -0.1 a 0.94 0.94 0 0 0 0.41 -0.33 a 1.44 1.44 0 0 0 0.22 -0.55 a 3.55 3.55 0 0 0 0.07 -0.77 a 4.38 4.38 0 0 0 -0.06 -0.77 a 1.49 1.49 0 0 0 -0.21 -0.56 a 0.89 0.89 0 0 0 -0.41 -0.33 a 1.54 1.54 0 0 0 -0.64 -0.1 a 1.48 1.48 0 0 0 -0.63 0.11 a 1 1 0 0 0 -0.4 0.34 a 1.45 1.45 0 0 0 -0.23 0.55 a 3.51 3.51 0 0 0 -0.07 0.76 a 4.5 4.5 0 0 0 0.06 0.78 a 1.54 1.54 0 0 0 0.22 0.55 A 0.86 0.86 0 0 0 115.26 25.4 Z m 0.2 -2.13 a 1.08 1.08 0 0 1 0.06 -0.38 a 0.48 0.48 0 0 1 0.14 -0.24 a 0.33 0.33 0 0 1 0.25 -0.09 a 0.38 0.38 0 0 1 0.36 0.28 a 2.76 2.76 0 0 1 0.1 0.9 a 2.79 2.79 0 0 1 -0.1 0.91 a 0.38 0.38 0 0 1 -0.36 0.28 a 0.33 0.33 0 0 1 -0.25 -0.09 a 0.47 0.47 0 0 1 -0.14 -0.25 a 1 1 0 0 1 -0.06 -0.37 c 0 -0.15 0 -0.3 0 -0.48 S 115.45 23.42 115.46 23.27 Z m 2.72 -2.22 a 0.7 0.7 0 0 1 0.29 -0.13 a 1.45 1.45 0 0 1 0.37 0 h 0.47 v 0.62 h -0.17 a 0.43 0.43 0 0 0 -0.26 0.06 a 0.27 0.27 0 0 0 -0.07 0.21 v 0.29 h 0.5 v 0.59 h -0.5 v 2.78 h -0.87 V 22.65 h -0.43 v -0.59 h 0.43 v -0.38 a 0.89 0.89 0 0 1 0.07 -0.38 A 0.65 0.65 0 0 1 118.18 21.05 Z m 4.1 0.05 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.29 2.29 0 0 1 -0.41 0 a 0.36 0.36 0 0 1 -0.24 -0.14 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 H 121 v -0.59 h 0.44 v -1 Z m 2.56 0.88 a 0.85 0.85 0 0 1 0.63 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 h -0.86 V 23.11 a 0.57 0.57 0 0 0 -0.09 -0.37 a 0.33 0.33 0 0 0 -0.28 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 v 2.24 h -0.87 V 21 H 124 v 1.45 h 0 A 0.87 0.87 0 0 1 124.84 22 Z m 1.55 2.95 a 1 1 0 0 0 0.39 0.41 a 1.45 1.45 0 0 0 0.73 0.15 a 1.19 1.19 0 0 0 0.9 -0.3 a 1.39 1.39 0 0 0 0.32 -0.9 H 128 a 1 1 0 0 1 -0.14 0.48 a 0.35 0.35 0 0 1 -0.32 0.16 a 0.35 0.35 0 0 1 -0.2 -0.07 a 0.59 0.59 0 0 1 -0.13 -0.17 a 1.82 1.82 0 0 1 -0.07 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 h 1.71 v -0.2 a 4.9 4.9 0 0 0 -0.05 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.4 1.4 0 0 0 -0.62 -0.12 a 1.43 1.43 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.63 1.63 0 0 0 -0.19 0.55 a 4.63 4.63 0 0 0 0 0.65 c 0 0.22 0 0.43 0 0.64 A 1.56 1.56 0 0 0 126.39 24.93 Z m 0.68 -1.7 a 1.94 1.94 0 0 1 0 -0.24 a 1.29 1.29 0 0 1 0.07 -0.21 a 0.44 0.44 0 0 1 0.14 -0.16 a 0.35 0.35 0 0 1 0.21 -0.06 a 0.38 0.38 0 0 1 0.22 0.06 a 0.32 0.32 0 0 1 0.13 0.15 a 1.49 1.49 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z m 4.65 0.85 a 3 3 0 0 0 0 0.31 a 0.85 0.85 0 0 0 0.08 0.24 a 0.49 0.49 0 0 0 0.16 0.16 a 0.53 0.53 0 0 0 0.26 0.06 a 0.54 0.54 0 0 0 0.27 -0.06 a 0.49 0.49 0 0 0 0.16 -0.16 a 0.85 0.85 0 0 0 0.08 -0.24 a 3 3 0 0 0 0 -0.31 V 21 h 0.9 v 3.12 a 1.79 1.79 0 0 1 -0.12 0.7 a 1.22 1.22 0 0 1 -0.32 0.44 a 1.05 1.05 0 0 1 -0.45 0.22 a 2.41 2.41 0 0 1 -0.54 0 a 2.32 2.32 0 0 1 -0.53 0 a 1 1 0 0 1 -0.77 -0.63 a 1.89 1.89 0 0 1 -0.12 -0.73 V 21 h 0.9 Z M 136 25.43 V 23.11 a 0.65 0.65 0 0 0 -0.08 -0.37 a 0.37 0.37 0 0 0 -0.29 -0.1 c -0.3 0 -0.45 0.18 -0.45 0.55 v 2.24 h -0.86 V 22.06 h 0.82 v 0.4 h 0 a 0.86 0.86 0 0 1 0.36 -0.37 A 1 1 0 0 1 136 22 a 0.83 0.83 0 0 1 0.63 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 Z m 1.53 -3.37 h 0.87 v 3.37 h -0.87 Z m 0.87 -0.41 h -0.87 v -0.74 h 0.87 Z m 1.72 0.41 h 0.5 v 0.59 h -0.5 v 1.82 a 0.5 0.5 0 0 0 0 0.28 a 0.29 0.29 0 0 0 0.25 0.09 h 0.2 v 0.6 H 140 a 2.37 2.37 0 0 1 -0.41 0 a 0.42 0.42 0 0 1 -0.24 -0.14 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 h -0.43 v -0.59 h 0.43 v -1 h 0.87 Z m 0.91 2.87 a 1.09 1.09 0 0 0 0.39 0.41 a 1.5 1.5 0 0 0 0.73 0.15 a 1.2 1.2 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.77 a 1.14 1.14 0 0 1 -0.14 0.48 a 0.36 0.36 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.45 0.45 0 0 1 -0.13 -0.17 a 1 1 0 0 1 -0.07 -0.25 a 1.46 1.46 0 0 1 0 -0.29 v -0.27 h 1.7 v -0.2 a 4.9 4.9 0 0 0 0 -0.7 a 1.28 1.28 0 0 0 -0.19 -0.54 a 0.87 0.87 0 0 0 -0.37 -0.34 a 1.4 1.4 0 0 0 -0.62 -0.12 a 1.43 1.43 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.44 1.44 0 0 0 -0.19 0.55 a 4.62 4.62 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.77 1.77 0 0 0 141 24.93 Z m 0.69 -1.7 a 1 1 0 0 1 0 -0.24 a 0.74 0.74 0 0 1 0.07 -0.21 a 0.42 0.42 0 0 1 0.13 -0.16 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.33 0.33 0 0 1 0.21 0.06 a 0.34 0.34 0 0 1 0.14 0.15 a 0.92 0.92 0 0 1 0.06 0.25 c 0 0.1 0 0.21 0 0.34 h -0.88 Z m 3.16 2.26 a 0.93 0.93 0 0 0 0.44 -0.09 a 0.86 0.86 0 0 0 0.33 -0.33 h 0 v 0.36 h 0.82 V 21 h -0.86 v 1.42 h 0 a 0.88 0.88 0 0 0 -0.31 -0.3 a 0.77 0.77 0 0 0 -0.42 -0.1 a 0.84 0.84 0 0 0 -0.78 0.41 a 2.83 2.83 0 0 0 -0.25 1.35 a 2.77 2.77 0 0 0 0.25 1.35 A 0.85 0.85 0 0 0 144.84 25.49 Z m -0.08 -2.57 a 0.38 0.38 0 0 1 0.74 0 a 3.29 3.29 0 0 1 0.08 0.82 a 3.33 3.33 0 0 1 -0.08 0.83 a 0.38 0.38 0 0 1 -0.74 0 a 2.91 2.91 0 0 1 -0.08 -0.83 A 2.87 2.87 0 0 1 144.76 22.92 Z M 149.39 24 v 0.13 a 1.29 1.29 0 0 0 0 0.29 a 0.58 0.58 0 0 0 0.09 0.21 a 0.45 0.45 0 0 0 0.19 0.14 a 0.76 0.76 0 0 0 0.29 0.05 a 0.56 0.56 0 0 0 0.37 -0.13 a 0.51 0.51 0 0 0 0.17 -0.42 a 0.67 0.67 0 0 0 -0.05 -0.26 a 0.49 0.49 0 0 0 -0.13 -0.2 a 0.82 0.82 0 0 0 -0.25 -0.15 a 2.81 2.81 0 0 0 -0.37 -0.15 a 3.25 3.25 0 0 1 -0.52 -0.22 a 1.34 1.34 0 0 1 -0.37 -0.28 a 0.85 0.85 0 0 1 -0.21 -0.37 a 1.43 1.43 0 0 1 -0.07 -0.48 a 1.25 1.25 0 0 1 0.37 -1 a 1.44 1.44 0 0 1 1 -0.32 a 2.38 2.38 0 0 1 0.55 0.06 a 1.38 1.38 0 0 1 0.44 0.21 a 1.1 1.1 0 0 1 0.29 0.38 a 1.46 1.46 0 0 1 0.1 0.55 v 0.12 h -0.86 a 0.87 0.87 0 0 0 -0.12 -0.49 a 0.41 0.41 0 0 0 -0.37 -0.17 a 0.62 0.62 0 0 0 -0.25 0 a 0.4 0.4 0 0 0 -0.16 0.12 a 0.35 0.35 0 0 0 -0.08 0.16 a 0.68 0.68 0 0 0 0 0.2 a 0.71 0.71 0 0 0 0.08 0.34 a 0.78 0.78 0 0 0 0.38 0.26 l 0.69 0.3 a 2.61 2.61 0 0 1 0.42 0.24 a 1.07 1.07 0 0 1 0.26 0.26 a 0.87 0.87 0 0 1 0.14 0.31 a 2.17 2.17 0 0 1 0 0.38 a 1.19 1.19 0 0 1 -0.41 1 a 1.76 1.76 0 0 1 -1.14 0.32 a 1.5 1.5 0 0 1 -1.09 -0.33 a 1.28 1.28 0 0 1 -0.33 -0.95 V 24 Z m 3.61 -2 h 0.5 v 0.59 H 153 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.22 2.22 0 0 1 -0.41 0 a 0.41 0.41 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 h -0.44 v -0.59 h 0.44 v -1 H 153 Z m 3.21 0.53 a 0.72 0.72 0 0 0 -0.18 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 A 2.12 2.12 0 0 0 155 22 a 1.66 1.66 0 0 0 -0.46 0.05 a 0.94 0.94 0 0 0 -0.38 0.17 a 1 1 0 0 0 -0.25 0.32 a 1.19 1.19 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 23 a 0.47 0.47 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.39 0.39 0 0 1 0.31 0.11 a 0.5 0.5 0 0 1 0.09 0.31 a 0.37 0.37 0 0 1 -0.07 0.25 a 0.49 0.49 0 0 1 -0.27 0.14 l -0.49 0.13 a 2 2 0 0 0 -0.38 0.14 a 1 1 0 0 0 -0.27 0.21 a 0.73 0.73 0 0 0 -0.15 0.29 a 1.64 1.64 0 0 0 -0.05 0.41 a 1.32 1.32 0 0 0 0 0.34 a 1 1 0 0 0 0.14 0.31 a 0.76 0.76 0 0 0 0.25 0.22 a 0.89 0.89 0 0 0 0.38 0.07 a 1.46 1.46 0 0 0 0.51 -0.07 a 0.81 0.81 0 0 0 0.35 -0.34 h 0 c 0 0.05 0 0.11 0 0.17 a 1.34 1.34 0 0 0 0.07 0.18 h 0.82 a 1.15 1.15 0 0 1 -0.08 -0.29 a 1.78 1.78 0 0 1 0 -0.36 V 23 A 1.86 1.86 0 0 0 156.21 22.59 Z m -0.78 1.82 a 0.52 0.52 0 0 1 -0.05 0.23 a 0.37 0.37 0 0 1 -0.13 0.17 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.08 -0.33 a 0.52 0.52 0 0 1 0.12 -0.36 a 0.65 0.65 0 0 1 0.37 -0.19 l 0.18 -0.06 a 0.52 0.52 0 0 0 0.19 -0.11 Z M 158 21.1 v 1 h 0.5 v 0.59 H 158 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 c 0 0.06 0.12 0.09 0.25 0.09 h 0.19 v 0.6 h -0.56 a 2.29 2.29 0 0 1 -0.41 0 a 0.36 0.36 0 0 1 -0.24 -0.14 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.42 2.42 0 0 1 0 -0.42 V 22.65 h -0.44 v -0.59 h 0.44 v -1 Z m 1 1.41 a 1.62 1.62 0 0 0 -0.18 0.55 a 3.49 3.49 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 a 1.77 1.77 0 0 0 0.15 0.58 a 1 1 0 0 0 0.39 0.41 a 1.47 1.47 0 0 0 0.73 0.15 a 1.23 1.23 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.78 a 1.16 1.16 0 0 1 -0.13 0.48 a 0.38 0.38 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.47 0.47 0 0 1 -0.14 -0.17 a 1.82 1.82 0 0 1 -0.07 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 h 1.71 v -0.2 a 4.9 4.9 0 0 0 0 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.38 1.38 0 0 0 -0.7 0.14 A 1 1 0 0 0 159 22.51 Z m 0.63 0.72 a 1.94 1.94 0 0 1 0 -0.24 a 1.29 1.29 0 0 1 0.07 -0.21 a 0.44 0.44 0 0 1 0.14 -0.16 a 0.37 0.37 0 0 1 0.21 -0.06 a 0.38 0.38 0 0 1 0.22 0.06 a 0.28 0.28 0 0 1 0.13 0.15 a 1.49 1.49 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z m 3 -0.58 a 0.34 0.34 0 0 0 -0.12 0.28 a 0.36 0.36 0 0 0 0.07 0.22 a 0.7 0.7 0 0 0 0.3 0.17 l 0.52 0.17 a 1.27 1.27 0 0 1 0.57 0.36 a 0.94 0.94 0 0 1 0.17 0.61 a 1.08 1.08 0 0 1 -0.09 0.46 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.19 a 2.05 2.05 0 0 1 -0.51 0 a 2.52 2.52 0 0 1 -0.6 -0.06 a 0.92 0.92 0 0 1 -0.38 -0.21 a 0.79 0.79 0 0 1 -0.2 -0.33 a 2.06 2.06 0 0 1 -0.05 -0.45 v -0.11 h 0.77 v 0.11 a 0.51 0.51 0 0 0 0.12 0.35 a 0.41 0.41 0 0 0 0.33 0.14 a 0.53 0.53 0 0 0 0.32 -0.1 a 0.38 0.38 0 0 0 0.12 -0.3 a 0.3 0.3 0 0 0 -0.1 -0.25 a 0.57 0.57 0 0 0 -0.21 -0.13 l -0.61 -0.22 a 1.14 1.14 0 0 1 -0.54 -0.36 a 0.89 0.89 0 0 1 -0.18 -0.58 a 1 1 0 0 1 0.07 -0.39 a 0.87 0.87 0 0 1 0.22 -0.32 a 1 1 0 0 1 0.38 -0.22 a 1.64 1.64 0 0 1 0.57 -0.08 a 1.27 1.27 0 0 1 0.87 0.25 a 0.9 0.9 0 0 1 0.28 0.7 v 0.14 h -0.78 a 0.63 0.63 0 0 0 -0.08 -0.38 a 0.33 0.33 0 0 0 -0.3 -0.13 A 0.45 0.45 0 0 0 162.63 22.65 Z m 4.59 -0.75 a 3.73 3.73 0 0 0 -0.14 1.2 c 0 0.27 0 0.51 0 0.73 a 2.1 2.1 0 0 0 0.09 0.55 a 0.77 0.77 0 0 0 0.18 0.35 a 0.46 0.46 0 0 0 0.5 0.08 a 1 1 0 0 0 0.18 -0.13 a 1 1 0 0 0 0.14 -0.23 a 0.75 0.75 0 0 0 0.06 -0.31 v -0.46 h -0.6 V 23 h 1.46 v 2.41 h -0.66 V 25 h 0 a 1 1 0 0 1 -0.39 0.38 a 1.27 1.27 0 0 1 -0.54 0.1 a 1.37 1.37 0 0 1 -0.68 -0.14 a 1 1 0 0 1 -0.4 -0.44 a 2.16 2.16 0 0 1 -0.2 -0.74 c 0 -0.3 0 -0.64 0 -1 a 5.75 5.75 0 0 1 0.07 -1 a 1.91 1.91 0 0 1 0.25 -0.71 A 1.19 1.19 0 0 1 167 21 a 1.54 1.54 0 0 1 0.72 -0.14 a 1.36 1.36 0 0 1 1.06 0.36 a 1.52 1.52 0 0 1 0.33 1.05 h -0.86 a 1.22 1.22 0 0 0 0 -0.26 a 0.85 0.85 0 0 0 -0.09 -0.24 a 0.69 0.69 0 0 0 -0.16 -0.18 a 0.38 0.38 0 0 0 -0.24 -0.07 A 0.5 0.5 0 0 0 167.22 21.9 Z M 169.69 23 a 4.28 4.28 0 0 0 -0.07 0.76 a 4.43 4.43 0 0 0 0.07 0.78 a 1.38 1.38 0 0 0 0.21 0.55 a 0.89 0.89 0 0 0 0.41 0.33 a 1.52 1.52 0 0 0 0.64 0.09 a 1.61 1.61 0 0 0 0.62 -0.1 a 0.89 0.89 0 0 0 0.41 -0.33 a 1.63 1.63 0 0 0 0.23 -0.55 a 5 5 0 0 0 0 -1.54 a 1.49 1.49 0 0 0 -0.21 -0.56 a 0.89 0.89 0 0 0 -0.41 -0.33 A 1.51 1.51 0 0 0 171 22 a 1.43 1.43 0 0 0 -0.62 0.11 a 1 1 0 0 0 -0.41 0.34 A 1.45 1.45 0 0 0 169.69 23 Z m 0.81 0.29 a 1.89 1.89 0 0 1 0.06 -0.38 a 0.57 0.57 0 0 1 0.14 -0.24 a 0.35 0.35 0 0 1 0.25 -0.09 a 0.37 0.37 0 0 1 0.36 0.28 a 2.76 2.76 0 0 1 0.1 0.9 a 2.79 2.79 0 0 1 -0.1 0.91 a 0.37 0.37 0 0 1 -0.36 0.28 a 0.35 0.35 0 0 1 -0.25 -0.09 a 0.55 0.55 0 0 1 -0.14 -0.25 a 1.68 1.68 0 0 1 -0.06 -0.37 c 0 -0.15 0 -0.3 0 -0.48 S 170.49 23.42 170.5 23.27 Z m 2.91 2.16 l -0.87 -3.37 h 0.9 l 0.48 2.41 h 0 l 0.45 -2.41 h 0.87 l -0.85 3.37 Z m 2.28 -0.5 a 1.09 1.09 0 0 0 0.39 0.41 a 1.5 1.5 0 0 0 0.73 0.15 a 1.22 1.22 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.77 a 1.31 1.31 0 0 1 -0.14 0.48 a 0.36 0.36 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.45 0.45 0 0 1 -0.13 -0.17 a 0.72 0.72 0 0 1 -0.07 -0.25 a 1.5 1.5 0 0 1 0 -0.29 v -0.27 h 1.71 v -0.2 A 4.9 4.9 0 0 0 178 23 a 1.44 1.44 0 0 0 -0.19 -0.54 a 0.87 0.87 0 0 0 -0.37 -0.34 a 1.43 1.43 0 0 0 -0.62 -0.12 a 1.41 1.41 0 0 0 -0.7 0.14 a 0.94 0.94 0 0 0 -0.4 0.39 a 1.44 1.44 0 0 0 -0.19 0.55 a 4.62 4.62 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.77 1.77 0 0 0 175.69 24.93 Z m 0.68 -1.7 a 1 1 0 0 1 0 -0.24 a 0.52 0.52 0 0 1 0.07 -0.21 a 0.42 0.42 0 0 1 0.13 -0.16 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.33 0.33 0 0 1 0.21 0.06 a 0.34 0.34 0 0 1 0.14 0.15 a 0.92 0.92 0 0 1 0.06 0.25 c 0 0.1 0 0.21 0 0.34 h -0.89 Z m 3.09 2.2 h -0.87 V 22.06 h 0.83 v 0.45 h 0 a 1.24 1.24 0 0 1 0.32 -0.39 a 0.76 0.76 0 0 1 0.46 -0.14 h 0.15 v 0.82 h -0.27 a 0.83 0.83 0 0 0 -0.22 0 a 0.53 0.53 0 0 0 -0.21 0.11 a 0.54 0.54 0 0 0 -0.15 0.18 a 0.63 0.63 0 0 0 0 0.29 Z m 2.14 0 h -0.86 V 22.06 h 0.82 v 0.4 h 0 a 0.92 0.92 0 0 1 0.36 -0.37 a 1 1 0 0 1 0.5 -0.11 a 0.86 0.86 0 0 1 0.64 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 h -0.87 V 23.11 a 0.58 0.58 0 0 0 -0.08 -0.37 a 0.36 0.36 0 0 0 -0.28 -0.1 c -0.31 0 -0.46 0.18 -0.46 0.55 Z m 3.19 0 h -0.87 V 22.06 h 0.83 v 0.35 h 0 a 0.88 0.88 0 0 1 0.37 -0.33 a 1 1 0 0 1 0.48 -0.1 a 0.92 0.92 0 0 1 0.51 0.13 a 0.76 0.76 0 0 1 0.27 0.4 h 0 a 0.76 0.76 0 0 1 0.32 -0.4 a 1 1 0 0 1 0.53 -0.13 a 0.72 0.72 0 0 1 0.63 0.26 a 1.14 1.14 0 0 1 0.21 0.74 v 2.45 h -0.87 V 23.08 a 0.6 0.6 0 0 0 -0.07 -0.33 a 0.32 0.32 0 0 0 -0.26 -0.11 a 0.39 0.39 0 0 0 -0.33 0.14 a 0.63 0.63 0 0 0 -0.12 0.43 v 2.22 h -0.87 V 23.08 a 0.6 0.6 0 0 0 -0.07 -0.33 a 0.32 0.32 0 0 0 -0.26 -0.11 a 0.39 0.39 0 0 0 -0.33 0.14 a 0.63 0.63 0 0 0 -0.12 0.43 Z m 4 -0.5 a 1 1 0 0 0 0.39 0.41 a 1.47 1.47 0 0 0 0.73 0.15 a 1.23 1.23 0 0 0 0.91 -0.3 a 1.39 1.39 0 0 0 0.31 -0.9 h -0.78 a 1.16 1.16 0 0 1 -0.13 0.48 a 0.38 0.38 0 0 1 -0.32 0.16 a 0.32 0.32 0 0 1 -0.2 -0.07 a 0.37 0.37 0 0 1 -0.13 -0.17 a 1 1 0 0 1 -0.08 -0.25 c 0 -0.1 0 -0.2 0 -0.29 v -0.27 h 1.71 v -0.2 a 4.9 4.9 0 0 0 0 -0.7 a 1.64 1.64 0 0 0 -0.19 -0.54 a 0.9 0.9 0 0 0 -0.38 -0.34 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.41 1.41 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.41 0.39 a 1.62 1.62 0 0 0 -0.18 0.55 a 4.62 4.62 0 0 0 -0.05 0.65 c 0 0.22 0 0.43 0 0.64 A 1.77 1.77 0 0 0 188.78 24.93 Z m 0.68 -1.7 a 1.94 1.94 0 0 1 0 -0.24 a 0.76 0.76 0 0 1 0.08 -0.21 a 0.34 0.34 0 0 1 0.13 -0.16 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.35 0.35 0 0 1 0.21 0.06 a 0.28 0.28 0 0 1 0.13 0.15 a 0.91 0.91 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 h -0.88 Z m 3.08 2.2 h -0.86 V 22.06 h 0.83 v 0.4 h 0 a 0.9 0.9 0 0 1 0.35 -0.37 a 1 1 0 0 1 0.5 -0.11 a 0.86 0.86 0 0 1 0.64 0.22 a 1 1 0 0 1 0.22 0.73 v 2.5 h -0.86 V 23.11 a 0.57 0.57 0 0 0 -0.09 -0.37 a 0.34 0.34 0 0 0 -0.28 -0.1 c -0.3 0 -0.46 0.18 -0.46 0.55 Z m 2.52 -2.78 h -0.44 v -0.59 h 0.44 v -1 h 0.86 v 1 h 0.5 v 0.59 h -0.5 v 1.82 a 0.48 0.48 0 0 0 0.06 0.28 a 0.27 0.27 0 0 0 0.24 0.09 h 0.2 v 0.6 h -0.56 a 2.22 2.22 0 0 1 -0.41 0 a 0.41 0.41 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.42 2.42 0 0 1 0 -0.42 Z M 26.64 84.41 h -0.83 V 80 h 1 l 1.09 3 h 0 V 80 h 0.82 v 4.46 h -1 l -1.1 -3.12 h 0 Z M 29.43 82 v 0.08 h 0.78 V 82 a 0.46 0.46 0 0 1 0.1 -0.32 a 0.35 0.35 0 0 1 0.3 -0.12 a 0.38 0.38 0 0 1 0.31 0.11 A 0.45 0.45 0 0 1 31 82 a 0.4 0.4 0 0 1 -0.08 0.26 a 0.49 0.49 0 0 1 -0.27 0.13 l -0.49 0.14 a 2.35 2.35 0 0 0 -0.38 0.14 a 0.75 0.75 0 0 0 -0.26 0.2 a 0.86 0.86 0 0 0 -0.16 0.3 a 1.58 1.58 0 0 0 -0.05 0.41 a 1.4 1.4 0 0 0 0.05 0.34 a 1 1 0 0 0 0.14 0.31 a 0.58 0.58 0 0 0 0.25 0.21 a 0.86 0.86 0 0 0 0.38 0.08 a 1.43 1.43 0 0 0 0.51 -0.08 a 0.69 0.69 0 0 0 0.34 -0.34 h 0 a 1.16 1.16 0 0 0 0 0.18 a 0.49 0.49 0 0 0 0.06 0.17 h 0.83 a 1.8 1.8 0 0 1 -0.09 -0.28 a 3.26 3.26 0 0 1 0 -0.37 V 82 a 1.32 1.32 0 0 0 0 -0.41 a 0.74 0.74 0 0 0 -0.17 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.15 2.15 0 0 0 -0.63 -0.08 a 2.31 2.31 0 0 0 -0.46 0.05 a 1.06 1.06 0 0 0 -0.37 0.18 a 0.92 0.92 0 0 0 -0.26 0.32 A 1.16 1.16 0 0 0 29.43 82 Z M 31 83.39 a 0.6 0.6 0 0 1 -0.05 0.24 a 0.53 0.53 0 0 1 -0.13 0.16 a 0.56 0.56 0 0 1 -0.17 0.09 l -0.19 0 a 0.27 0.27 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 a 0.52 0.52 0 0 1 0.11 -0.35 a 0.68 0.68 0 0 1 0.38 -0.19 l 0.18 -0.06 a 0.93 0.93 0 0 0 0.19 -0.11 Z m 2.55 -2.34 h 0.5 v 0.59 h -0.5 v 1.81 a 0.65 0.65 0 0 0 0 0.29 a 0.32 0.32 0 0 0 0.25 0.08 h 0.2 v 0.6 h -0.57 a 1.62 1.62 0 0 1 -0.41 0 a 0.41 0.41 0 0 1 -0.24 -0.13 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.63 2.63 0 0 1 0 -0.43 V 81.64 h -0.43 v -0.59 h 0.43 v -1 h 0.87 Z m 0.89 -1.15 h 0.86 v 0.74 h -0.86 Z m 0 1.15 h 0.86 v 3.36 h -0.86 Z m 1.69 3 a 0.87 0.87 0 0 0 0.41 0.32 a 1.69 1.69 0 0 0 0.64 0.1 a 1.56 1.56 0 0 0 0.62 -0.11 a 0.89 0.89 0 0 0 0.41 -0.33 a 1.38 1.38 0 0 0 0.23 -0.55 a 3.45 3.45 0 0 0 0.07 -0.76 a 4.5 4.5 0 0 0 -0.06 -0.78 a 1.62 1.62 0 0 0 -0.22 -0.55 a 1 1 0 0 0 -0.4 -0.34 a 1.74 1.74 0 0 0 -0.65 -0.1 a 1.46 1.46 0 0 0 -0.62 0.12 a 1 1 0 0 0 -0.41 0.33 a 1.49 1.49 0 0 0 -0.22 0.56 a 3.45 3.45 0 0 0 -0.07 0.76 a 4.38 4.38 0 0 0 0.06 0.77 A 1.49 1.49 0 0 0 36.14 84.06 Z m 0.6 -1.81 a 1.79 1.79 0 0 1 0.06 -0.37 a 0.46 0.46 0 0 1 0.14 -0.24 a 0.37 0.37 0 0 1 0.25 -0.09 a 0.37 0.37 0 0 1 0.37 0.27 a 4.19 4.19 0 0 1 0 1.82 a 0.37 0.37 0 0 1 -0.37 0.27 a 0.37 0.37 0 0 1 -0.25 -0.09 a 0.57 0.57 0 0 1 -0.14 -0.24 a 1.78 1.78 0 0 1 -0.06 -0.38 c 0 -0.14 0 -0.3 0 -0.47 S 36.73 82.4 36.74 82.25 Z m 4.63 -1.06 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.3 0 -0.45 0.19 -0.45 0.56 v 2.23 H 39 V 81.05 h 0.83 v 0.39 h 0 a 0.83 0.83 0 0 1 0.36 -0.36 a 1 1 0 0 1 0.5 -0.12 A 0.85 0.85 0 0 1 41.37 81.19 Z m 3.25 2.57 V 82 a 1.73 1.73 0 0 0 0 -0.41 a 0.67 0.67 0 0 0 -0.18 -0.33 A 0.88 0.88 0 0 0 44 81 a 2.12 2.12 0 0 0 -0.62 -0.08 A 2.16 2.16 0 0 0 43 81 a 1.11 1.11 0 0 0 -0.38 0.18 a 0.8 0.8 0 0 0 -0.25 0.32 a 1.15 1.15 0 0 0 -0.1 0.49 v 0.08 H 43 V 82 a 0.46 0.46 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.37 0.37 0 0 1 0.31 0.11 a 0.45 0.45 0 0 1 0.09 0.3 a 0.4 0.4 0 0 1 -0.08 0.26 a 0.49 0.49 0 0 1 -0.26 0.13 l -0.49 0.14 a 2.49 2.49 0 0 0 -0.39 0.14 a 0.86 0.86 0 0 0 -0.26 0.2 a 0.71 0.71 0 0 0 -0.15 0.3 a 1.24 1.24 0 0 0 -0.05 0.41 a 1.37 1.37 0 0 0 0 0.34 a 1.23 1.23 0 0 0 0.14 0.31 a 0.58 0.58 0 0 0 0.25 0.21 a 0.86 0.86 0 0 0 0.38 0.08 a 1.43 1.43 0 0 0 0.51 -0.08 a 0.71 0.71 0 0 0 0.35 -0.34 h 0 a 1.16 1.16 0 0 0 0 0.18 a 0.51 0.51 0 0 0 0.07 0.17 h 0.82 a 1.09 1.09 0 0 1 -0.08 -0.28 A 1.77 1.77 0 0 1 44.62 83.76 Z m -0.82 -0.37 a 0.6 0.6 0 0 1 0 0.24 a 0.42 0.42 0 0 1 -0.13 0.16 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.08 -0.33 a 0.48 0.48 0 0 1 0.12 -0.35 a 0.65 0.65 0 0 1 0.37 -0.19 l 0.18 -0.06 a 0.72 0.72 0 0 0 0.19 -0.11 Z M 45.33 80 h 0.86 v 4.46 h -0.86 Z m 5.06 2.75 h 0.9 a 5 5 0 0 1 0 0.69 A 1.61 1.61 0 0 1 51 84 a 1.13 1.13 0 0 1 -0.43 0.38 a 1.69 1.69 0 0 1 -0.73 0.14 a 1.67 1.67 0 0 1 -0.8 -0.16 a 1.1 1.1 0 0 1 -0.46 -0.47 a 2 2 0 0 1 -0.21 -0.73 a 11.06 11.06 0 0 1 0 -1.88 a 2 2 0 0 1 0.21 -0.73 a 1.18 1.18 0 0 1 0.46 -0.48 a 1.67 1.67 0 0 1 0.8 -0.17 a 1.48 1.48 0 0 1 0.76 0.16 a 1 1 0 0 1 0.42 0.39 a 1.38 1.38 0 0 1 0.17 0.52 a 5.13 5.13 0 0 1 0 0.52 h -0.9 a 1.59 1.59 0 0 0 -0.12 -0.71 a 0.45 0.45 0 0 0 -0.42 -0.22 a 0.43 0.43 0 0 0 -0.28 0.09 a 0.61 0.61 0 0 0 -0.17 0.3 a 2.74 2.74 0 0 0 -0.09 0.53 c 0 0.22 0 0.49 0 0.8 s 0 0.61 0 0.82 a 1.55 1.55 0 0 0 0.11 0.48 a 0.39 0.39 0 0 0 0.18 0.24 a 0.49 0.49 0 0 0 0.25 0.06 a 0.54 0.54 0 0 0 0.22 0 a 0.34 0.34 0 0 0 0.18 -0.16 a 1 1 0 0 0 0.12 -0.34 A 3.13 3.13 0 0 0 50.39 82.7 Z M 53.53 81 h 0.08 v 0.83 h -0.27 a 0.83 0.83 0 0 0 -0.22 0 a 0.51 0.51 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.21 0.47 v 2 h -0.86 V 81.05 h 0.83 v 0.45 h 0 a 1.24 1.24 0 0 1 0.32 -0.39 a 0.7 0.7 0 0 1 0.45 -0.15 Z m 2.66 0.47 a 0.92 0.92 0 0 0 -0.38 -0.35 A 1.35 1.35 0 0 0 55.2 81 a 1.52 1.52 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.43 1.43 0 0 0 -0.19 0.56 a 4.51 4.51 0 0 0 0 0.65 c 0 0.21 0 0.42 0 0.64 a 1.71 1.71 0 0 0 0.15 0.57 a 1 1 0 0 0 0.39 0.41 a 1.36 1.36 0 0 0 0.73 0.16 a 1.18 1.18 0 0 0 0.91 -0.31 a 1.36 1.36 0 0 0 0.31 -0.89 H 55.6 a 1.16 1.16 0 0 1 -0.13 0.47 a 0.35 0.35 0 0 1 -0.32 0.16 a 0.27 0.27 0 0 1 -0.2 -0.07 a 0.37 0.37 0 0 1 -0.13 -0.17 a 0.66 0.66 0 0 1 -0.07 -0.25 a 1.36 1.36 0 0 1 0 -0.29 v -0.27 h 1.71 v -0.19 a 5 5 0 0 0 0 -0.71 A 1.33 1.33 0 0 0 56.19 81.43 Z m -1.47 0.92 v -0.13 a 1 1 0 0 1 0 -0.24 a 0.57 0.57 0 0 1 0.07 -0.22 a 0.47 0.47 0 0 1 0.13 -0.15 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.43 0.43 0 0 1 0.21 0 a 0.34 0.34 0 0 1 0.13 0.16 a 0.61 0.61 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 Z m 3.91 -1 h 0 a 1.1 1.1 0 0 0 -0.31 -0.3 a 0.82 0.82 0 0 0 -0.42 -0.1 a 0.85 0.85 0 0 0 -0.78 0.42 a 3.74 3.74 0 0 0 0 2.69 a 0.86 0.86 0 0 0 0.78 0.41 a 1 1 0 0 0 0.44 -0.09 a 0.88 0.88 0 0 0 0.32 -0.34 h 0 v 0.36 h 0.82 V 80 h -0.86 Z m -0.08 2.2 a 0.37 0.37 0 0 1 -0.38 0.28 a 0.35 0.35 0 0 1 -0.36 -0.28 a 3.87 3.87 0 0 1 0 -1.66 a 0.35 0.35 0 0 1 0.36 -0.28 a 0.37 0.37 0 0 1 0.38 0.28 a 4.35 4.35 0 0 1 0 1.66 Z m 1.61 -2.51 H 61 v 3.36 h -0.86 Z m 0 -1.15 H 61 v 0.74 h -0.86 Z m 2.58 1.15 h 0.5 v 0.59 h -0.5 v 1.81 a 0.52 0.52 0 0 0 0.06 0.29 a 0.31 0.31 0 0 0 0.25 0.08 h 0.19 v 0.6 h -0.56 a 1.58 1.58 0 0 1 -0.41 0 a 0.35 0.35 0 0 1 -0.24 -0.13 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.63 2.63 0 0 1 0 -0.43 V 81.64 h -0.44 v -0.59 h 0.44 v -1 h 0.86 Z M 67.09 80 H 68 v 3.11 a 1.76 1.76 0 0 1 -0.12 0.7 a 1.07 1.07 0 0 1 -0.32 0.44 a 1 1 0 0 1 -0.46 0.22 a 2.33 2.33 0 0 1 -0.53 0.06 a 3.07 3.07 0 0 1 -0.53 0 a 1.12 1.12 0 0 1 -0.46 -0.2 a 1.14 1.14 0 0 1 -0.32 -0.44 a 2.12 2.12 0 0 1 -0.11 -0.73 V 80 H 66 v 3.11 a 1.51 1.51 0 0 0 0 0.31 a 0.62 0.62 0 0 0 0.08 0.24 a 0.44 0.44 0 0 0 0.16 0.17 a 0.53 0.53 0 0 0 0.26 0.06 a 0.48 0.48 0 0 0 0.26 -0.06 a 0.44 0.44 0 0 0 0.16 -0.17 a 0.62 0.62 0 0 0 0.08 -0.24 a 1.48 1.48 0 0 0 0 -0.31 Z m 3.83 1.24 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.3 0 -0.46 0.19 -0.46 0.56 v 2.23 h -0.86 V 81.05 h 0.83 v 0.39 h 0 a 0.83 0.83 0 0 1 0.36 -0.36 a 1 1 0 0 1 0.5 -0.12 A 0.85 0.85 0 0 1 70.92 81.19 Z m 0.89 -1.29 h 0.86 v 0.74 h -0.86 Z m 0 1.15 h 0.86 v 3.36 h -0.86 Z m 3.79 0.35 a 1 1 0 0 0 -0.4 -0.34 a 1.74 1.74 0 0 0 -0.65 -0.1 a 1.46 1.46 0 0 0 -0.62 0.12 a 1 1 0 0 0 -0.41 0.33 a 1.49 1.49 0 0 0 -0.22 0.56 a 3.45 3.45 0 0 0 -0.07 0.76 a 4.38 4.38 0 0 0 0.06 0.77 a 1.49 1.49 0 0 0 0.21 0.56 a 0.87 0.87 0 0 0 0.41 0.32 a 1.72 1.72 0 0 0 0.64 0.1 a 1.65 1.65 0 0 0 0.63 -0.11 a 0.94 0.94 0 0 0 0.41 -0.33 a 1.38 1.38 0 0 0 0.22 -0.55 a 3.45 3.45 0 0 0 0.07 -0.76 a 4.5 4.5 0 0 0 -0.06 -0.78 A 1.44 1.44 0 0 0 75.6 81.4 Z m -0.68 2.24 a 0.37 0.37 0 0 1 -0.37 0.27 a 0.37 0.37 0 0 1 -0.25 -0.09 a 0.69 0.69 0 0 1 -0.14 -0.24 a 1.78 1.78 0 0 1 -0.06 -0.38 c 0 -0.14 0 -0.3 0 -0.47 s 0 -0.33 0 -0.48 a 1.79 1.79 0 0 1 0.06 -0.37 a 0.54 0.54 0 0 1 0.14 -0.24 a 0.37 0.37 0 0 1 0.25 -0.09 a 0.37 0.37 0 0 1 0.37 0.27 a 4.19 4.19 0 0 1 0 1.82 Z m 3.81 -2.45 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.33 0.33 0 0 0 -0.28 -0.11 c -0.3 0 -0.45 0.19 -0.45 0.56 v 2.23 H 76.4 V 81.05 h 0.83 v 0.39 h 0 a 0.83 0.83 0 0 1 0.36 -0.36 a 1 1 0 0 1 0.5 -0.12 A 0.85 0.85 0 0 1 78.73 81.19 Z M 81.82 80 l -1.18 4.46 h 0.93 l 0.21 -0.94 H 83 l 0.2 0.94 h 0.94 L 82.93 80 Z m 0.12 2.78 l 0.43 -2 h 0 l 0.43 2 Z m 4.21 -1.37 h 0 a 1.24 1.24 0 0 0 -0.31 -0.3 a 0.82 0.82 0 0 0 -0.42 -0.1 a 0.85 0.85 0 0 0 -0.78 0.42 a 3.74 3.74 0 0 0 0 2.69 a 0.86 0.86 0 0 0 0.78 0.41 a 1 1 0 0 0 0.44 -0.09 a 0.88 0.88 0 0 0 0.32 -0.34 h 0 v 0.36 H 87 V 80 h -0.86 Z m -0.09 2.2 a 0.36 0.36 0 0 1 -0.37 0.28 a 0.35 0.35 0 0 1 -0.36 -0.28 a 3.87 3.87 0 0 1 0 -1.66 a 0.35 0.35 0 0 1 0.36 -0.28 a 0.36 0.36 0 0 1 0.37 0.28 a 3.87 3.87 0 0 1 0 1.66 Z m 5.55 -2.34 a 1.22 1.22 0 0 1 0.2 0.75 v 2.44 H 91 V 82.06 a 0.56 0.56 0 0 0 -0.08 -0.32 a 0.29 0.29 0 0 0 -0.26 -0.12 a 0.42 0.42 0 0 0 -0.33 0.14 a 0.66 0.66 0 0 0 -0.12 0.44 v 2.21 H 89.3 V 82.06 a 0.56 0.56 0 0 0 -0.08 -0.32 a 0.29 0.29 0 0 0 -0.26 -0.12 a 0.42 0.42 0 0 0 -0.33 0.14 a 0.66 0.66 0 0 0 -0.12 0.44 v 2.21 h -0.86 V 81.05 h 0.82 v 0.34 h 0 a 1 1 0 0 1 0.36 -0.33 a 1.07 1.07 0 0 1 0.49 -0.1 a 0.89 0.89 0 0 1 0.5 0.14 a 0.69 0.69 0 0 1 0.27 0.4 h 0 a 0.74 0.74 0 0 1 0.33 -0.4 A 1 1 0 0 1 91 81 A 0.78 0.78 0 0 1 91.61 81.22 Z m 0.87 -0.17 h 0.86 v 3.36 h -0.86 Z m 0 -1.15 h 0.86 v 0.74 h -0.86 Z m 3.86 1.29 a 1 1 0 0 1 0.22 0.73 v 2.49 H 95.7 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.3 0 -0.46 0.19 -0.46 0.56 v 2.23 H 94 V 81.05 h 0.83 v 0.39 h 0 a 0.87 0.87 0 0 1 0.35 -0.36 a 1.06 1.06 0 0 1 0.5 -0.12 A 0.86 0.86 0 0 1 96.34 81.19 Z m 0.89 -0.14 h 0.86 v 3.36 h -0.86 Z m 0 -1.15 h 0.86 v 0.74 h -0.86 Z m 3.71 2.94 a 1 1 0 0 1 0.16 0.6 a 1.13 1.13 0 0 1 -0.09 0.47 a 0.93 0.93 0 0 1 -0.26 0.33 a 1 1 0 0 1 -0.39 0.18 a 2 2 0 0 1 -0.51 0.06 a 2.06 2.06 0 0 1 -0.6 -0.07 a 0.82 0.82 0 0 1 -0.38 -0.21 a 0.79 0.79 0 0 1 -0.2 -0.33 a 2 2 0 0 1 0 -0.44 v -0.12 h 0.77 v 0.11 a 0.52 0.52 0 0 0 0.12 0.36 a 0.4 0.4 0 0 0 0.33 0.13 a 0.46 0.46 0 0 0 0.32 -0.1 a 0.38 0.38 0 0 0 0.12 -0.3 a 0.33 0.33 0 0 0 -0.09 -0.25 a 1 1 0 0 0 -0.22 -0.13 l -0.61 -0.22 a 1.13 1.13 0 0 1 -0.54 -0.35 a 0.92 0.92 0 0 1 -0.18 -0.59 a 1.07 1.07 0 0 1 0.07 -0.39 a 0.87 0.87 0 0 1 0.22 -0.32 a 1.27 1.27 0 0 1 0.38 -0.22 a 1.91 1.91 0 0 1 0.57 -0.08 a 1.27 1.27 0 0 1 0.87 0.25 a 0.89 0.89 0 0 1 0.28 0.71 v 0.13 h -0.78 a 0.65 0.65 0 0 0 -0.08 -0.38 a 0.35 0.35 0 0 0 -0.3 -0.12 a 0.45 0.45 0 0 0 -0.28 0.09 a 0.32 0.32 0 0 0 -0.12 0.27 a 0.34 0.34 0 0 0 0.08 0.23 a 0.6 0.6 0 0 0 0.29 0.16 l 0.52 0.18 A 1.21 1.21 0 0 1 100.94 82.84 Z m 1.71 -1.79 h 0.5 v 0.59 h -0.5 v 1.81 a 0.52 0.52 0 0 0 0.06 0.29 a 0.3 0.3 0 0 0 0.24 0.08 h 0.2 v 0.6 h -0.56 a 1.53 1.53 0 0 1 -0.41 0 a 0.4 0.4 0 0 1 -0.25 -0.13 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.63 2.63 0 0 1 0 -0.43 V 81.64 h -0.44 v -0.59 h 0.44 v -1 h 0.86 Z M 105.2 81 h 0.08 v 0.83 H 105 a 0.83 0.83 0 0 0 -0.22 0 a 0.51 0.51 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.21 0.47 v 2 h -0.86 V 81.05 h 0.83 v 0.45 h 0 a 1.24 1.24 0 0 1 0.32 -0.39 a 0.68 0.68 0 0 1 0.45 -0.15 Z m 2.85 2.8 V 82 a 1.7 1.7 0 0 0 0 -0.41 a 0.67 0.67 0 0 0 -0.18 -0.33 a 0.82 0.82 0 0 0 -0.37 -0.21 a 2 2 0 0 0 -0.62 -0.08 a 2.24 2.24 0 0 0 -0.46 0.05 a 1.21 1.21 0 0 0 -0.38 0.18 a 0.89 0.89 0 0 0 -0.25 0.32 a 1.16 1.16 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 82 a 0.51 0.51 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.36 0.36 0 0 1 0.31 0.11 a 0.45 0.45 0 0 1 0.09 0.3 a 0.4 0.4 0 0 1 -0.07 0.26 a 0.49 0.49 0 0 1 -0.27 0.13 l -0.49 0.14 a 2 2 0 0 0 -0.38 0.14 a 0.79 0.79 0 0 0 -0.27 0.2 a 0.84 0.84 0 0 0 -0.15 0.3 a 1.58 1.58 0 0 0 0 0.41 a 1.4 1.4 0 0 0 0 0.34 a 0.93 0.93 0 0 0 0.13 0.31 a 0.72 0.72 0 0 0 0.25 0.21 a 0.89 0.89 0 0 0 0.38 0.08 a 1.43 1.43 0 0 0 0.51 -0.08 a 0.71 0.71 0 0 0 0.35 -0.34 h 0 a 1.16 1.16 0 0 1 0 0.18 a 0.87 0.87 0 0 0 0.07 0.17 h 0.82 a 1.09 1.09 0 0 1 -0.08 -0.28 A 3.26 3.26 0 0 1 108.05 83.76 Z m -0.83 -0.37 a 0.47 0.47 0 0 1 0 0.24 a 0.34 0.34 0 0 1 -0.13 0.16 a 0.46 0.46 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.07 -0.33 a 0.48 0.48 0 0 1 0.11 -0.35 a 0.65 0.65 0 0 1 0.37 -0.19 l 0.19 -0.06 a 0.87 0.87 0 0 0 0.18 -0.11 Z m 2.55 -2.34 h 0.5 v 0.59 h -0.5 v 1.81 a 0.52 0.52 0 0 0 0.06 0.29 a 0.31 0.31 0 0 0 0.25 0.08 h 0.19 v 0.6 h -0.56 a 1.58 1.58 0 0 1 -0.41 0 a 0.35 0.35 0 0 1 -0.24 -0.13 a 0.56 0.56 0 0 1 -0.12 -0.27 a 2.63 2.63 0 0 1 0 -0.43 V 81.64 h -0.44 v -0.59 h 0.44 v -1 h 0.86 Z m 1.76 3.36 h -0.86 V 81.05 h 0.86 Z m 0 -3.77 h -0.86 V 79.9 h 0.86 Z m 2.93 0.76 a 1 1 0 0 0 -0.41 -0.34 a 1.69 1.69 0 0 0 -0.64 -0.1 a 1.43 1.43 0 0 0 -0.62 0.12 a 1 1 0 0 0 -0.41 0.33 a 1.69 1.69 0 0 0 -0.23 0.56 a 4.26 4.26 0 0 0 -0.06 0.76 a 4.38 4.38 0 0 0 0.06 0.77 a 1.49 1.49 0 0 0 0.21 0.56 a 0.87 0.87 0 0 0 0.41 0.32 a 1.69 1.69 0 0 0 0.64 0.1 a 1.6 1.6 0 0 0 0.62 -0.11 a 0.89 0.89 0 0 0 0.41 -0.33 a 1.38 1.38 0 0 0 0.23 -0.55 a 4.19 4.19 0 0 0 0.07 -0.76 a 4.43 4.43 0 0 0 -0.07 -0.78 A 1.44 1.44 0 0 0 114.46 81.4 Z m -0.69 2.24 a 0.35 0.35 0 0 1 -0.36 0.27 a 0.35 0.35 0 0 1 -0.25 -0.09 a 0.57 0.57 0 0 1 -0.14 -0.24 a 1.78 1.78 0 0 1 -0.06 -0.38 c 0 -0.14 0 -0.3 0 -0.47 s 0 -0.33 0 -0.48 a 1.79 1.79 0 0 1 0.06 -0.37 a 0.46 0.46 0 0 1 0.14 -0.24 a 0.35 0.35 0 0 1 0.25 -0.09 a 0.35 0.35 0 0 1 0.36 0.27 a 4.19 4.19 0 0 1 0 1.82 Z m 3.82 -2.45 a 1 1 0 0 1 0.22 0.73 v 2.49 H 117 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.31 0 -0.46 0.19 -0.46 0.56 v 2.23 h -0.86 V 81.05 h 0.82 v 0.39 h 0 a 0.87 0.87 0 0 1 0.35 -0.36 A 1.06 1.06 0 0 1 117 81 A 0.86 0.86 0 0 1 117.59 81.19 Z m 0.91 2.25 h 0.82 v 0.81 a 3.15 3.15 0 0 1 0 0.44 a 1 1 0 0 1 -0.13 0.36 a 0.75 0.75 0 0 1 -0.25 0.25 a 0.86 0.86 0 0 1 -0.41 0.12 V 85 a 0.34 0.34 0 0 0 0.24 -0.18 a 0.59 0.59 0 0 0 0.08 -0.32 v -0.08 h -0.32 Z m 5.24 0.32 V 82 a 1.7 1.7 0 0 0 0 -0.41 a 0.67 0.67 0 0 0 -0.18 -0.33 a 0.88 0.88 0 0 0 -0.37 -0.21 a 2.12 2.12 0 0 0 -0.62 -0.08 a 2.16 2.16 0 0 0 -0.46 0.05 a 1.11 1.11 0 0 0 -0.38 0.18 a 0.89 0.89 0 0 0 -0.25 0.32 a 1.16 1.16 0 0 0 -0.09 0.49 v 0.08 h 0.77 V 82 a 0.46 0.46 0 0 1 0.1 -0.32 a 0.38 0.38 0 0 1 0.3 -0.12 a 0.36 0.36 0 0 1 0.31 0.11 a 0.45 0.45 0 0 1 0.09 0.3 a 0.35 0.35 0 0 1 -0.08 0.26 a 0.45 0.45 0 0 1 -0.26 0.13 l -0.49 0.14 a 2.49 2.49 0 0 0 -0.39 0.14 a 0.86 0.86 0 0 0 -0.26 0.2 a 0.71 0.71 0 0 0 -0.15 0.3 a 1.58 1.58 0 0 0 0 0.41 a 1.37 1.37 0 0 0 0 0.34 a 1.23 1.23 0 0 0 0.14 0.31 a 0.64 0.64 0 0 0 0.25 0.21 a 0.86 0.86 0 0 0 0.38 0.08 a 1.43 1.43 0 0 0 0.51 -0.08 a 0.71 0.71 0 0 0 0.35 -0.34 h 0 c 0 0.06 0 0.12 0 0.18 a 0.87 0.87 0 0 0 0.07 0.17 h 0.82 a 1.09 1.09 0 0 1 -0.08 -0.28 A 1.89 1.89 0 0 1 123.74 83.76 Z m -0.83 -0.37 a 0.6 0.6 0 0 1 0 0.24 a 0.42 0.42 0 0 1 -0.13 0.16 a 0.56 0.56 0 0 1 -0.17 0.09 a 0.57 0.57 0 0 1 -0.18 0 a 0.26 0.26 0 0 1 -0.25 -0.14 a 0.67 0.67 0 0 1 -0.08 -0.33 a 0.48 0.48 0 0 1 0.12 -0.35 a 0.65 0.65 0 0 1 0.37 -0.19 a 0.64 0.64 0 0 0 0.18 -0.06 a 0.72 0.72 0 0 0 0.19 -0.11 Z m 5 -3.44 h 0.9 v 3.11 a 1.76 1.76 0 0 1 -0.12 0.7 a 1 1 0 0 1 -0.32 0.44 a 1 1 0 0 1 -0.45 0.22 a 2.33 2.33 0 0 1 -0.53 0.06 a 3 3 0 0 1 -0.53 0 a 1 1 0 0 1 -0.46 -0.2 a 1.14 1.14 0 0 1 -0.32 -0.44 a 1.89 1.89 0 0 1 -0.12 -0.73 V 80 h 0.9 v 3.11 a 2.85 2.85 0 0 0 0 0.31 a 0.85 0.85 0 0 0 0.08 0.24 a 0.46 0.46 0 0 0 0.17 0.17 a 0.5 0.5 0 0 0 0.26 0.06 a 0.53 0.53 0 0 0 0.26 -0.06 a 0.44 0.44 0 0 0 0.16 -0.17 a 0.62 0.62 0 0 0 0.08 -0.24 a 2.85 2.85 0 0 0 0 -0.31 Z m 1.56 3.49 h 0.82 v 1 h -0.82 Z m 4.29 -0.69 a 1.53 1.53 0 0 1 0 0.38 a 1.25 1.25 0 0 1 -0.41 1 a 1.82 1.82 0 0 1 -1.14 0.32 a 1.5 1.5 0 0 1 -1.09 -0.33 a 1.29 1.29 0 0 1 -0.33 -1 V 83 h 0.9 v 0.13 a 2.3 2.3 0 0 0 0 0.28 a 0.5 0.5 0 0 0 0.1 0.22 a 0.51 0.51 0 0 0 0.18 0.14 a 0.84 0.84 0 0 0 0.29 0 a 0.59 0.59 0 0 0 0.38 -0.14 a 0.5 0.5 0 0 0 0.16 -0.41 a 0.68 0.68 0 0 0 0 -0.26 a 0.53 0.53 0 0 0 -0.13 -0.2 a 1.2 1.2 0 0 0 -0.25 -0.16 a 3 3 0 0 0 -0.38 -0.15 a 2.8 2.8 0 0 1 -0.52 -0.22 a 1.26 1.26 0 0 1 -0.36 -0.27 a 1.07 1.07 0 0 1 -0.22 -0.37 a 1.75 1.75 0 0 1 -0.07 -0.49 a 1.21 1.21 0 0 1 0.37 -1 a 1.46 1.46 0 0 1 1 -0.33 a 2 2 0 0 1 0.56 0.07 a 1 1 0 0 1 0.43 0.21 a 1 1 0 0 1 0.29 0.37 a 1.35 1.35 0 0 1 0.1 0.55 v 0.13 h -0.86 a 1 1 0 0 0 -0.11 -0.5 a 0.43 0.43 0 0 0 -0.38 -0.17 a 0.62 0.62 0 0 0 -0.25 0 a 0.42 0.42 0 0 0 -0.15 0.11 a 0.56 0.56 0 0 0 -0.09 0.17 a 1.23 1.23 0 0 0 0 0.19 a 0.65 0.65 0 0 0 0.09 0.35 a 0.82 0.82 0 0 0 0.37 0.26 l 0.7 0.3 a 2 2 0 0 1 0.42 0.23 a 1.28 1.28 0 0 1 0.26 0.26 A 0.93 0.93 0 0 1 133.74 82.75 Z m 0.58 0.69 h 0.82 v 1 h -0.82 Z m 4.3 -1.44 h 1.46 v 2.41 h -0.66 V 84 h 0 a 1 1 0 0 1 -0.39 0.37 a 1.27 1.27 0 0 1 -0.54 0.11 a 1.49 1.49 0 0 1 -0.68 -0.14 a 1 1 0 0 1 -0.4 -0.45 a 2.16 2.16 0 0 1 -0.2 -0.74 a 9.93 9.93 0 0 1 -0.05 -1 a 5.83 5.83 0 0 1 0.07 -1 a 2 2 0 0 1 0.25 -0.71 a 1.19 1.19 0 0 1 0.46 -0.43 a 1.68 1.68 0 0 1 0.72 -0.14 a 1.32 1.32 0 0 1 1.06 0.37 a 1.49 1.49 0 0 1 0.33 1 h -0.86 a 1.07 1.07 0 0 0 0 -0.25 a 0.85 0.85 0 0 0 -0.09 -0.24 a 0.6 0.6 0 0 0 -0.16 -0.19 a 0.45 0.45 0 0 0 -0.24 -0.07 a 0.5 0.5 0 0 0 -0.47 0.37 a 3.73 3.73 0 0 0 -0.14 1.2 q 0 0.39 0 0.72 a 2 2 0 0 0 0.09 0.55 a 0.72 0.72 0 0 0 0.18 0.35 a 0.46 0.46 0 0 0 0.32 0.13 a 0.49 0.49 0 0 0 0.18 0 a 0.68 0.68 0 0 0 0.18 -0.13 a 0.69 0.69 0 0 0 0.14 -0.22 a 0.79 0.79 0 0 0 0.06 -0.32 v -0.45 h -0.6 Z m 4.34 -0.6 a 1 1 0 0 0 -0.41 -0.34 a 1.69 1.69 0 0 0 -0.64 -0.1 a 1.43 1.43 0 0 0 -0.62 0.12 a 1 1 0 0 0 -0.41 0.33 a 1.5 1.5 0 0 0 -0.23 0.56 a 4.19 4.19 0 0 0 -0.07 0.76 a 4.31 4.31 0 0 0 0.07 0.77 a 1.49 1.49 0 0 0 0.21 0.56 a 0.87 0.87 0 0 0 0.41 0.32 a 1.69 1.69 0 0 0 0.64 0.1 a 1.6 1.6 0 0 0 0.62 -0.11 a 0.89 0.89 0 0 0 0.41 -0.33 a 1.55 1.55 0 0 0 0.23 -0.55 a 4.26 4.26 0 0 0 0.06 -0.76 a 4.5 4.5 0 0 0 -0.06 -0.78 A 1.44 1.44 0 0 0 143 81.4 Z m -0.69 2.24 a 0.36 0.36 0 0 1 -0.36 0.27 a 0.35 0.35 0 0 1 -0.25 -0.09 a 0.57 0.57 0 0 1 -0.14 -0.24 a 1.78 1.78 0 0 1 -0.06 -0.38 c 0 -0.14 0 -0.3 0 -0.47 s 0 -0.33 0 -0.48 a 1.79 1.79 0 0 1 0.06 -0.37 a 0.46 0.46 0 0 1 0.14 -0.24 a 0.35 0.35 0 0 1 0.25 -0.09 a 0.36 0.36 0 0 1 0.36 0.27 a 4.19 4.19 0 0 1 0 1.82 Z m 3.08 -2.59 h 0.87 l -0.85 3.36 h -1 l -0.87 -3.36 h 0.9 l 0.48 2.4 h 0 Z m 3.45 0.38 a 0.92 0.92 0 0 0 -0.38 -0.35 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.52 1.52 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.43 1.43 0 0 0 -0.19 0.56 a 4.51 4.51 0 0 0 -0.05 0.65 c 0 0.21 0 0.42 0 0.64 a 1.71 1.71 0 0 0 0.15 0.57 a 1 1 0 0 0 0.39 0.41 a 1.39 1.39 0 0 0 0.73 0.16 a 1.18 1.18 0 0 0 0.91 -0.31 a 1.36 1.36 0 0 0 0.31 -0.89 h -0.77 a 1.32 1.32 0 0 1 -0.14 0.47 a 0.35 0.35 0 0 1 -0.32 0.16 a 0.27 0.27 0 0 1 -0.2 -0.07 a 0.37 0.37 0 0 1 -0.13 -0.17 a 0.66 0.66 0 0 1 -0.07 -0.25 a 1.36 1.36 0 0 1 0 -0.29 v -0.27 H 149 v -0.19 a 5 5 0 0 0 0 -0.71 A 1.33 1.33 0 0 0 148.8 81.43 Z m -1.47 0.92 v -0.13 a 1 1 0 0 1 0 -0.24 a 0.57 0.57 0 0 1 0.07 -0.22 a 0.47 0.47 0 0 1 0.13 -0.15 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.41 0.41 0 0 1 0.21 0 a 0.34 0.34 0 0 1 0.13 0.16 a 0.61 0.61 0 0 1 0.07 0.25 c 0 0.1 0 0.21 0 0.34 Z M 151.24 81 h 0.08 v 0.83 h -0.27 a 0.83 0.83 0 0 0 -0.22 0 a 0.51 0.51 0 0 0 -0.21 0.1 a 0.58 0.58 0 0 0 -0.15 0.19 a 0.59 0.59 0 0 0 -0.05 0.28 v 2 h -0.87 V 81.05 h 0.83 v 0.45 h 0 a 1.24 1.24 0 0 1 0.32 -0.39 a 0.71 0.71 0 0 1 0.46 -0.15 Z m 2.79 0.23 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.87 V 82.09 a 0.55 0.55 0 0 0 -0.08 -0.36 a 0.36 0.36 0 0 0 -0.28 -0.11 c -0.31 0 -0.46 0.19 -0.46 0.56 v 2.23 h -0.86 V 81.05 h 0.82 v 0.39 h 0 a 0.89 0.89 0 0 1 0.36 -0.36 a 1 1 0 0 1 0.5 -0.12 A 0.86 0.86 0 0 1 154 81.19 Z m 4.81 0 a 1.16 1.16 0 0 1 0.21 0.75 v 2.44 h -0.87 V 82.06 a 0.56 0.56 0 0 0 -0.07 -0.32 a 0.3 0.3 0 0 0 -0.26 -0.12 a 0.42 0.42 0 0 0 -0.33 0.14 a 0.66 0.66 0 0 0 -0.12 0.44 v 2.21 h -0.87 V 82.06 a 0.56 0.56 0 0 0 -0.07 -0.32 a 0.3 0.3 0 0 0 -0.26 -0.12 a 0.42 0.42 0 0 0 -0.33 0.14 a 0.66 0.66 0 0 0 -0.12 0.44 v 2.21 h -0.87 V 81.05 h 0.83 v 0.34 h 0 a 1 1 0 0 1 0.37 -0.33 a 1 1 0 0 1 0.48 -0.1 a 0.87 0.87 0 0 1 0.5 0.14 a 0.66 0.66 0 0 1 0.28 0.4 h 0 a 0.72 0.72 0 0 1 0.32 -0.4 a 1 1 0 0 1 0.53 -0.14 A 0.75 0.75 0 0 1 158.84 81.22 Z m 3 0.21 a 0.92 0.92 0 0 0 -0.38 -0.35 a 1.35 1.35 0 0 0 -0.61 -0.12 a 1.5 1.5 0 0 0 -0.7 0.14 a 1.1 1.1 0 0 0 -0.41 0.39 a 1.6 1.6 0 0 0 -0.18 0.56 a 4.51 4.51 0 0 0 -0.05 0.65 c 0 0.21 0 0.42 0 0.64 a 1.71 1.71 0 0 0 0.15 0.57 a 0.91 0.91 0 0 0 0.39 0.41 a 1.36 1.36 0 0 0 0.73 0.16 a 1.19 1.19 0 0 0 0.91 -0.31 a 1.36 1.36 0 0 0 0.31 -0.89 h -0.78 a 1.16 1.16 0 0 1 -0.13 0.47 a 0.35 0.35 0 0 1 -0.32 0.16 a 0.27 0.27 0 0 1 -0.2 -0.07 a 0.37 0.37 0 0 1 -0.13 -0.17 a 0.92 0.92 0 0 1 -0.08 -0.25 a 2.64 2.64 0 0 1 0 -0.29 v -0.27 h 1.71 v -0.19 a 5 5 0 0 0 0 -0.71 A 1.5 1.5 0 0 0 161.89 81.43 Z m -1.47 0.92 v -0.13 a 1.94 1.94 0 0 1 0 -0.24 a 0.83 0.83 0 0 1 0.08 -0.22 a 0.37 0.37 0 0 1 0.13 -0.15 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.43 0.43 0 0 1 0.21 0 a 0.34 0.34 0 0 1 0.13 0.16 a 0.82 0.82 0 0 1 0.07 0.25 a 3.28 3.28 0 0 1 0 0.34 Z M 165 81.19 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.3 0 -0.46 0.19 -0.46 0.56 v 2.23 h -0.86 V 81.05 h 0.83 v 0.39 h 0 a 0.87 0.87 0 0 1 0.35 -0.36 a 1.06 1.06 0 0 1 0.5 -0.12 A 0.86 0.86 0 0 1 165 81.19 Z m 1.91 -0.14 h 0.5 v 0.59 h -0.5 v 1.81 a 0.52 0.52 0 0 0 0.06 0.29 a 0.3 0.3 0 0 0 0.24 0.08 h 0.2 v 0.6 h -0.56 a 1.53 1.53 0 0 1 -0.41 0 a 0.4 0.4 0 0 1 -0.25 -0.13 a 0.67 0.67 0 0 1 -0.11 -0.27 a 2.63 2.63 0 0 1 0 -0.43 V 81.64 h -0.44 v -0.59 H 166 v -1 h 0.86 Z M 170 80 l -1.19 4.46 h 0.94 l 0.21 -0.94 h 1.19 l 0.2 0.94 h 0.94 L 171.08 80 Z m 0.11 2.78 l 0.44 -2 h 0 l 0.43 2 Z m 4.22 -1.31 h 0 a 0.76 0.76 0 0 0 -0.69 -0.46 a 0.87 0.87 0 0 0 -0.56 0.16 a 1 1 0 0 0 -0.32 0.4 a 1.85 1.85 0 0 0 -0.14 0.55 a 4.22 4.22 0 0 0 0 0.6 A 2.48 2.48 0 0 0 172.8 84 a 0.86 0.86 0 0 0 0.77 0.39 a 0.73 0.73 0 0 0 0.4 -0.11 a 0.91 0.91 0 0 0 0.32 -0.3 h 0 v 0.44 a 0.77 0.77 0 0 1 -0.1 0.42 a 0.39 0.39 0 0 1 -0.37 0.17 l -0.16 0 l -0.13 -0.07 a 0.29 0.29 0 0 1 -0.13 -0.26 h -0.83 a 0.81 0.81 0 0 0 0.3 0.67 a 1.39 1.39 0 0 0 0.85 0.23 a 1.53 1.53 0 0 0 1.08 -0.32 a 1.38 1.38 0 0 0 0.32 -1 V 81.05 h -0.83 Z m 0 1.72 a 1.11 1.11 0 0 1 -0.07 0.3 a 0.53 0.53 0 0 1 -0.15 0.2 a 0.33 0.33 0 0 1 -0.23 0.07 a 0.32 0.32 0 0 1 -0.22 -0.07 a 0.5 0.5 0 0 1 -0.13 -0.2 a 1.07 1.07 0 0 1 -0.06 -0.27 c 0 -0.11 0 -0.22 0 -0.33 s 0 -0.42 0 -0.58 a 1.58 1.58 0 0 1 0.06 -0.37 a 0.4 0.4 0 0 1 0.14 -0.2 a 0.35 0.35 0 0 1 0.23 -0.07 a 0.37 0.37 0 0 1 0.36 0.26 a 2.92 2.92 0 0 1 0.09 0.87 A 2.42 2.42 0 0 1 174.28 83.14 Z m 3.35 -2.06 A 1.43 1.43 0 0 0 177 81 a 1.52 1.52 0 0 0 -0.7 0.14 a 1 1 0 0 0 -0.4 0.39 a 1.43 1.43 0 0 0 -0.19 0.56 a 4.51 4.51 0 0 0 -0.05 0.65 c 0 0.21 0 0.42 0 0.64 a 1.71 1.71 0 0 0 0.15 0.57 a 1 1 0 0 0 0.39 0.41 a 1.39 1.39 0 0 0 0.73 0.16 a 1.18 1.18 0 0 0 0.91 -0.31 a 1.36 1.36 0 0 0 0.31 -0.89 h -0.77 a 1.32 1.32 0 0 1 -0.14 0.47 a 0.34 0.34 0 0 1 -0.32 0.16 a 0.27 0.27 0 0 1 -0.2 -0.07 a 0.45 0.45 0 0 1 -0.13 -0.17 a 0.66 0.66 0 0 1 -0.07 -0.25 a 1.36 1.36 0 0 1 0 -0.29 v -0.27 h 1.71 v -0.19 a 5 5 0 0 0 -0.05 -0.71 a 1.33 1.33 0 0 0 -0.19 -0.53 A 0.89 0.89 0 0 0 177.63 81.08 Z m -1.1 1.27 v -0.13 a 1 1 0 0 1 0 -0.24 a 0.57 0.57 0 0 1 0.07 -0.22 a 0.47 0.47 0 0 1 0.13 -0.15 a 0.38 0.38 0 0 1 0.22 -0.06 a 0.41 0.41 0 0 1 0.21 0 a 0.44 0.44 0 0 1 0.14 0.16 a 0.83 0.83 0 0 1 0.06 0.25 c 0 0.1 0 0.21 0 0.34 Z M 180 81.08 a 1 1 0 0 1 0.5 -0.12 a 0.85 0.85 0 0 1 0.63 0.23 a 1 1 0 0 1 0.22 0.73 v 2.49 h -0.86 V 82.09 a 0.54 0.54 0 0 0 -0.09 -0.36 a 0.35 0.35 0 0 0 -0.28 -0.11 c -0.3 0 -0.45 0.19 -0.45 0.56 v 2.23 h -0.87 V 81.05 h 0.83 v 0.39 h 0 A 0.83 0.83 0 0 1 180 81.08 Z m 2.75 1.15 a 3.86 3.86 0 0 0 0 0.51 a 4.27 4.27 0 0 0 0 0.53 a 1.22 1.22 0 0 0 0.07 0.37 a 0.38 0.38 0 0 0 0.14 0.2 a 0.38 0.38 0 0 0 0.55 -0.12 a 1.27 1.27 0 0 0 0.1 -0.6 h 0.82 a 1.5 1.5 0 0 1 -0.29 1 a 1.25 1.25 0 0 1 -1 0.35 a 1.89 1.89 0 0 1 -0.56 -0.08 a 0.76 0.76 0 0 1 -0.4 -0.28 a 1.34 1.34 0 0 1 -0.24 -0.54 a 3.45 3.45 0 0 1 -0.08 -0.85 a 3 3 0 0 1 0.1 -0.86 a 1.25 1.25 0 0 1 0.28 -0.54 a 1 1 0 0 1 0.43 -0.29 a 1.87 1.87 0 0 1 0.55 -0.08 a 1.13 1.13 0 0 1 0.9 0.35 a 1.41 1.41 0 0 1 0.3 1 h -0.82 a 1.94 1.94 0 0 0 0 -0.24 a 1.42 1.42 0 0 0 0 -0.22 a 0.48 0.48 0 0 0 -0.12 -0.16 a 0.37 0.37 0 0 0 -0.2 0 a 0.39 0.39 0 0 0 -0.25 0.07 a 0.41 0.41 0 0 0 -0.15 0.21 A 1.09 1.09 0 0 0 182.7 82.23 Z m 3.67 -1.18 h 0.86 l -0.81 3.14 c -0.08 0.27 -0.15 0.5 -0.22 0.67 a 1.14 1.14 0 0 1 -0.24 0.4 a 0.68 0.68 0 0 1 -0.34 0.19 a 2.35 2.35 0 0 1 -0.5 0 h -0.35 v -0.64 l 0.23 0 a 0.41 0.41 0 0 0 0.34 -0.13 a 0.55 0.55 0 0 0 0.12 -0.33 l -0.94 -3.36 h 0.9 l 0.5 2.32 h 0 Z M 40.65 36.33 h 9 L 61.23 57 h 0.1 V 36.33 h 8.2 V 69.8 h -9 L 49 48.94 h -0.09 V 69.8 H 40.65 Z M 91.14 70.5 C 81 70.5 74.45 62.77 74.45 53.06 S 81 35.63 91.14 35.63 c 7.22 0 15 4.59 15.28 12.65 H 97.7 c -0.47 -3.37 -3.09 -5.15 -6.75 -5.15 c -5.62 0 -7.78 5 -7.78 9.93 S 85.33 63 91 63 c 4.08 0 6.42 -2.34 6.75 -6.19 h 8.72 C 106 65.44 99.62 70.5 91.14 70.5 Z m 28.4 -34.17 V 56.48 c 0 4.32 1.6 6.52 5.86 6.52 s 5.86 -2.2 5.86 -6.52 V 36.33 H 140 V 56 c 0 9.7 -4.45 14.53 -14.58 14.53 S 110.83 65.67 110.83 56 V 36.33 Z M 165.11 63.8 l 2.06 6 h 9.09 L 163.75 36.33 h -8.86 L 142.37 69.8 h 9 l 2.1 -6 Z m -5.86 -18.19 h 0.09 L 163 57.33 h -7.59 Z'
      ]
    },
    {
      prefix: 'ncr',
      iconName: 'ncr',
      icon: [
        100, 100,
        [],
        null,
        'M83.8,49.6h-3.3v-3.8h3.8c2.3,0,2.6,0.8,2.6,1.8C86.9,48,86.8,49.6,83.8,49.6z M100,0v100H0V0H100z M28.6,59.5 c0.4-0.3,0.8-0.6,1.1-0.9c0.3-0.3,0.8-0.8,1.3-1.3l7.2-7.7L35.5,47c-1,0.5-1.9,1.1-2.6,2l-5.2,5.5c-0.5,0.5-1,0.9-1.5,1.3 c-0.4,0.3-0.8,0.6-1.2,0.8c-0.9,0.4-2,0.6-3,0.6c-3.9,0-7.1-3.2-7.2-7.1c-0.1-4,3-7.3,7-7.4c0,0,0,0,0,0c0.9,0,1.9,0.1,2.8,0.4 l1.1-1.2c0.6-0.8,1.4-1.4,2.2-2c-0.7-0.4-1.4-0.7-2.2-1c-1.3-0.4-2.6-0.6-4-0.6c-6.3,0.1-11.3,5.4-11.1,11.6c0,0.1,0,0.1,0,0.2 c0.2,6.3,5.3,11.3,11.6,11.2C24.4,61.6,26.7,60.8,28.6,59.5z M24.6,56.1c1-0.5,1.9-1.2,2.6-2.1l5.2-5.5c0.5-0.6,1.1-1.1,1.8-1.6 c0.2-0.1,0.4-0.2,0.6-0.3l0.2-0.1l-2.7-2.5c-1,0.5-1.9,1.3-2.6,2.1l-5.2,5.5c-0.5,0.6-1.1,1.1-1.8,1.6c-0.2,0.1-0.4,0.2-0.6,0.3 l-0.3,0.1L24.6,56.1z M46.4,49.7c-0.2-6.3-5.4-11.3-11.6-11.2c-2.3,0-4.6,0.7-6.5,2.1c-0.4,0.3-0.8,0.6-1.1,0.9 c-0.3,0.3-0.8,0.8-1.3,1.3l-7.3,7.7l2.7,2.5c1-0.5,1.9-1.1,2.6-2l5.2-5.5c0.5-0.5,1-0.9,1.5-1.3c0.4-0.3,0.8-0.6,1.2-0.8 c0.9-0.4,2-0.6,3-0.6c3.9,0,7.1,3.2,7.2,7.1c0.1,4-3,7.3-7,7.4c0,0,0,0,0,0c-0.9,0-1.9-0.1-2.8-0.4l-1.1,1.2c-0.7,0.8-1.4,1.4-2.2,2 c0.7,0.4,1.4,0.7,2.2,1c1.3,0.4,2.6,0.6,4,0.6c6.3-0.1,11.3-5.4,11.1-11.6C46.4,49.8,46.4,49.7,46.4,49.7L46.4,49.7z M62,43.5h-2.7 v6.9c0,0.3,0.1,0.7,0.2,1c-0.2-0.4-0.5-0.7-0.9-1l-8.7-7.1v13.2h2.8v-6.9c0-0.3-0.1-0.6-0.1-0.9c0.2,0.3,0.5,0.6,0.8,0.8l8.8,7.3 V43.5z M76.2,53.5c-1.5,0.5-3,0.8-4.6,0.8c-3.5,0-5.4-1.6-5.4-4.1c0-3.1,1.8-4.5,5.4-4.5c1.5,0,2.9,0.3,4.3,0.8v-2.8 c-1.4-0.3-2.8-0.4-4.3-0.4c-3.8,0-8.3,1.4-8.3,6.8c0,4.5,4.3,6.5,8.3,6.5c1.5,0,3.1-0.2,4.6-0.5V53.5z M90.9,56.5L86,51.9 c-0.1-0.1-0.3-0.2-0.5-0.3h0.3c2.7-0.2,4-2,4-3.8c0-2.5-1.1-4.2-5.5-4.2h-6.7v12.8h2.9v-6.8l6.7,6.8L90.9,56.5z'
      ]
    },
    {
      prefix: 'ncr',
      iconName: 'x-twitter-square',
      icon: [ 
        448, 512,
        [],
        null,
        'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z'
      ]
    },
    // Template Icon
    // {
    //   prefix: 'ncr',
    //   iconName: '{{ name of icon }}',
    //   icon: [
    //     448, 448,
    //     [],
    //     null,
    //     '{{ Replace this with SVG CODE }}'
    //   ]
    // },
  );

//////////////////////////////////////////////////////////////////////////////
  //tabTrapping 5.0
  //////////////////////////////////////////////////////////////////////////////
  //
  // to intitualize this plugin all you have to do is add this to your javascript file:
  //
  //////////////////////////////////////////////////////////////
  // $("body").tabTrapping();
  //////////////////////////////////////////////////////////////
  //
  // this is an empty panel, you have to have it closed or opened
  // you need ether = "panel-closed or panel-opened" in class
  // if you want it to close if you click anything else, add "panel-overlay" class to it
  // if its a popout type of panel, add "panel-pop", a div with a 
  // class of ".popout-bg" will appear in inside the panel div
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //																												//											
  //      <div class="(panel-closed or panel-opened)(panel-overlay, panel-pop, or none)" ncr-panel="menu"></div>		//
  //																												//
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //
  // this is the panel toggle, you have to have it closed or opened
  // the panel-closed or panel-opened class will show up automatilly depending on what you put in the panel
  //////////////////////////////////////////////////////////////
  //															//
  //          <a href="#" ncr-toggle="menu"></a>				//
  //															//
  //////////////////////////////////////////////////////////////
  //
  //
  // put this button inside a panel-pop, to close it with a button.
  //////////////////////////////////////////////////////////////
  //															//
  //			<a href="#" class="close-button"></a>           //
  //														    //
  //////////////////////////////////////////////////////////////

  
  
//  export function tabTrapping(options, callback) {

// 	var settings = Object.assign({
// 		preloadRemoveDelay: 0
// 	}, options)

// 	var allPanels = Array.prototype.slice.call(document.querySelectorAll('[ncr-panel]'));

// 	if (document.querySelector('.feature-wrap').classList.contains('single-open')) {
// 		var panels = document.querySelectorAll('.single-open [ncr-panel]');
// 		panels.forEach(function(panel) {
// 		  panel.classList.add('panel-accordion');
// 		});
// 	}
	
// 	for (var i = 0; i < allPanels.length; i++) {
	

// 		//initial main variables set up
// 		var ncr_panel = allPanels[i];
// 		var panel_attr = ncr_panel.getAttribute('ncr-panel');
		
// 		var ncr_toggle = document.querySelector('[ncr-toggle="' + panel_attr + '"]');
// 		var ncr_toggle_attr = ncr_toggle.getAttribute('ncr-toggle');
	
// 		var close_button = ncr_panel.querySelector('.close-button');
// 		var width = window.innerWidth;
// 		var isitpop = false;
// 		var isitoverlay = false;
// 		var child_panels = ncr_panel.querySelectorAll('[ncr-panel]');



// 		function getScrollBarWidth() {
// 			var inner = document.createElement('p');
// 			inner.style.width = "100%";
// 			inner.style.height = "200px";
		  
// 			var outer = document.createElement('div');
// 			outer.style.position = "absolute";
// 			outer.style.top = "0px";
// 			outer.style.left = "0px";
// 			outer.style.visibility = "hidden";
// 			outer.style.width = "200px";
// 			outer.style.height = "150px";
// 			outer.style.overflow = "hidden";
// 			outer.appendChild (inner);
		  
// 			document.body.appendChild (outer);
// 			var w1 = inner.offsetWidth;
// 			outer.style.overflow = 'scroll';
// 			var w2 = inner.offsetWidth;
// 			if (w1 == w2) w2 = outer.clientWidth;
		  
// 			document.body.removeChild (outer);
		  
// 			return (w1 - w2);
// 		}
// 		//intial setup for elements
// 		function intialSetupForElements(this_panel, this_toggle) {
// 			//add data- class
// 			this_toggle.classList.add('ncr-toggle');

// 			var ncr_toggle_close = document.querySelectorAll('.ncr-toggle.panel-closed');
// 			var ncr_toggle_open = document.querySelectorAll('.ncr-toggle.panel-opened');
// 			var ncr_panel_close = document.querySelectorAll('div.panel-closed');
// 			var ncr_panel_open = document.querySelectorAll('div.panel-opened');
// 			var childrenOfPanel = this_panel.querySelectorAll('[ncr-panel]');
// 			var childrenOfPanelToggle = this_panel.querySelectorAll('[ncr-toggle]');
		  

// 			//adds all aria related attributes 
// 			//adds all aria related attributes 
// 			this_toggle.style.pointerEvents = 'auto'; // forces pointer-events auto on all toggles
// 			ncr_panel_close.forEach(function(panel) {
// 				panel.setAttribute("aria-expanded", "false");
// 				panel.style.pointerEvents = 'none';
// 			});
// 			ncr_panel_close.forEach(function(panel) {
// 				panel.querySelectorAll('select, input, textarea, button, a').forEach(function(el) {
// 				el.setAttribute('tabIndex', '-1');
// 				});
// 			});
// 			ncr_panel_open.forEach(function(panel) {
// 				panel.setAttribute("aria-expanded", "true");
// 			});
// 			ncr_toggle_close.forEach(function(toggle) {
// 				toggle.setAttribute("aria-expanded", "false");
// 			});
// 			ncr_toggle_open.forEach(function(toggle) {
// 				toggle.setAttribute("aria-expanded", "true");
// 			});


// 			if (ncr_panel.getAttribute("aria-label") == "" || ncr_panel.getAttribute("aria-label") == undefined) {
// 				ncr_panel.setAttribute('aria-label', '' + panel_attr + ' Primary');
// 			}
// 			if (ncr_toggle.getAttribute("aria-label") == "" || ncr_toggle.getAttribute("aria-label") == undefined) {
// 				ncr_toggle.setAttribute('aria-label', '' + panel_attr + ' Toggle');
// 			}
// 			if (close_button !=null){
// 				if (close_button.getAttribute("aria-label") == "" || close_button.getAttribute("aria-label") == undefined) {
// 					close_button.setAttribute('aria-label', '' + panel_attr + ' close Button');
// 				}
// 			}


// 			var childrenOfPanel = ncr_panel.querySelectorAll('[ncr-panel]');
// 			var childrenOfPanelToggle = ncr_panel.querySelectorAll('[ncr-toggle]');
			
// 			for (var i = 0; i < childrenOfPanel.length; i++) {
// 				var childOfPanel = childrenOfPanel[i];
// 				childOfPanel.classList.add('child-panel');
// 			  }
// 			  for (var i = 0; i < childrenOfPanelToggle.length; i++) {
// 				var childOfPanelToggle = childrenOfPanelToggle[i];
// 				childOfPanelToggle.classList.add('child-panel');
// 			  }



// 			for (var i = 0; i < this_panel.length; i++) {
// 			var panel = this_panel[i];
// 			var level = panel.querySelectorAll('[ncr-panel]').length + 1;
// 			panel.classList.add('level-' + level);
// 			this_toggle.classList.add('level-' + level);
// 			}


// 			// adds panel-overlay to toggle
// 			if (settings.popout == true || this_panel.classList.contains('panel-pop')) {
// 				this_panel.classList.add('panel-pop');
// 				this_toggle.classList.add('panel-pop');
// 			}
// 			// adds panel-overlay to toggle
// 			else if (settings.overlay == true || this_panel.classList.contains('panel-overlay')) {
// 				this_panel.classList.add('panel-overlay');
// 				this_toggle.classList.add('panel-overlay');
// 			}
// 			// adds popout-bg div to panel-pops
// 			if (this_panel.classList.contains('panel-pop')) {
// 				if (this_panel.querySelectorAll('.popout-bg').length == 0) {
// 				this_panel.innerHTML += '<div class="popout-bg"></div>';
// 				}
// 			}

// 			// adds popout-bg div to panel-pops
// 			if (this_panel.classList.contains('track-history')) {
// 			this_toggle.classList.add('track-history');
// 			}
// 			// adds panel-accordion to toggle
// 			else if (this_panel.classList.contains('panel-accordion')) {
// 			this_toggle.classList.add('panel-accordion');
// 			}
// 			// adds panel-closed to toggle
// 			else if (this_panel.classList.contains('panel-closed')) {
// 			this_toggle.classList.add('panel-closed');
// 			}
// 			// adds panel-opened to toggle
// 			else if (this_panel.classList.contains('panel-opened')) {
// 			this_toggle.classList.add('panel-opened');
// 			}
// 		}

// 		//start
// 		intialSetupForElements(ncr_panel, ncr_toggle);

// 		//ncr-close-panel / ncr-open-panel custom .on()
// 		ncr_panel.addEventListener("ncr-close-panel", function() {
// 			ncr_panel_close_settings(ncr_toggle, panel_attr);
// 		  });
// 		ncr_panel.addEventListener("ncr-open-panel", function() {
// 			ncr_panel_open_settings(ncr_toggle, panel_attr);
// 			trappingTab(ncr_panel);
// 		});

// 		//returns if turned off based on class
// 		function ifTurnedOff() {
// 			if (ncr_panel.classList.contains('panel-off-')) {
// 			  return true;
// 			} else {
// 			  return false;
// 			}
// 		}

// 		//returns when its turned off
// 		function turnedOffabove() {
// 			if (ncr_panel.classList.contains('panel-off-')) {
// 			  var result;
// 			  var classes = ncr_panel.classList;
// 			  for (var i = 0; i < classes.length; i++) {
// 				if (classes[i].indexOf('panel-off-') > -1) result = classes[i];
// 			  }
// 			  var res = result.split('-')[2];
// 			} else {
// 			  return (res = 'on');
// 			}
// 			return res;
// 		  }

// 		function turnedOffaboveNumber() {
// 		var element_id = ncr_panel.classList.toString();
// 		var number = element_id.match(/\d+/);
// 		return number;
// 		}

// 		// targets after initial setup
// 		var popout_bg = ncr_panel.querySelectorAll('.popout-bg');
// 		var overlay_panel = document.querySelectorAll('.panel-overlay');
// 		var popout_panel = document.querySelectorAll('.panel-pop');
// 		var level = 1;



// 		//function called to open panel
// 		function ncr_panel_open_settings(dataBtn, data) {
// 			console.log(dataBtn)

// 			var ncr_toggle_attr = dataBtn.setAttribute("aria-expanded", "true");
// 			var ncr_toggle_attr2 = dataBtn.classList.add("panel-opened")
// 			var ncr_toggle_attr3 = dataBtn.classList.remove("panel-closed");
			  
// 			var ncr_panel = document.querySelector('[ncr-panel="' + data + '"]').setAttribute("aria-expanded", "true")
// 			var ncr_panel2 = document.querySelector('[ncr-panel="' + data + '"]').classList.add("panel-opened")
// 			var ncr_panel3 = document.querySelector('[ncr-panel="' + data + '"]').classList.remove("panel-closed")
// 			var ncr_panel4 = document.querySelector('[ncr-panel="' + data + '"]').style.pointerEvents = "auto";
		  
// 			var ncr_panel_inputs = document.querySelector('[ncr-panel="' + data + '"]');
// 			var ncr_panel_inputs2 = document.querySelectorAll("select, input, textarea, button, a")
// 			for (let index = 0; index < ncr_panel_inputs2.length; index++) {
// 				const element = ncr_panel_inputs2[index];
// 				return element.setAttribute("tabIndex", "0");
// 			}
// 			var ncr_panel_inputs3 = document.setAttribute("tabIndex", "0");
		  
// 			document.querySelector('[ncr-panel="' + data + '"]')
// 			document.querySelectorAll(".panel-closed[ncr-panel]")
// 			document.querySelectorAll("select, input, textarea, button, a")
// 			document.setAttribute("tabIndex", "-1");
		  
// 			ncr_panel.dispatchEvent(new Event("ncr-panel-opened"));

// 			document
// 			  .querySelector('[ncr-panel="' + data + '"]')
// 			  .closest(".feature")
// 			  .classList.add("active");
		  
// 			return ncr_toggle_attr, ncr_toggle_attr2, ncr_toggle_attr3, ncr_panel,ncr_panel2,ncr_panel3,ncr_panel4, ncr_panel_inputs,ncr_panel_inputs2,ncr_panel_inputs3;
// 		  }

		  
// 		// function called to close panel
// 		function ncr_panel_close_settings(dataBtn, data) {
// 			var ncr_toggle_attr = dataBtn.setAttribute("aria-expanded", "false")
// 			var ncr_toggle_attr2 = dataBtn.classList.add("panel-closed")
// 			var ncr_toggle_attr3 = dataBtn.classList.remove("panel-opened");
		
// 			var ncr_panel = document.querySelector('[ncr-panel="' + data + '"]')
// 			.setAttribute("aria-expanded", "false")
// 			.classList.remove("panel-opened")
// 			.classList.add("panel-closed")
// 			.style.pointerEvents = "none";
		
// 			document.querySelector('[ncr-panel="' + data + '"]')
// 			document.querySelectorAll("select, input, textarea, button, a")
// 			document.setAttribute("tabIndex", "-1");
		
// 			ncr_panel.dispatchEvent(new Event("ncr-panel-closed"));
// 			document
// 			.querySelector('[ncr-panel="' + data + '"]')
// 			.closest(".feature")
// 			.classList.remove("active");
		
// 			return ncr_toggle_attr, ncr_toggle_attr2, ncr_toggle_attr3, ncr_panel, ncr_panel_inputs;
// 		}
		
// 		//close all children

// 		function closeChildren(parentPanel) {
// 			var childrenOfPanel = parentPanel.querySelectorAll('.child-panel[ncr-panel]');
// 			var childrenOfPanelToggle = parentPanel.querySelectorAll('.child-panel[ncr-toggle]');
			
// 			childrenOfPanel.forEach(function(child) {
// 				var ncr_toggle = child.querySelector('.child-panel[ncr-toggle]');
// 				ncr_toggle.setAttribute("aria-expanded", "false");
// 				ncr_toggle.classList.add("panel-closed");
// 				ncr_toggle.classList.remove("panel-opened");
				
// 				child.setAttribute("aria-expanded", "false");
// 				child.classList.remove("panel-opened");
// 				child.classList.add("panel-closed");
// 				child.style.pointerEvents = "none";
				
// 				var ncr_panel_inputs = child.querySelectorAll("select, input, textarea, button, a");
				
// 				ncr_panel_inputs.forEach(function(input) {
// 					input.setAttribute("tabIndex", "-1");
// 				});
// 			});
// 		}
		  
// 		// open all children
// 		const openChildren = () => {
// 			var childrenOfPanel = ncr_panel.querySelectorAll('.child-panel[ncr-panel]');
// 			var childrenOfPanelToggle = ncr_panel.querySelectorAll('.child-panel[ncr-toggle]');
		
// 			childrenOfPanel.forEach(function(child) {
// 			var ncr_toggle_attr = child.querySelector('.child-panel[ncr-toggle]')
// 				.setAttribute("aria-expanded", "true")
// 				.classList.add("panel-opened")
// 				.classList.remove("panel-closed");
		
// 			var ncr_panel = child
// 				.setAttribute("aria-expanded", "true")
// 				.classList.remove("panel-closed")
// 				.classList.add("panel-opened")
// 				.style.pointerEvents = "auto";
		
// 			var ncr_panel_inputs = child
// 				.querySelectorAll("select, input, textarea, button, a")
// 				.setAttribute("tabIndex", "0");
		
// 			return ncr_toggle_attr, ncr_panel, ncr_panel_inputs;
// 			});
// 		}
  
  
  
// 		ncr_toggle.addEventListener('click', function (e) {
// 			var overlay_panels = document.querySelectorAll('[ncr-panel].panel-overlay');
// 			var overlay_toggles = document.querySelectorAll('[ncr-toggle].panel-overlay');
// 			var popout_panels = document.querySelectorAll('[ncr-panel].panel-pop.level-' + level);
// 			var popout_toggles = document.querySelectorAll('[ncr-toggle].panel-pop.level-' + level);
// 			var accordion_panels = this.closest('.feature-wrap') + '[ncr-panel].panel-accordion.level-' + level;
// 			var accordion_toggles = this.closest('.feature-wrap') + '[ncr-toggle].panel-accordion.level-' + level;
// 			var panel_child_panel = ncr_panel;
		
// 		// console.log(accordion_panels, accordion_toggles)
// 			function buttonFunctionality() {
// 				if (ncr_toggle.classList.contains('panel-pop', 'level-' + level)) {
// 					if (ncr_panel.getAttribute("aria-expanded") === 'false') {
// 						e.stopImmediatePropagation();
					  
// 						popout_toggles.setAttribute("aria-expanded", "true")
// 						  .classList.add("panel-closed")
// 						  .classList.remove("panel-opened");
					  
// 						popout_panels
// 						  .setAttribute("aria-expanded", "false")
// 						  .classList.remove("panel-opened")
// 						  .classList.add("panel-closed")
// 						  .style.pointerEvents = 'none';
					  
// 						popout_panels
// 						  .querySelectorAll('select, input, textarea, button, a')
// 						  .forEach(function(element) {
// 							element.setAttribute('tabIndex', '-1');
// 						  });
					  
// 						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
// 						trappingTab(ncr_panel);
					  
					  
// 						document.querySelector('body').style.overflowY = 'hidden';
// 						document.querySelector('body').style.position = 'absolute';
// 						document.querySelector('body').style.width = '100%';
// 						document.querySelector('body').style.borderRight = getScrollBarWidth() + 'px solid white';
					  
					  
// 						if (panel_child_panel.classList.contains('ncr-turned-off')) {
// 						  openChildren();
// 						}
// 					} else if (ncr_panel.getAttribute("aria-expanded") === 'true') {
// 					if (ncr_panel.classList.contains('panel-pop')) {
// 						document.querySelector('body').style.overflowY = 'auto';
// 						document.querySelector('body').style.position = 'relative';
// 						document.querySelector('body').style.borderRight = '0px solid white';
// 					}
					
// 					ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
// 					if (ncr_panel.classList.contains('ncr-turned-off')) {
// 						trappingTab(this);
// 					}
// 					}
// 				} else if (ncr_toggle.classList.contains('panel-overlay')) {
// 					if (ncr_panel.getAttribute("aria-expanded") == 'false') {
// 						e.stopImmediatePropagation();
					  
// 						overlay_toggles.setAttribute("aria-expanded", "true")
// 						  .classList.add("panel-closed")
// 						  .classList.remove("panel-opened");
					  
// 						overlay_panels
// 						  .setAttribute("aria-expanded", "false")
// 						  .classList.remove("panel-opened")
// 						  .classList.add("panel-closed")
// 						  .style.pointerEvents = 'none';
					  
// 						overlay_panels
// 						  .querySelectorAll('select, input, textarea, button, a')
// 						  .forEach(el => el.setAttribute('tabIndex', '-1'));
// 						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
// 						trappingTab(ncr_panel);
					  
// 						if (panel_child_panel.classList.contains('ncr-turned-off')) {
// 						  openChildren()
// 						}
// 					} else {
// 					if (ncr_panel.classList.contains('panel-pop')) {
// 						document.documentElement.style.overflowY = 'auto';
// 						document.documentElement.style.position = 'relative';
// 						document.documentElement.style.borderRight = '0px solid white';
// 					}
					
// 					ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
// 					if (ncr_panel.classList.contains('ncr-turned-off')) {
// 						trappingTab(this);
// 					}
// 					}
// 				} else if (ncr_toggle.classList.contains('panel-accordion', 'level-' + level)) {
// 					if (ncr_panel.getAttribute("aria-expanded") == 'false') {
// 						accordion_toggles.setAttribute("aria-expanded", "true")
// 						  .classList.add("panel-closed")
// 						  .classList.remove("panel-opened");
					  
// 						accordion_panels
// 						  .setAttribute("aria-expanded", "false")
// 						  .classList.remove("panel-opened")
// 						  .classList.add("panel-closed")
// 						  .style.pointerEvents = 'none';
					  
// 						accordion_panels
// 						  .querySelectorAll('select, input, textarea, button, a')
// 						  .forEach(el => el.setAttribute('tabIndex', '-1'));
					  
// 						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
// 						trappingTab(ncr_panel);
// 						if (panel_child_panel.classList.contains('ncr-turned-off')) {
// 						  openChildren()
// 						}
// 					} else {
// 					if (!(ncr_panel.classList.contains('panel-cant-close') && ncr_panel.classList.contains('panel-opened'))) {
// 						if (ncr_panel.classList.contains('panel-pop')) {
// 						document.documentElement.style.overflowY = 'auto';
// 						document.documentElement.style.position = 'relative';
// 						document.documentElement.style.borderRight = '0px solid white';
// 						}
// 						ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
// 						if (ncr_panel.classList.contains('ncr-turned-off')) {
// 						trappingTab(this);
// 						}
// 					}
// 					}
// 				} else {
// 					if (ncr_panel.getAttribute('aria-expanded') == 'false') {
// 						this.dispatchEvent(new Event("ncr-panel-open"));
// 						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
// 						trappingTab(ncr_panel);
// 						if (panel_child_panel.classList.contains('ncr-turned-off')) {
// 						  openChildren()
// 						}
// 					} else {
// 						if (ncr_panel.classList.contains('panel-pop')) {
// 							document.documentElement.style.overflowY = 'auto';
// 							document.documentElement.style.position = 'relative';
// 							document.documentElement.style.borderRight = '0px solid white';
// 						  }
// 						  this.dispatchEvent(new Event("ncr-panel-close"));
					
// 						  ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
// 						  if (ncr_panel.classList.contains('ncr-turned-off')) {
// 							trappingTab(this);
// 						  }
// 					}
// 				}
		
			
// 			}



// 			if (!(ifTurnedOff() && (width > (turnedOffabove() - getScrollBarWidth())))) {
// 				buttonFunctionality();
// 				if (!(ncr_panel.classList.contains('panel-no-trap'))) {
// 				  ncr_toggle.addEventListener('keyup', function (e) {
// 					if (e.keyCode == 27) {
// 					  if (this.classList.contains('panel-pop')) {
// 						document.querySelector('body').style.overflowY = 'auto';
// 						document.querySelector('body').style.position = 'relative';
// 						document.querySelector('body').style.borderRight = '0px solid white';
// 					  }
// 					  ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
// 					  if (ncr_panel.classList.contains('ncr-turned-off')) {
// 						trappingTab(this);
// 					  }
// 					  this.focus();
// 					  // console.log('escaped not')  
// 					}
// 				  });
// 				  e.stopImmediatePropagation();
// 				}
// 			} else if (ncr_panel.classList.contains('ncr-panel-off')) {
// 			ncr_toggle.addEventListener('keyup', function (e) {
// 				if (e.keyCode == 27) {
// 				// console.log('escaped')
// 				}
// 			});
// 			}
// 		});

		
// 		//tab trap
// 		function trappingTab(panel) {

// 		//selecting elements to tab through *thanks to the greatness of jordan
// 		var allElements = panel.querySelectorAll(':not([ncr-panel].panel-closed, [ncr-panel].panel-closed *)');
// 		// var tabbable = allElements.filter(function (element) {
// 		// 	return element.matches('select:visible, input:visible, textarea:visible, a:visible, button:visible');
// 		// });

// 		var tabbable = [];

// 		// Create a new array containing only the visible elements
// 		var tabbable = [];

// 		for (var i = 0; i < allElements.length; i++) {
// 		var element = allElements[i];
// 		if (element.offsetParent !== null) {
// 			tabbable.push(element);
// 		}
// }

// 		var firstTabbable = tabbable[0];
// 		var lastTabbable = tabbable[tabbable.length - 1];

// 		//set focus on first input
// 		if (ncr_panel.classList.contains('auto-focus')) {
// 			firstTabbable.focus();
// 		}


// 		//first tab
// 		ncr_toggle.addEventListener('keydown', function (e) {
// 			if (e.which === 9 && !e.shiftKey) {
// 				if (ifTurnedOff() && (width > (turnedOffabove() - getScrollBarWidth()))) {
// 				e.stopImmediatePropagation();
// 				} else {
// 				if (this.classList.contains('panel-opened')) {
// 					e.preventDefault();
// 					firstTabbable.focus();
// 				} else {
// 					e.stopImmediatePropagation();
// 				}
// 				}
// 			}
// 		});

// 		// Check if to trap tab or not
// 		if (!panel.classList.contains('panel-no-trap')) {
// 			// First shift-tab
// 			ncr_toggle.addEventListener('keydown', function(e) {
// 			if (e.which === 9 && e.shiftKey) {
// 				if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
// 				e.stopImmediatePropagation();
// 				} else {
// 				if (this.classList.contains('panel-opened')) {
// 					e.preventDefault();
// 					firstTabbable.focus();
// 				} else {
// 					e.stopImmediatePropagation();
// 				}
// 				}
// 			}
// 			});
		
// 			// Redirect last tab to first input
// 			lastTabbable.addEventListener('keydown', function(e) {
// 			if (e.which === 9 && !e.shiftKey) {
// 				if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
// 				e.stopImmediatePropagation();
// 				} else {
// 				e.preventDefault();
// 				firstTabbable.focus();
// 				}
// 			}
// 			});
		
// 			// Redirect first shift+tab to last input
// 			firstTabbable.addEventListener('keydown', function(e) {
// 			if (e.which === 9 && e.shiftKey) {
// 				if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
// 				e.stopImmediatePropagation();
// 				} else {
// 				e.preventDefault();
// 				lastTabbable.focus();
// 				}
// 			}
// 			});
// 		}

// 		ncr_panel.addEventListener('keyup', function (e) {
// 			switch (e.which) {
// 				case 27: // escape
// 				if (!((ifTurnedOff() == true) && (width > (turnedOffabove() - getScrollBarWidth())))) {
// 					if (!(panel.classList.contains('panel-no-trap'))) {
// 					if (ncr_panel.classList.contains('ncr-turned-off')) {
// 						closeChildren(this);
// 					}
// 					ncr_panel_close_settings(ncr_toggle, panel_attr);
// 					ncr_toggle.focus();
// 					if (ncr_panel.classList.contains('panel-pop')) {
// 						document.querySelector('body').style.overflowY = 'auto';
// 						document.querySelector('body').style.position = 'relative';
// 						document.querySelector('body').style.borderRight = '0px solid white';
// 					}
// 					e.stopImmediatePropagation();
// 					}
// 				}
// 				break;
			
// 				case 37: // left
// 				// allElements[allElements.indexOf(e) + counter--].focus();
// 				// Get all links in the HTML
// 				var allLinks = allElements.querySelectorAll('a');
// 				// Get the index of the currently focused link
// 				var index = allLinks.indexOf(document.activeElement);
// 				// If there is a link after the currently focused one
// 				if (index + 1 < allLinks.length) {
// 					// Focus on the next link
// 					allLinks[index + 1].focus();
// 				}
// 				break;
			
// 				case 38: // up
// 				allElements[allElements.indexOf(e) + counter--].focus();
// 				//console.log("clicked up");
// 				break;
			
// 				case 39: // right
// 				// allElements[allElements.indexOf(e) + counter++].focus();
// 				//console.log("clicked right");
// 				// Get all links in the HTML
// 				var allLinks = allElements.querySelectorAll('a');
// 				// Get the index of the currently focused link
// 				var index = allLinks.indexOf(document.activeElement);
// 				// If there is a link after the currently focused one
// 				if (index + 1 < allLinks.length) {
// 					// Focus on the next link
// 					allLinks[index + 1].focus();
// 				}
// 				break;
			
// 				case 40: // down
// 				allElements[allElements.indexOf(e) + counter++].focus();
// 				//console.log("clicked down");
// 				break;
			
// 				default:
// 				return;
// 			}
// 		});

// 		}

// 		//if popout panel is open, it automatically tab traps in it
// 		if (ncr_panel.classList.contains('panel-pop') && ncr_panel.classList.contains('panel-opened')) {
// 			var loaded_popout = document.querySelectorAll('.panel-pop.panel-opened');
// 			document.querySelector('body').style.overflowY = 'hidden';
// 			document.querySelector('body').style.position = 'absolute';
// 			trappingTab(loaded_popout);
// 		  }

// 		var isItHover;
// 		var isItOff;

// 		window.addEventListener('load resize', () => {

// 			isItHover = ncr_panel.classList.contains('hover-toggle') && window.innerWidth >= turnedOffaboveNumber();
// 			isItOff = ifTurnedOff() && window.innerWidth >= turnedOffaboveNumber();
// 			//  console.log(ncr_toggle.attr('ncr-toggle'),'|hover: ',isItHover,'| off: ',isItOff, 'numb', turnedOffaboveNumber() )
// 		})


// 		//start of button functionality
// 		//toggle button



// 		ncr_toggle.addEventListener('mouseover', () => {
// 			if (isItHover) {
// 				ncr_panel_open_settings(ncr_toggle, panel_attr);
// 				trappingTab(ncr_panel);
// 				if (panel_child_panel.classList.contains('ncr-turned-off')) {
// 					openChildren();
// 				}
// 			} else {
// 				// do nothing
// 			}
// 		});
		
// 		ncr_toggle.addEventListener('mouseleave', function() {
// 			if (isItHover) {
// 				ncr_panel_close_settings(ncr_toggle, panel_attr);
// 			} else {
// 				// do nothing
// 			}
// 		});
		

// 		//close button
// 		if (close_button !=null){
// 			close_button.addEventListener('click', function(e) {
// 				if (!this.parentElement.classList.contains('ncr-turned-off')) {
// 				var ncr_panel = this.closest('.panel-opened').getAttribute('ncr-panel');
// 				var ncr_toggle = document.querySelector('[ncr-toggle="' + ncr_panel + '"]');
			
// 				// console.log('working');
// 				document.querySelector('body').style.overflowY = 'auto';
// 				document.querySelector('body').style.position = 'relative';
// 				document.querySelector('body').style.borderRight = '0px solid white';
			
// 				ncr_panel_close_settings(ncr_toggle, ncr_panel);
// 				if (ncr_panel.classList.contains('ncr-turned-off')) {
// 					closeChildren(ncr_panel);
// 				}
// 				ncr_toggle.focus();
			
// 				e.stopImmediatePropagation();
// 				}
// 			});
// 		}
		  
// 	//panel-pop
// 	popout_bg.addEventListener('click', function (e) {
// 		if ((ifTurnedOff()) && (width > (turnedOffAt() - getScrollBarWidth()))) {
// 			e.stopImmediatePropagation();
// 		} else {
// 			var ncr_panel = this.closest('div').getAttribute('ncr-panel');

// 			ncr_panel_close_settings(ncr_toggle, ncr_panel);
// 			if (ncr_panel.classList.contains('ncr-turned-off')) {
// 				closeChildren(ncr_panel);
// 			}

// 			ncr_toggle.focus();
// 			if (this.closest('[ncr-panel]').classList.contains('panel-pop')) {
// 				document.documentElement.style.overflowY = 'auto';
// 				document.documentElement.style.position = 'relative';
// 				document.documentElement.style.borderRight = '0px solid white';
// 			}
// 			e.stopImmediatePropagation();
// 		}
// 	});

// 	//panel-overlay stop from closing if clicked outside of selector
// 	overlay_panel.addEventListener('click', function (e) {
// 		e.stopImmediatePropagation();
// 	});

// 	//panel-pop stop from closing if clicked outside of selector
// 	popout_panel.addEventListener('click', function (e) {
// 		e.stopImmediatePropagation();
// 	});

// 	//space button
// 	ncr_toggle.addEventListener('keyup', function (e) {
// 		if ((ifTurnedOff()) && (width > (turnedOffAt() - getScrollBarWidth()))) {
// 			e.stopImmediatePropagation();
// 		} else {
// 			if (e.keyCode === 32) {
// 				e.preventDefault();
// 				var ncr_panel = document.querySelector('[ncr-panel="' + panel_attr + '"]');
// 				if (ncr_panel.getAttribute("aria-expanded") === 'false') {
// 					ncr_panel_open_settings(ncr_panel, panel_attr);
// 					trappingTab(ncr_panel);
// 					e.stopImmediatePropagation();
// 				}
// 			}
// 		}
// 	});

 



// 	function switchClassesAbove() {
// 		if (ncr_panel.matches('[class*=switch-]')) {
// 			let result = undefined;
// 			ncr_panel.className.split(' ').forEach(function (cls) {
// 				if (cls.indexOf('switch-') > -1) result = cls;
// 			});
// 			var res = result.split('-')[1];
// 		} else {
// 			return (res = 'on');
// 		}
// 		return res;
// 	}
	
// 	function fromClass() {
// 		if (ncr_panel.matches('[class*=switch-]')) {
// 			let fromClass = undefined;
// 			ncr_panel.className.split(' ').forEach(function (cls) {
// 				if (cls.indexOf('switch-') > -1) fromClass = cls;
// 			});
// 			var from = fromClass.split('-')[3];
// 		} else {
// 			return (from = 'on');
// 		}
// 		return 'panel-' + from;
// 	}
	
// 	function toClass() {
// 		if (ncr_panel.matches('[class*=switch-]')) {
// 			let toClass = undefined;
// 			ncr_panel.className.split(' ').forEach(function (cls) {
// 				if (cls.indexOf('switch-') > -1) toClass = cls;
// 			});
// 			var to = toClass.split('-')[2];
// 		} else {
// 			return (to = 'on');
// 		}
// 		return 'panel-' + to;
// 	}
	
// 	function fromToClass() {
// 		if (width < switchClassesAbove()) {
// 			ncr_toggle.classList.add(fromClass());
// 			ncr_panel.classList.add(fromClass());
// 			ncr_toggle.classList.remove(toClass());
// 			ncr_panel.classList.remove(toClass());
// 		} else {
// 			ncr_toggle.classList.add(toClass());
// 			ncr_panel.classList.add(toClass());
// 			ncr_toggle.classList.remove(fromClass());
// 			ncr_panel.classList.remove(fromClass());
// 		}
// 	}






// 	function adjustClasses() {
// 		if ((ifTurnedOff()) && (width >= (turnedOffabove() - getScrollBarWidth()))) {
// 			ncr_panel.classList.add('ncr-turned-off');
// 			ncr_toggle.classList.add('ncr-toggle-turned-off');
	
// 			if (ncr_panel.classList.contains('panel-overlay')) {
// 				isitoverlay = true;
// 			}
// 			ncr_toggle.classList.remove('panel-overlay');
// 			ncr_panel.classList.remove('panel-overlay');
	
// 			if (ncr_panel.classList.contains('panel-pop')) {
// 				isitpop = true;
// 			}
	
// 			ncr_panel.classList.remove('panel-pop');
// 			ncr_toggle.classList.remove('panel-pop');
	
// 			ncr_toggle.style.pointerEvents = 'auto';
// 			ncr_panel.style.pointerEvents = 'none';
// 			ncr_panel.querySelectorAll('select, input, textarea, button, a').forEach(function (elem) {
// 				elem.style.pointerEvents = 'auto';
// 			});
// 		} else {
// 			ncr_panel.classList.remove('ncr-turned-off');
// 			ncr_toggle.classList.remove('ncr-toggle-turned-off');
	
// 			if (isitoverlay) {
// 				ncr_toggle.classList.add('panel-overlay');
// 				ncr_panel.classList.add('panel-overlay');
// 			}
// 			if (isitpop) {
// 				ncr_panel.classList.add('panel-pop');
// 				ncr_toggle.classList.add('panel-pop');
// 			}
// 			ncr_toggle.style.pointerEvents = 'auto';
// 			ncr_panel.style.pointerEvents = 'auto';
// 		}
// 	}


// 	if (ifTurnedOff() === true) {
// 		function open(btn, area) {
// 			btn.setAttribute("aria-expanded", "true");
// 			btn.classList.add("panel-opened");
// 			btn.classList.remove("panel-closed");
	
// 			area.setAttribute("aria-expanded", "true");
// 			area.classList.add("panel-opened");
// 			area.classList.remove("panel-closed");
// 			area.style.pointerEvents = 'auto';
	
// 			area.querySelectorAll('select, input, textarea, button, a').forEach(function (elem) {
// 				elem.removeAttribute('tabIndex');
// 			});
// 		}
	
// 		function close(btn, area) {
// 			btn.setAttribute("aria-expanded", "true");
// 			btn.classList.add("panel-closed");
// 			btn.classList.remove("panel-opened");
	
// 			area.setAttribute("aria-expanded", "false");
// 			area.classList.remove("panel-opened");
// 			area.classList.add("panel-closed");
// 			area.style.pointerEvents = 'none';
	
// 			area.querySelectorAll('select, input, textarea, button, a').forEach(function (elem) {
// 				elem.setAttribute('tabIndex', '-1');
// 			});
	
// 			document.documentElement.style.overflowY = 'auto';
// 			document.documentElement.style.position = 'relative';
// 			document.documentElement.style.borderRight = '0px solid white';
// 		}
	
// 		function overlaySettingsTurnedOff() {
// 			if (width < (turnedOffabove() - getScrollBarWidth())) {
// 				close(ncr_toggle, ncr_panel);
// 			} else {
// 				open(ncr_toggle, ncr_panel);
// 			}
	
// 			if (settings.overlay == true || settings.popout == true) {
// 				if (width < (turnedOffabove() - getScrollBarWidth())) {
	
// 				} else {
	
// 				}
// 			}
// 		}
	
// 		overlaySettingsTurnedOff();
// 	}
// 	fromToClass();
// 	adjustClasses();





// 	window.addEventListener('resize', function () {
// 		let currentWidth = window.innerWidth;
	
// 		if (currentWidth !== width) {
// 			width = currentWidth;
	
// 			if (ifTurnedOff()) {
// 				function open(btn, area) {
// 					btn.setAttribute("aria-expanded", "true");
// 					btn.classList.add("panel-opened");
// 					btn.classList.remove("panel-closed");
	
// 					area.setAttribute("aria-expanded", "true");
// 					area.classList.add("panel-opened");
// 					area.classList.remove("panel-closed");
// 					area.style.pointerEvents = 'auto';
	
// 					area.querySelectorAll('select, input, textarea, button, a').forEach(function (elem) {
// 						elem.removeAttribute('tabIndex');
// 					});
// 				}
	
// 				function close(btn, area) {
// 					btn.setAttribute("aria-expanded", "true");
// 					btn.classList.add("panel-closed");
// 					btn.classList.remove("panel-opened");
	
// 					area.setAttribute("aria-expanded", "false");
// 					area.classList.remove("panel-opened");
// 					area.classList.add("panel-closed");
// 					area.style.pointerEvents = 'none';
	
// 					area.querySelectorAll('select, input, textarea, button, a').forEach(function (elem) {
// 						elem.setAttribute('tabIndex', '-1');
// 					});
	
// 					document.documentElement.style.overflowY = 'auto';
// 					document.documentElement.style.position = 'relative';
// 					document.documentElement.style.borderRight = '0px solid white';
// 				}
	
// 				function overlaySettingsTurnedOff() {
// 					if (width < (turnedOffabove() - getScrollBarWidth())) {
// 						close(ncr_toggle, ncr_panel);
// 					} else {
// 						open(ncr_toggle, ncr_panel);
// 					}
	
// 					if (settings.overlay === true || settings.popout === true) {
// 						if (width < (turnedOffabove() - getScrollBarWidth())) {
	
// 						} else {
	
// 						}
// 					}
// 				}
	
// 				overlaySettingsTurnedOff();
// 			}
	
// 			fromToClass();
// 			adjustClasses();
// 		}
// 	});
	
// 	if (settings.panelOpen || settings.panelClose === true) {
// 		ncr_toggle.dispatchEvent(new Event('click'));
// 		ncr_toggle.focus();
// 	}
	
// 	if (typeof callback === 'function') {
// 		callback.call(this);
// 	}











// 	} // end of foreach

// 	if(document.querySelectorAll('.feature-wrap.first-open').length > 0){
// 		var firstOpenContainers = document.querySelectorAll('.feature-wrap.first-open');
// 		firstOpenContainers.forEach(function(container){
// 		var firstPanel = container.querySelector('[ncr-panel]');
// 		var event = new CustomEvent('ncr-open-panel');
// 		firstPanel.dispatchEvent(event);
// 		});
// 	}
		
// 	if(document.querySelectorAll('.feature-wrap.all-open').length > 0){
// 		var allOpenContainers = document.querySelectorAll('.feature-wrap.all-open');
// 		allOpenContainers.forEach(function(container){
// 		var panels = container.querySelectorAll('[ncr-panel]');
// 		panels.forEach(function(panel){
// 		var event = new CustomEvent('ncr-open-panel');
// 		panel.dispatchEvent(event);
// 		});
// 		});
// 	}

// 	//panel-overlay
// 	document.addEventListener('click', function (event) {
// 		var panelOverlays = document.querySelectorAll('div.panel-overlay:not(.ncr-turned-off).panel-opened');
// 		if (panelOverlays.length) {
// 		  var toggleElems = document.querySelectorAll('[ncr-toggle].panel-overlay');
// 		  toggleElems.forEach(function (toggleElem) {
// 			toggleElem.setAttribute("aria-expanded", "false");
// 			toggleElem.classList.add("panel-closed");
// 			toggleElem.classList.remove("panel-opened");
// 		  });
// 		  var panelElems = document.querySelectorAll('[ncr-panel].panel-overlay');
// 		  panelElems.forEach(function (panelElem) {
// 			panelElem.setAttribute("aria-expanded", "false");
// 			panelElem.classList.remove("panel-opened");
// 			panelElem.classList.add("panel-closed");
// 			panelElem.style.pointerEvents = 'none';
// 			var inputElems = panelElem.querySelectorAll('select, input, textarea, button, a');
// 			inputElems.forEach(function (inputElem) {
// 			  inputElem.setAttribute('tabIndex', '-1');
// 			});
// 		  });
// 		}
// 	});
// }


  ///////////////////////////////////////////////////////////////////////////
  //tabTrapping 5.0 end                                                    //
  ///////////////////////////////////////////////////////////////////////////





















  
  
  
  
  //////////////////////////////////////////////////////////////////////////////
  //tabTrapping 6.0
  //////////////////////////////////////////////////////////////////////////////
  //
  // to intitualize this plugin all you have to do is add this to your javascript file:
  //
  //////////////////////////////////////////////////////////////
  // $("body").tabTrapping();
  //////////////////////////////////////////////////////////////
  //
  // this is an empty panel, you have to have it closed or opened
  // you need ether = "panel-closed or panel-opened" in class
  // if you want it to close if you click anything else, add "panel-overlay" class to it
  // if its a popout type of panel, add "panel-pop", a div with a 
  // class of ".popout-bg" will appear in inside the panel div
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //																												//											
  //      <div class="(panel-closed or panel-opened)(panel-overlay, panel-pop, or none)" ncr-panel="menu"></div>		//
  //																												//
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //
  // this is the panel toggle, you have to have it closed or opened
  // the panel-closed or panel-opened class will show up automatilly depending on what you put in the panel
  //////////////////////////////////////////////////////////////
  //															//
  //          <a href="#" ncr-toggle="menu"></a>				//
  //															//
  //////////////////////////////////////////////////////////////
  //
  //
  // put this button inside a panel-pop, to close it with a button.
  //////////////////////////////////////////////////////////////
  //															//
  //			<a href="#" class="close-button"></a>           //
  //														    //
  //////////////////////////////////////////////////////////////

function tabTrapping(options, callback) {

class Panel {
		constructor(panel) {
			this.panel = panel;
			this.name =  this.panel.getAttribute('ncr-panel');
			this.toggle = document.querySelector('[ncr-toggle="' + this.name + '"]');
			this.closeButton = this.panel.querySelector('.close-button');
			this.isOff = Array.from(this.panel.classList).some(className => className.startsWith('panel-off-'));
			this.isOpen = this.panel.classList.contains('panel-opened');
			this.level = this.panel.querySelectorAll('[ncr-panel]').length + 1;
			this.turnedOffAbove = this.turnedOffAt();
			this.childrenPanels = this.panel.querySelectorAll('[ncr-panel]');
			this.childrenPanelsToggle = this.panel.querySelectorAll('[ncr-toggle]');
			
			this._initialize();

			window.addEventListener('resize', () => {
				// Get a reference to the panel element
				if (!this.isOff) {
					return undefined;
				}
			
				this.turnedOffAt();
				
				
				// Check if the panel should be turned off or on
				if( this.aboveOrbelow() == 'above'){
					if (this.turnedOffAt() <= window.innerWidth) {
						this.closePanel();
						this.turnOffPanel();
					} else {
						this.openPanel();
						this.turnOnPanel();
					}
					// console.log(turnedOffAbove)
				}
				else if(this.aboveOrbelow() == 'below'){
					if (this.turnedOffAt() >= window.innerWidth) {
						this.closePanel();
						this.turnOffPanel();
					} else {
						this.openPanel();
						this.turnOnPanel();
					}

					// console.log(turnedOffAbove)

				}
			},{ passive: true });
			if (this.isOff) {
				this.turnedOffAt();
				// Check if the panel should be turned off or on
				if( this.aboveOrbelow() == 'above'){
					if (this.turnedOffAt() <= window.innerWidth) {
						this.closePanel();
						this.turnOffPanel();
					} else {
						this.openPanel();
						this.turnOnPanel();
					}
					// console.log(turnedOffAbove)
				}
				else if(this.aboveOrbelow() == 'below'){
					if (this.turnedOffAt() >= window.innerWidth) {
						this.closePanel();
						this.turnOffPanel();
					} else {
						this.openPanel();
						this.turnOnPanel();
					}

					// console.log(turnedOffAbove)

				}
			}
			return undefined;
		}

		findType() {
		if (this.panel.classList.contains('panel-overlay')) {
			return "panel-overlay";
		} else if (this.panel.classList.contains('panel-accordion')) {
			return "panel-accordion";
		} else if (this.panel.classList.contains('panel-pop')) {
			return "panel-pop";
		} else {
			return "panel-none";
		}
		}

		openPanel() {
		
		if(this.toggle != null){
			this.toggle.setAttribute("aria-expanded", "true");
			this.toggle.classList.add("panel-opened");
			this.toggle.classList.remove("panel-closed");
		}
			this.panel.setAttribute("aria-expanded", "true");
			this.panel.classList.add("panel-opened");
			this.panel.classList.remove("panel-closed");
			this.panel.style.pointerEvents = 'auto';

			// Set the "tabIndex" attribute to "0" on the focusable elements inside the panel
			var focusableElements = this.panel.querySelectorAll('select, input, textarea, button, a');
			focusableElements.forEach(function(element) {
				element.setAttribute('tabIndex', '0');
			});
			
			// Get a reference to the focusable elements inside the closed panels
			// var closedPanels = panel.querySelectorAll('.panel-closed[ncr-panel]');
			// var focusableElementsInClosedPanels = closedPanels.querySelectorAll('select, input, textarea, button, a');
			
			// // Set the "tabIndex" attribute to "-1" on the focusable elements inside the closed panels
			// focusableElementsInClosedPanels.forEach(function(element) {
			//   element.setAttribute('tabIndex', '-1');
			// });
			
			// Dispatch a custom "ncr-panel-opened" event on the panel element
			var event = new CustomEvent("ncr-panel-opened", { bubbles: true });
			this.panel.dispatchEvent(event);
		}

		closePanel() {
		if(this.toggle != null){
			this.toggle.setAttribute("aria-expanded", "false");
			this.toggle.classList.add("panel-closed");
			this.toggle.classList.remove("panel-opened");
		}
			this.panel.setAttribute("aria-expanded", "false");
			this.panel.classList.remove("panel-opened");
			this.panel.classList.add("panel-closed");
			this.panel.style.pointerEvents = 'none';
			
			// Set the "tabIndex" attribute to "-1" on the focusable elements inside the panel
			var focusableElements = this.panel.querySelectorAll('select, input, textarea, button, a');
			focusableElements.forEach(function(element) {
				element.setAttribute('tabIndex', '-1');
			});
			
			// Dispatch a custom "ncr-panel-closed" event on the panel element
			var event = new CustomEvent("ncr-panel-closed", { bubbles: true });
			this.panel.dispatchEvent(event);
		}

		trappingTab() {
			var width = window.innerWidth;

			var allElements = this.panel.querySelectorAll(':not([ncr-panel].panel-closed, [ncr-panel].panel-closed *)');
			// Convert the NodeList object to an array
			var allElementsArray = Array.from(allElements);

			// Filter the array to include only select, input, textarea, a, or button elements
			var tabbable = allElementsArray.filter(function(element) {
			// Check if the element is visible
			if (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0) {
				// The element is visible, so include it in the tabbable array
				return element.matches('select, input, textarea, a, button');
			}
			});
			console.log(this.panel.querySelectorAll('select, input, textarea, a, button'));

			var firstTabbable = tabbable[0];
			var lastTabbable = tabbable[tabbable.length - 1];

			//set focus on first input
			if (this.panel.classList.contains('auto-focus')) {
				firstTabbable.focus();
			}

			//first tab
			this.toggle.addEventListener('keydown', function (e) {
				if (e.which === 9 && !e.shiftKey) {
					if (this.isOff && (width > (this.turnedOffAt() - this.getScrollBarWidth()))) {
					e.stopImmediatePropagation();
					} else {
					if (this.classList.contains('panel-opened')) {
						e.preventDefault();
						firstTabbable.focus();
					} else {
						e.stopImmediatePropagation();
					}
					}
				}
			},{ passive: true });

			// Check if to trap tab or not
			if (!this.panel.classList.contains('panel-no-trap')) {
				// First shift-tab
				if (this.toggle) {
					this.toggle.addEventListener('keydown', function(e) {
						if (!this.toggle) {
							return undefined;
						}
						else if (e.which === 9 && e.shiftKey) {
							if ((this.isOff) && (width > (turnedOffAt() - getScrollBarWidth()))) {
							e.stopImmediatePropagation();
							} else {
							if (this.classList.contains('panel-opened')) {
								e.preventDefault();
								firstTabbable.focus();
							} else {
								e.stopImmediatePropagation();
							}
							}
						}
					},{ passive: true });
				}
				if (lastTabbable) {
				// Redirect last tab to first input
					lastTabbable.addEventListener('keydown', function(e) {
						if (e.which === 9 && !e.shiftKey) {
							if ((this.isOff) && (width > (this.turnedOffAt() - this.getScrollBarWidth()))) {
							e.stopImmediatePropagation();
							console.log('on first');
							} else {
							e.preventDefault();
							firstTabbable.focus();
							}
						}
					},{ passive: true });
				}
			
				if (firstTabbable) {
				// Redirect first shift+tab to last input
					firstTabbable.addEventListener('keydown', function(e) {
						if (e.which === 9 && e.shiftKey) {
							if ((this.isOff) && (width > (this.turnedOffAt() - this.getScrollBarWidth()))) {
							e.stopImmediatePropagation();
							} else {
							e.preventDefault();
							lastTabbable.focus();
							}
						}
					},{ passive: true });
				}

			}

		 	this.panel.addEventListener('keyup', (e) =>{
				switch (e.which) {
					case 27: // escape
					if (!((this.isOff == true) && (width > (this.turnedOffAt() - this.getScrollBarWidth())))) {
						if (!(this.panel.classList.contains('panel-no-trap'))) {
							if (this.panel.classList.contains('ncr-turned-off')) {
								// this.closeChildren(this);
								console.log('escape tyrbed iff');
							}
							this.closePanel();
							this.toggle.focus();
							if (this.panel.classList.contains('panel-pop')) {
								document.querySelector('body').style.overflowY = 'auto';
								document.querySelector('body').style.position = 'relative';
								document.querySelector('body').style.borderRight = '0px solid white';
							}
							e.stopImmediatePropagation();
							console.log('escape no trap');
						}
						console.log('escape');
					}
					break;
				
					case 37: // left
					// allElements[allElements.indexOf(e) + counter--].focus();
					// Get all links in the HTML
					var allLinks = allElements.querySelectorAll('a');
					// Get the index of the currently focused link
					var index = allLinks.indexOf(document.activeElement);
					// If there is a link after the currently focused one
					if (index + 1 < allLinks.length) {
						// Focus on the next link
						allLinks[index + 1].focus();
					}
					break;
				
					case 38: // up
					allElements[allElements.indexOf(e) + counter--].focus();
					//console.log("clicked up");
					break;
				
					case 39: // right
					// allElements[allElements.indexOf(e) + counter++].focus();
					//console.log("clicked right");
					// Get all links in the HTML
					var allLinks = allElements.querySelectorAll('a');
					// Get the index of the currently focused link
					var index = allLinks.indexOf(document.activeElement);
					// If there is a link after the currently focused one
					if (index + 1 < allLinks.length) {
						// Focus on the next link
						allLinks[index + 1].focus();
					}
					break;
				
					case 40: // down
					allElements[allElements.indexOf(e) + counter++].focus();
					//console.log("clicked down");
					break;
				
					default:
					return;
				}
			},{ passive: true });

			this.toggle.addEventListener('keyup', (e) =>{
				switch (e.which) {
					case 27: // escape
					if (!((this.isOff == true) && (width > (this.turnedOffAt() - this.getScrollBarWidth())))) {
						if (!(this.panel.classList.contains('panel-no-trap'))) {
							if (this.panel.classList.contains('ncr-turned-off')) {
								// this.closeChildren(this);
								console.log('this.closeChildren(this);');
							}
							this.closePanel();
							this.toggle.focus();
							if (this.panel.classList.contains('panel-pop')) {
								document.querySelector('body').style.overflowY = 'auto';
								document.querySelector('body').style.position = 'relative';
								document.querySelector('body').style.borderRight = '0px solid white';
							}
							e.stopImmediatePropagation();
						}
					}
					break;
		
					default:
					return;
				}
			},{ passive: true });


		}

		aboveOrbelow() {
			if (!this.isOff) {
				return undefined;
				}
				// Get a reference to the panel element
				var panel = document.querySelector('[ncr-panel="' + this.name + '"]');
				
				// Get the class names on the panel element as an array
				var classNames = Array.from(panel.classList);
				
				// Find the class name that starts with "panel-off-"
				var offClassName = classNames.find(function (className) {
				return className.indexOf('panel-off-') > -1;
				});
				
				// Split the class name on the "-" character and return the third element
				// console.log(offClassName.split('-')[2])
				return offClassName.split('-')[2];
		}

		turnedOffAt() {
		if (!this.isOff) {
			return undefined;
		}
			// Get a reference to the panel element
			var panel = document.querySelector('[ncr-panel="' + this.name + '"]');
			
			// Get the class names on the panel element as an array
			var classNames = Array.from(panel.classList);
			
			// Find the class name that starts with "panel-off-"
			var offClassName = classNames.find(function (className) {
				return className.indexOf('panel-off-') > -1;
			});
			
			// Split the class name on the "-" character and return the third element
			// console.log(offClassName.split('-')[3], this.name)
			return offClassName.split('-')[3];
		}

		turnOnPanel(){
		this.panel.classList.remove('ncr-turned-off');
		this.toggle.classList.remove('ncr-toggle-turned-off');
		this.closePanel();
		// console.log( this.name, this.turnedOffAbove < window.innerWidth, 'ON');
		}

		turnOffPanel(){
		this.panel.classList.add('ncr-turned-off');
		this.toggle.classList.add('ncr-toggle-turned-off');
		this.openPanel();
		// console.log( this.name, this.turnedOffAbove < window.innerWidth, 'OFF');
		}
		
		getScrollBarWidth() {
			var inner = document.createElement('p');
			inner.style.width = "100%";
			inner.style.height = "200px";
		  
			var outer = document.createElement('div');
			outer.style.position = "absolute";
			outer.style.top = "0px";
			outer.style.left = "0px";
			outer.style.visibility = "hidden";
			outer.style.width = "200px";
			outer.style.height = "150px";
			outer.style.overflow = "hidden";
			outer.appendChild (inner);
		  
			document.body.appendChild (outer);
			var w1 = inner.offsetWidth;
			outer.style.overflow = 'scroll';
			var w2 = inner.offsetWidth;
			if (w1 == w2) w2 = outer.clientWidth;
		  
			document.body.removeChild (outer);
		  
			return (w1 - w2);
		}

		_initialize(){
		
		this.panel.classList.add('level-' + this.level);
		this.panel.setAttribute("aria-expanded", this.isOpen);
		this.panel.setAttribute('aria-label', this.name + ' Primary');
		if (this.toggle != null) {
			this.toggle.style.pointerEvents = 'auto';
			this.toggle.setAttribute('aria-label', this.name + ' Toggle');
			this.toggle.setAttribute("aria-expanded", this.isOpen);
			this.toggle.classList.add('level-' + this.level);
		}
		if (this.closeButton) {
			//close button
			this.closeButton.setAttribute('aria-label', `${this.name} close Button`);
			// Get a reference to the panel element
		}

		var panel = document.querySelector('[ncr-panel="' + this.name + '"]');

		// If the panel is not open, disable pointer events on the panel and set the "tabIndex" attribute to "-1" on the focusable elements inside the panel
		if (!this.isOpen) {
			panel.style.pointerEvents = 'none';
			var focusableElements = panel.querySelectorAll('select, input, textarea, button, a');
			focusableElements.forEach(function(element) {
				element.setAttribute('tabIndex', '-1');
			});
		}

		// If the panel is turned off and the "turnedOffAbove" value is less than the width of the window, add the "ncr-turned-off" class to the panel and remove the "panel-pop" class
		if (this.isOff && this.turnedOffAbove < window.innerWidth) {
			panel.classList.add('ncr-turned-off');
			panel.classList.remove('panel-pop');
		}

		if (this.panel.classList.contains('panel-overlay')) {
			this.panel.classList.add('panel-overlay');
			this.toggle.classList.add('panel-overlay');
		}
		// adds panel-overlay to toggle
		if (this.panel.classList.contains('panel-pop')) {
			this.panel.classList.add('panel-pop');
			this.toggle.classList.add('panel-pop');
		}
		// adds panel-pop to toggle popout-bg
		if (this.panel.classList.contains('panel-pop')) {
			if (this.panel.querySelectorAll('.popout-bg').length == 0) {
			this.panel.innerHTML += '<div class="popout-bg"></div>';
			}
		}


		
			
		}
		
	
	}

    // Get a list of all elements with the "ncr-panel" attribute on the page
	var panelElements = document.querySelectorAll('[ncr-panel]');
	var panelElementsArray = Array.from(panelElements);
	// Create a new Panel object for each element in the array and return an array of these objects
	var allPanels = panelElementsArray.map(function(panelElement) {
	  return new Panel(panelElement);
	});

	allPanels.forEach(function(panel){
		if (panel.toggle != null) {
			panel.toggle.addEventListener('click', function() {
				if (panel.panel.classList.contains('panel-opened')) {
				panel.closePanel();
				} else {
				panel.openPanel();
				panel.trappingTab();
				}
			},{ passive: true });
		}

		panel.panel.addEventListener('click', function (e) {
			e.stopImmediatePropagation();
		},{ passive: true });

		if (panel.closeButton && typeof panel.closeButton !== 'undefined') {
			panel.closeButton.addEventListener('click', function() {
				panel.closePanel();
			},{ passive: true });
		}

		panel.panel.addEventListener("ncr-close-panel", function() {
			panel.closePanel();
		},{ passive: true });

		panel.panel.addEventListener("ncr-open-panel", () => {
			panel.openPanel();
		},{ passive: true });


	});



	
	// window.addEventListener('resize', () => {
	// 	var allPanels = panelElements.map(function(panelElement) {
	// 	  return new Panel(panelElement);
	// 	});

	// 	return allPanels;
	// });


	if(document.querySelectorAll('.feature-wrap.first-open').length > 0){
		var firstOpenContainers = document.querySelectorAll('.feature-wrap.first-open');
		firstOpenContainers.forEach(function(container){
		var firstPanel = container.querySelector('[ncr-panel]');
		var event = new CustomEvent('ncr-open-panel');
		firstPanel.dispatchEvent(event);
		});
	}
		
	if(document.querySelectorAll('.feature-wrap.all-open').length > 0){
		var allOpenContainers = document.querySelectorAll('.feature-wrap.all-open');
		allOpenContainers.forEach(function(container){
			var panels = container.querySelectorAll('[ncr-panel]');
			panels.forEach(function(panel){
				var event = new CustomEvent('ncr-open-panel');
				panel.dispatchEvent(event);
			});
		});
	}

	//overlay setup
	document.addEventListener('click', (event) => {
		if (!event.target.classList.contains('panel-overlay')) {
		  // Get the panel and toggle elements

		  const panelElements = document.querySelectorAll('.panel-overlay[ncr-panel]');
		  const panelElementsArray  = Array.from(panelElements);
		  const toggleElements = document.querySelectorAll('.panel-overlay[ncr-toggle]');
		  const toggleElementArray  = Array.from(toggleElements);


		  // Loop through the panel and toggle elements
		  panelElementsArray.forEach((panelElement) => {
			toggleElementArray.forEach((toggleElement) => {
				if (panelElement.getAttribute('aria-expanded') == 'true') {

				  toggleElement.setAttribute("aria-expanded", "false");
				  toggleElement.classList.remove("panel-opened");
				  toggleElement.classList.add("panel-closed");
				  panelElement.setAttribute("aria-expanded", "false");
				  panelElement.classList.remove("panel-opened");
				  panelElement.classList.add("panel-closed");
				  panelElement.style.pointerEvents = 'none';
				  var inputElems = panelElement.querySelectorAll('select, input, textarea, button, a');
				  inputElems.forEach(function (inputElem) {
					inputElem.setAttribute('tabIndex', '-1');
				  });
				}
		  });
		});
		  
		}

	},{ passive: true });
}

  ///////////////////////////////////////////////////////////////////////////
  //tabTrapping 6.0 end                                                    //
  ///////////////////////////////////////////////////////////////////////////













///remove when ready to NOT use jquery
function jqueryTabTrapping (options, callback) {

	var settings = $.extend({
		preloadRemoveDelay: 0
	}, options);

	var allPanels = $('body').find('[ncr-panel]');

	if($('.feature-wrap').hasClass('single-open')){
		var  panels = $('.single-open').find('[ncr-panel]');
		// console.log(panels.attr('ncr-panel'));
		panels.each(function(){
			$(this).addClass('panel-accordion');
		});
	}
	allPanels.each(function () {

		({
			panel: $(this),
			toggle: $(this).attr('ncr-panel')

		});

		//initial main variables set up
		var ncr_panel = $(this);
		var panel_attr = ncr_panel.attr('ncr-panel');
		var ncr_toggle = $('[ncr-toggle="' + panel_attr + '"]');
		var ncr_toggle_attr = ncr_toggle.attr('ncr-toggle');

		var close_button = ncr_panel.find('.close-button');
		var width = window.innerWidth;
		var isitpop = false;
		var isitoverlay = false;
		ncr_panel.find('[ncr-panel]');


		function getScrollBarWidth() {
			var inner = document.createElement('p');
			inner.style.width = "100%";
			inner.style.height = "200px";
		  
			var outer = document.createElement('div');
			outer.style.position = "absolute";
			outer.style.top = "0px";
			outer.style.left = "0px";
			outer.style.visibility = "hidden";
			outer.style.width = "200px";
			outer.style.height = "150px";
			outer.style.overflow = "hidden";
			outer.appendChild (inner);
		  
			document.body.appendChild (outer);
			var w1 = inner.offsetWidth;
			outer.style.overflow = 'scroll';
			var w2 = inner.offsetWidth;
			if (w1 == w2) w2 = outer.clientWidth;
		  
			document.body.removeChild (outer);
		  
			return (w1 - w2);
		  }		//intial setup for elements
		function intialSetupForElements(this_panel, this_toggle) {
			//add data- class
			ncr_toggle.addClass('ncr-toggle');
			// $(ncr_panel).addClass('ncr-panel');

			var ncr_toggle_close = $('.ncr-toggle.panel-closed');
			var ncr_toggle_open = $('.ncr-toggle.panel-opened');
			var ncr_panel_close = $('[ncr-panel].panel-closed');
			var ncr_panel_open = $('[ncr-panel].panel-opened');
			var childrenOfPanel = ncr_panel.find('[ncr-panel]');
			var childrenOfPanelToggle = ncr_panel.find('[ncr-toggle]');

			//adds all aria related attributes 
			ncr_toggle.css('pointer-events', 'auto');
			ncr_panel_close.attr("aria-expanded", "false").css('pointer-events', 'none');
			ncr_panel_close.find('select, input, textarea, button, a').attr('tabIndex', '-1');
			ncr_panel_open.attr("aria-expanded", "true");
			ncr_toggle_close.attr("aria-expanded", "false");
			ncr_toggle_open.attr("aria-expanded", "true");


			if (ncr_panel.attr("aria-label") == "" || ncr_panel.attr("aria-label") == undefined) {
				ncr_panel.attr('aria-label', '' + panel_attr + ' Primary');
			}
			if (ncr_toggle.attr("aria-label") == "" || ncr_toggle.attr("aria-label") == undefined) {
				ncr_toggle.attr('aria-label', '' + panel_attr + ' Toggle');
			}
			if (close_button.attr("aria-label") == "" || close_button.attr("aria-label") == undefined) {
				close_button.attr('aria-label', '' + panel_attr + ' close Button');
			}

			childrenOfPanel.each(function () {
				childrenOfPanel.addClass('child-panel');
				childrenOfPanelToggle.addClass('child-panel');
			});
			this_panel.each(function () {
				var level = $(this).parents('[ncr-panel]').length + 1;

				$(this).addClass('level-' + level);
				this_toggle.addClass('level-' + level);
			});
			//adds panel-overlay to toggle
			if (settings.popout == true || this_panel.hasClass('panel-pop')) {
				$(this_panel).addClass('panel-pop');
				$(this_toggle).addClass('panel-pop');
			}
			//adds panel-overlay to toggle
			else if (settings.overlay == true || this_panel.hasClass('panel-overlay')) {
				$(this_panel).addClass('panel-overlay');
				$(this_toggle).addClass('panel-overlay');
			}
			//adds popout-bg div to panel-pops
			if ($(this_panel).hasClass('panel-pop')) {
				if ($(this_panel).children('.popout-bg').length == 0) {
					$(this_panel).append('<div class="popout-bg"></div>');
				}
			}
			//adds popout-bg div to panel-pops
			if ($(this_panel).hasClass('track-history')) {
				$(this_toggle).addClass('track-history');
			}
			//adds panel-accordion to toggle
			else if ($(this_panel).hasClass('panel-accordion')) {
				$(this_toggle).addClass('panel-accordion');
			}
			//adds panel-closed to toggle
			else if ($(this_panel).hasClass('panel-closed')) {
				$(this_toggle).addClass('panel-closed');
			}
			//adds panel-opened to toggle
			else if ($(this_panel).hasClass('panel-opened')) {
				$(this_toggle).addClass('panel-opened');
			}
		}

		//start
		intialSetupForElements(ncr_panel, ncr_toggle);

		//ncr-close-panel / ncr-open-panel custom .on()
		ncr_panel.on("ncr-close-panel", function () {
			ncr_panel_close_settings(ncr_toggle, panel_attr);
		});
		ncr_panel.on("ncr-open-panel", function () {
			ncr_panel_open_settings(ncr_toggle, panel_attr);
			trappingTab(ncr_panel);
		});

		//returns if turned off based on class
		function ifTurnedOff() {
			if (ncr_panel.is('[class*=panel-off-]')) {
				return true;
			} else {
				return false;
			}
		}

		//returns when its turned off
		function turnedOffabove() {
			if (ncr_panel.is('[class*=panel-off-]')) {
				var result = undefined;
				$(ncr_panel.attr('class').split(' ')).each(function () {
					if (this.indexOf('panel-off-') > -1) result = this;
				});
				var res = result.split('-')[2];
			} else {
				return res = 'on';
			}
			return res;
		}

		function turnedOffaboveNumber() {
			var element_id = ncr_panel.attr('class');
			var number = element_id.match(/\d+/);
			return number;
		}

		//targets after initial setup
		var popout_bg = ncr_panel.find('.popout-bg');
		var overlay_panel = $('.panel-overlay');
		var popout_panel = $('.panel-pop');
		var level = ncr_panel.parents('[ncr-panel]').length + 1;






		//function called to open panel
		function ncr_panel_open_settings(dataBtn, data) {
			dataBtn.attr("aria-expanded", "true")
				.addClass("panel-opened")
				.removeClass("panel-closed");

			var ncr_panel =
				$('[ncr-panel="' + data + '"]')
				.attr("aria-expanded", "true")
				.addClass("panel-opened")
				.removeClass("panel-closed")
				.css('pointer-events', 'auto');

			var ncr_panel_inputs =
				$('[ncr-panel="' + data + '"]')
				.find('select, input, textarea, button, a')
				.attr('tabIndex', '0');

			$('[ncr-panel="' + data + '"]').find('.panel-closed[ncr-panel]')
				.find('select, input, textarea, button, a')
				.attr('tabIndex', '-1');

			ncr_panel.trigger("ncr-panel-opened");
			$('[ncr-panel="' + data + '"]').parents('.feature').addClass('active');

			return ncr_panel_inputs;
		}

		//function called to close panel
		function ncr_panel_close_settings(dataBtn, data) {
			dataBtn.attr("aria-expanded", "false")
				.addClass("panel-closed")
				.removeClass("panel-opened");

			var ncr_panel =
				$('[ncr-panel="' + data + '"]')
				.attr("aria-expanded", "false")
				.removeClass("panel-opened")
				.addClass("panel-closed")
				.css('pointer-events', 'none');

			var ncr_panel_inputs =
				$('[ncr-panel="' + data + '"]')
				.find('select, input, textarea, button, a')
				.attr('tabIndex', '-1');


			// if ($('[ncr-panel="' + data + '"]').hasClass('track-history')) {
			//     var uri = window.location.toString();
			//     if (uri.indexOf("?") > 0) {
			//         var clean_uri = uri.substring(0, uri.indexOf("?"));
			//         window.history.replaceState({}, document.title, clean_uri, function() {});
			//     }
			// }

			ncr_panel.trigger("ncr-panel-closed");
			$('[ncr-panel="' + data + '"]').parents('.feature').removeClass('active');

			return ncr_panel_inputs;
		}

		//close all children
		function closeChildren(parentPanel) {
			var childrenOfPanel = parentPanel.find('.child-panel[ncr-panel]');
			var childrenOfPanelToggle = parentPanel.find('.child-panel[ncr-toggle]');

			childrenOfPanel.each(function () {
				$(childrenOfPanelToggle).attr("aria-expanded", "false")
					.addClass("panel-closed")
					.removeClass("panel-opened");

				childrenOfPanel
					.attr("aria-expanded", "false")
					.removeClass("panel-opened")
					.addClass("panel-closed")
					.css('pointer-events', 'none');

				var ncr_panel_inputs =
					childrenOfPanel
					.find('select, input, textarea, button, a')
					.attr('tabIndex', '-1');


				return ncr_panel_inputs;
			});
		}

		//open all children
		function openChildren() {
			var childrenOfPanel = ncr_panel.find('.child-panel[ncr-panel]');
			var childrenOfPanelToggle = ncr_panel.find('.child-panel[ncr-toggle]');

			childrenOfPanel.each(function () {
				childrenOfPanelToggle.attr("aria-expanded", "true")
					.addClass("panel-opened")
					.removeClass("panel-closed");

				childrenOfPanel
					.attr("aria-expanded", "true")
					.removeClass("panel-closed")
					.addClass("panel-opened")
					.css('pointer-events', 'auto');

				var ncr_panel_inputs =
					childrenOfPanel
					.find('select, input, textarea, button, a')
					.attr('tabIndex', '0');


				return ncr_panel_inputs;
			});
		}

		//tab trap
		function trappingTab(panel) {

			//selecting elements to tab through *thanks to the greatness of jordan
			var allElements = panel.find(':not([ncr-panel].panel-closed, [ncr-panel].panel-closed *)');
			var tabbable = allElements.filter('select:visible, input:visible, textarea:visible, a:visible, button:visible');

			var firstTabbable = tabbable.first();
			var lastTabbable = tabbable.last();


			//set focus on first input
			if (ncr_panel.hasClass('auto-focus')) {
				firstTabbable.focus();
			}


			//first tab
			ncr_toggle.on('keydown', function (e) {
				if ((e.which === 9 && !e.shiftKey)) {
					if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
						e.stopImmediatePropagation();
					} else {
						if ($(this).hasClass('panel-opened')) {
							e.preventDefault();
							firstTabbable.focus();
						} else {
							e.stopImmediatePropagation();
						}
					}
				}
			});

			//check if to traptab or not
			if (!(panel.hasClass('panel-no-trap'))) {
				//first shift-tab
				ncr_toggle.on('keydown', function (e) {
					if ((e.which === 9 && e.shiftKey)) {
						if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
							e.stopImmediatePropagation();
						} else {
							if ($(this).hasClass('panel-opened')) {
								e.preventDefault();
								firstTabbable.focus();
							} else {
								e.stopImmediatePropagation();
							}
						}
					}
				});
				//redirect last tab to first input
				lastTabbable.on('keydown', function (e) {
					if ((e.which === 9 && !e.shiftKey)) {
						if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
							e.stopImmediatePropagation();
						} else {
							e.preventDefault();
							firstTabbable.focus();
						}
					}
				});
				//redirect first shift+tab to last input
				firstTabbable.on('keydown', function (e) {
					if ((e.which === 9 && e.shiftKey)) {
						if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
							e.stopImmediatePropagation();
						} else {
							e.preventDefault();
							lastTabbable.focus();
						}
					}
				});
			}


			//all keys
			ncr_panel.on('keyup', function (e) {
				switch (e.which) {
					case 27: // escape
						if (!((ifTurnedOff() == true) && (width > (turnedOffabove() - getScrollBarWidth())))) {
							if (!(panel.hasClass('panel-no-trap'))) {

								if (ncr_panel.hasClass('ncr-turned-off')) {
									closeChildren(this);
								}
								ncr_panel_close_settings(ncr_toggle, panel_attr);
								ncr_toggle.focus();
								if (ncr_panel.hasClass('panel-pop')) {
									$('body').css('overflow-y', 'auto');
									$('body').css('position', 'relative');
									$('body').css('border-right','0px solid white');
								}

								e.stopImmediatePropagation();
							}
						}
						break;

					case 37: // left
						allElements.eq(allElements.index($(e)) + counter--, function () {}).focus();
						//console.log("clicked left");
						break;

					case 38: // up
						allElements.eq(allElements.index($(e)) + counter--).focus();
						//console.log("clicked up");
						break;

					case 39: // right
						allElements.eq(allElements.index($(e)) + counter++).focus();
						//console.log("clicked right");
						break;

					case 40: // down
						allElements.eq(allElements.index($(e)) + counter++).focus();
						//console.log("clicked down");
						break;

					default:
						return;
				}

			});

		}

		//if popout panel is open, it automatically tab traps in it
		if (ncr_panel.hasClass('panel-pop') && ncr_panel.hasClass('panel-opened')) {
			var loaded_popout = $(document).find('.panel-pop.panel-opened');
			$('body').css('overflow-y', 'hidden');
			$('body').css('position', 'absolute');
			trappingTab(loaded_popout);
		}

		var isItHover;

		$(window).on('load resize', function () {
			isItHover = ncr_panel.hasClass('hover-toggle') && window.innerWidth >= turnedOffaboveNumber();
			ifTurnedOff() && window.innerWidth >= turnedOffaboveNumber();

			//  console.log(ncr_toggle.attr('ncr-toggle'),'|hover: ',isItHover,'| off: ',isItOff, 'numb', turnedOffaboveNumber() )
		});


		//start of button functionality
		//toggle button
		ncr_toggle.on('click', function (e) {
			var overlay_panels = $('body').find('[ncr-panel].panel-overlay');
			var overlay_toggles = $('body').find('[ncr-toggle].panel-overlay');
			var popout_panels = $('body').find('[ncr-panel].panel-pop.level-' + level);
			var popout_toggles = $('body').find('[ncr-toggle].panel-pop.level-' + level);
			var accordion_panels = $(this).parents('.feature-wrap').find('[ncr-panel].panel-accordion.level-' + level);
			var accordion_toggles = $(this).parents('.feature-wrap').find('[ncr-toggle].panel-accordion.level-' + level);
			var panel_child_panel = $(ncr_panel).find('> [ncr-panel].child-panel');

	// console.log(accordion_panels, accordion_toggles)
			function buttonFunctionality() {
				if (ncr_toggle.hasClass('panel-pop', 'level-' + level)) {
					if (ncr_panel.attr("aria-expanded") == 'false') {
						e.stopImmediatePropagation();

						popout_toggles.attr("aria-expanded", "true")
							.addClass("panel-closed")
							.removeClass("panel-opened");

						popout_panels
							.attr("aria-expanded", "false")
							.removeClass("panel-opened")
							.addClass("panel-closed")
							.css('pointer-events', 'none');

						popout_panels
							.find('select, input, textarea, button, a')
							.attr('tabIndex', '-1');

						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
						trappingTab(ncr_panel);


						$('body').css('overflow-y', 'hidden');
						$('body').css('position', 'absolute');
						$('body').css('width', '100%');
						$('body').css('border-right',''+getScrollBarWidth()+'px solid white');
		

						if (panel_child_panel.hasClass('ncr-turned-off')) {
							openChildren();
						}
					} else if (ncr_panel.attr("aria-expanded") == 'true') {
						if (ncr_panel.hasClass('panel-pop')) {
							$('body').css('overflow-y', 'auto');
							$('body').css('position', 'relative');
							$('body').css('border-right','0px solid white');
						}

						ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
						if ($(ncr_panel).hasClass('ncr-turned-off')) {
							trappingTab(this);
						}
					}
				} else if (ncr_toggle.hasClass('panel-overlay')) {
					if (ncr_panel.attr("aria-expanded") == 'false') {
						e.stopImmediatePropagation();

						overlay_toggles.attr("aria-expanded", "true")
							.addClass("panel-closed")
							.removeClass("panel-opened");

						overlay_panels
							.attr("aria-expanded", "false")
							.removeClass("panel-opened")
							.addClass("panel-closed")
							.css('pointer-events', 'none');

						overlay_panels
							.find('select, input, textarea, button, a')
							.attr('tabIndex', '-1');
						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
						trappingTab(ncr_panel);

						if (panel_child_panel.hasClass('ncr-turned-off')) {
							openChildren();
						}
					} else {
						if (ncr_panel.hasClass('panel-pop')) {
							$('body').css('overflow-y', 'auto');
							$('body').css('position', 'relative');
							$('body').css('border-right','0px solid white');
						}

						ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
						if ($(ncr_panel).hasClass('ncr-turned-off')) {
							trappingTab(this);
						}
					}
				} else if (ncr_toggle.hasClass('panel-accordion', 'level-' + level)) {
					if (ncr_panel.attr("aria-expanded") == 'false') {

						accordion_toggles.attr("aria-expanded", "true")
							.addClass("panel-closed")
							.removeClass("panel-opened");

						accordion_panels
							.attr("aria-expanded", "false")
							.removeClass("panel-opened")
							.addClass("panel-closed")
							.css('pointer-events', 'none');

						accordion_panels
							.find('select, input, textarea, button, a')
							.attr('tabIndex', '-1');

						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
						trappingTab(ncr_panel);
						if (panel_child_panel.hasClass('ncr-turned-off')) {
							openChildren();
						}
					} else {
						if (!(ncr_panel.hasClass('panel-cant-close') && ncr_panel.hasClass('panel-opened'))) {
							if (ncr_panel.hasClass('panel-pop')) {
								$('body').css('overflow-y', 'auto');
								$('body').css('position', 'relative');
								$('body').css('border-right','0px solid white');
							}
							ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
							if ($(ncr_panel).hasClass('ncr-turned-off')) {
								trappingTab(this);
							}
						}

					}
				} else {
					if (ncr_panel.attr("aria-expanded") == 'false') {
						$(this).trigger("ncr-panel-open", function () {
							//console.log('opened - call ncr-panel-open');
						});
						ncr_panel_open_settings(ncr_toggle, ncr_toggle_attr);
						trappingTab(ncr_panel);
						if (panel_child_panel.hasClass('ncr-turned-off')) {
							openChildren();
						}
					} else {
						if (ncr_panel.hasClass('panel-pop')) {
							$('body').css('overflow-y', 'auto');
							$('body').css('position', 'relative');
							$('body').css('border-right','0px solid white');
						}
						$(this).trigger("ncr-panel-close", function () {
							//console.log('closed - call ncr-panel-close');
						});

						ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
						if ($(ncr_panel).hasClass('ncr-turned-off')) {
							trappingTab(this);
						}
					}
				}

			
			}
			if (!((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth())))) {
				buttonFunctionality();
				if (!(ncr_panel.hasClass('panel-no-trap'))) {
					ncr_toggle.keyup(function (e) {
						if (e.keyCode == 27) {

							if ($(this).hasClass('panel-pop')) {
								$('body').css('overflow-y', 'auto');
								$('body').css('position', 'relative');
								$('body').css('border-right','0px solid white');
							}
							ncr_panel_close_settings(ncr_toggle, ncr_toggle_attr);
							if ($(ncr_panel).hasClass('ncr-turned-off')) {
								trappingTab(this);
							}
							$(this).focus();
							// console.log('escaped not')  
						}
					});
					e.stopImmediatePropagation();
				}

			} else if ((ncr_panel.hasClass('ncr-panel-off'))) {
				ncr_toggle.keyup(function (e) {
					if (e.keyCode == 27) ;
				});
			}
		});

		function hoverOffAt(){
			if (ncr_panel.is('[class*=hover-off-]')) {
				var result = undefined;
				$(ncr_panel.attr('class').split(' ')).each(function () {
					if (this.indexOf('hover-off-') > -1) result = this;
				});
				var res = result.split('-')[2];
			} else {
				return res = 'on';
			}
			return res;
		}

		$(window).on('load resize', function () {
			if(window.innerWidth >= (hoverOffAt() - getScrollBarWidth())){
				
				$(ncr_toggle).parents('.feature').offset(ncr_panel).on('mouseover', function () {
					if (isItHover) {
						var panel_child_panel = $(ncr_panel).find('.child-panel[ncr-panel]');
						ncr_panel_open_settings(ncr_toggle, panel_attr);
						trappingTab(ncr_panel);
						if ($(panel_child_panel).hasClass('ncr-turned-off')) {
							openChildren();
						}
					}
				});

				$(ncr_toggle).parents('.feature').offset(ncr_panel).on('mouseleave', function () {
					if (isItHover) {
						ncr_panel_close_settings(ncr_toggle, panel_attr);
					}
				});
			}
			else {
				$(ncr_toggle).parents('.feature').offset(ncr_panel).off('mouseover');
				$(ncr_toggle).parents('.feature').offset(ncr_panel).off('mouseleave');
			}
		});
		

		

		//close button
		close_button.on('click', function (e) {
			if (!($(this).parent('[ncr-panel]').hasClass('ncr-turned-off'))) {
				var ncr_panel = $(this).parents('.panel-opened').attr('ncr-panel');
				var ncr_toggle = $('[ncr-toggle="' + ncr_panel + '"');

				// console.log('working');
				$('body').css('overflow-y', 'auto');
				$('body').css('position', 'relative');
				$('body').css('border-right','0px solid white');

				ncr_panel_close_settings(ncr_toggle, ncr_panel);
				if ($(ncr_panel).hasClass('ncr-turned-off')) {
					closeChildren();
				}
				ncr_toggle.focus();

				e.stopImmediatePropagation();
			}
		});

		//panel-pop
		popout_bg.on('click', function (e) {
			if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
				e.stopImmediatePropagation();
			} else {
				var ncr_panel = $(this).parents().attr('ncr-panel');



				ncr_panel_close_settings(ncr_toggle, ncr_panel);
				if ($(ncr_panel).hasClass('ncr-turned-off')) {
					closeChildren();
				}

				ncr_toggle.focus();
				if ($(this).parents('[ncr-panel]').hasClass('panel-pop')) {
					$('body').css('overflow-y', 'auto');
					$('body').css('position', 'relative');
					$('body').css('border-right','0px solid white');
				}
				e.stopImmediatePropagation();
			}
		});

		//panel-overlay stop from closing if clicked outside of selector
		overlay_panel.on('click', function (e) {
			e.stopImmediatePropagation();
		});

		//panel-pop stop from closing if clicked outside of selector
		popout_panel.on('click', function (e) {
			e.stopImmediatePropagation();
		});

		//space button
		ncr_toggle.keyup(function (e) {
			if ((ifTurnedOff()) && (width > (turnedOffabove() - getScrollBarWidth()))) {
				e.stopImmediatePropagation();
			} else {
				if (e.keyCode == 32) {
					e.preventDefault();
					var ncr_panel = $('[ncr-panel="' + panel_attr + '"]');
					if (ncr_panel.attr("aria-expanded") == 'false') {
						ncr_panel_open_settings(ncr_panel, panel_attr);
						trappingTab(ncr_panel);
						e.stopImmediatePropagation();
					}

				}
			}
		});




		//if turnOff is true, do these things
		//from class to class function
		function switchClassesAbove() {
			if (ncr_panel.is('[class*=switch-]')) {
				var result = undefined;
				$(ncr_panel.attr('class').split(' ')).each(function () {
					if (this.indexOf('switch-') > -1) result = this;
				});
				var res = result.split('-')[1];
			} else {
				return res = 'on';
			}
			return res;
		}

		function fromClass() {
			if (ncr_panel.is('[class*=switch-]')) {
				var fromClass = undefined;
				$(ncr_panel.attr('class').split(' ')).each(function () {
					if (this.indexOf('switch-') > -1) fromClass = this;
				});
				var from = fromClass.split('-')[3];
			} else {
				return from = 'on';
			}
			return 'panel-' + from;
		}

		function toClass() {
			if (ncr_panel.is('[class*=switch-]')) {
				var toClass = undefined;
				$(ncr_panel.attr('class').split(' ')).each(function () {
					if (this.indexOf('switch-') > -1) toClass = this;
				});
				var to = toClass.split('-')[2];
			} else {
				return to = 'on';
			}
			return 'panel-' + to;
		}

		function fromToClass() {
			if (width < switchClassesAbove()) {
				ncr_toggle.addClass(fromClass());
				ncr_panel.addClass(fromClass());
				ncr_toggle.removeClass(toClass());
				ncr_panel.removeClass(toClass());
			} else {
				ncr_toggle.addClass(toClass());
				ncr_panel.addClass(toClass());
				ncr_toggle.removeClass(fromClass());
				ncr_panel.removeClass(fromClass());
			}
		}

		function adjustClasses() {
			if ((ifTurnedOff()) && (width >= (turnedOffabove() - getScrollBarWidth()))) {
				ncr_panel.addClass('ncr-turned-off');
				ncr_toggle.addClass('ncr-toggle-turned-off');

				if (ncr_panel.hasClass('panel-overlay')) {
					isitoverlay = true;
				}
				ncr_toggle.removeClass('panel-overlay');
				ncr_panel.removeClass('panel-overlay');

				if (ncr_panel.hasClass('panel-pop')) {
					isitpop = true;
				}

				ncr_panel.removeClass('panel-pop');
				ncr_toggle.removeClass('panel-pop');

				ncr_toggle.css('pointer-events', 'auto');
				ncr_panel.css('pointer-events', 'none');
				ncr_panel.find('select, input, textarea, button, a').css('pointer-events', 'auto');
			} else {
				ncr_panel.removeClass('ncr-turned-off');
				ncr_toggle.removeClass('ncr-toggle-turned-off');

				if (isitoverlay) {
					ncr_toggle.addClass('panel-overlay');
					ncr_panel.addClass('panel-overlay');
				}
				if (isitpop) {
					ncr_panel.addClass('panel-pop');
					ncr_toggle.addClass('panel-pop');
				}
				ncr_toggle.css('pointer-events', 'auto');
				ncr_panel.css('pointer-events', 'auto');
			}
		}

		if (ifTurnedOff() === true) {
			//turn off open the panel/toggle function
			function open(btn, area) {
				btn
					.attr("aria-expanded", "true")
					.addClass("panel-opened")
					.removeClass("panel-closed");

				area
					.attr("aria-expanded", "true")
					.addClass("panel-opened")
					.removeClass("panel-closed")
					.css('pointer-events', 'auto');

				area
					.find('select, input, textarea, button, a')
					.removeAttr('tabIndex');
			}
			//turn off close the panel/toggle function
			function close(btn, area) {
				btn
					.attr("aria-expanded", "true")
					.addClass("panel-closed")
					.removeClass("panel-opened");

				area
					.attr("aria-expanded", "false")
					.removeClass("panel-opened")
					.addClass("panel-closed")
					.css('pointer-events', 'none');

				area
					.find('select, input, textarea, button, a')
					.attr('tabIndex', '-1');


				$('body').css('overflow-y', 'auto');
				$('body').css('position', 'relative');
				$('body').css('border-right','0px solid white');
			}
			//turning on and off panels/toggle + handles overlays and popouts if turned off 
			function overlaySettingsTurnedOff() {
				if (width < (turnedOffabove() - getScrollBarWidth())) {
					close(ncr_toggle, ncr_panel);
				} else {
					open(ncr_toggle, ncr_panel);
				}

				if (settings.overlay == true || settings.popout == true) {
					if (width < (turnedOffabove() - getScrollBarWidth())) ;
				}
			}

			//turn off function start based on width only resize when resizing

			//turn off function start based on width only resize when loaded
			overlaySettingsTurnedOff();
		}
		fromToClass();
		adjustClasses();
		//on resize width only browser check
		$(window).on('resize', function () {
			if ($(this).width() != width) {
				width = $(this).width();

				if (ifTurnedOff()) {
					//turn off open the panel/toggle function
					function open(btn, area) {
						btn
							.attr("aria-expanded", "true")
							.addClass("panel-opened")
							.removeClass("panel-closed");

						area
							.attr("aria-expanded", "true")
							.addClass("panel-opened")
							.removeClass("panel-closed")
							.css('pointer-events', 'auto');
						area
							.find('select, input, textarea, button, a')
							.removeAttr('tabIndex');
					}
					//turn off close the panel/toggle function
					function close(btn, area) {
						btn
							.attr("aria-expanded", "true")
							.addClass("panel-closed")
							.removeClass("panel-opened");

						area
							.attr("aria-expanded", "false")
							.removeClass("panel-opened")
							.addClass("panel-closed")
							.css('pointer-events', 'none');

						area
							.find('select, input, textarea, button, a')
							.attr('tabIndex', '-1');


						$('body').css('overflow-y', 'auto');
						$('body').css('position', 'relative');
						$('body').css('border-right','0px solid white');
					}
					//turning on and off panels/toggle + handles overlays and popouts if turned off 
					function overlaySettingsTurnedOff() {
						if (width < (turnedOffabove() - getScrollBarWidth())) {
							close(ncr_toggle, ncr_panel);

						} else {
							open(ncr_toggle, ncr_panel);
						}

						if (settings.overlay == true || settings.popout == true) {
							if (width < (turnedOffabove() - getScrollBarWidth())) ;
						}
					}

					//turn off function start based on width only resize when resizing

					//turn off function start based on width only resize when loaded
					overlaySettingsTurnedOff();
				}

				fromToClass();
				adjustClasses();
			}
		});


		if (settings.panelOpen || settings.panelClose == true) {
			ncr_toggle.trigger('click');
			ncr_toggle.focus();
		}

		if (typeof callback == 'function') { // make sure the callback is a function
			callback.call(this); // brings the scope to the callback
		}

	}); // end of foreach


	if($('.feature-wrap').hasClass('first-open')){
		$($('.first-open')).each(function(){
			var  firstChild = $('.first-open').find('[ncr-panel]').first();
			// console.log(firstChild.attr('ncr-panel'));
			firstChild.trigger('ncr-open-panel');
		});

	}
	if($('.feature-wrap').hasClass('all-open')){
		$($('.all-open')).each(function(){
			var  panels = $('.all-open').find('[ncr-panel]');
			// console.log(panels.attr('ncr-panel'));
			panels.each(function(){
			$(this).trigger('ncr-open-panel');
			});
		});
	}
	//panel-overlay
	$(document).on('click', function () {

		if ($('[ncr-panel].panel-overlay:not(.ncr-turned-off)').hasClass('panel-opened')) {


			$('[ncr-toggle].panel-overlay')
				.attr("aria-expanded", "false")
				.addClass("panel-closed")
				.removeClass("panel-opened");

			$('[ncr-panel].panel-overlay')
				.attr("aria-expanded", "false")
				.removeClass("panel-opened")
				.addClass("panel-closed")
				.css('pointer-events', 'none');

			$('[ncr-panel].panel-overlay')
				.find('select, input, textarea, button, a')
				.attr('tabIndex', '-1');
		}
	});
}

function elementResizer(mainElementSelector, options, minWidths, childSelectors, ) {

  const settings = {
    qty: '',
    minWidth: 235,
    child: '.feature',
    margin: 0,
    ...options};

  const mainElements = document.querySelectorAll(mainElementSelector);

  if (!mainElements.length) {
    return {
      destroy() {}
    };
  }

  const resizeElements = (mainElement) => {
    const minWidth = minWidths || mainElement.getAttribute('ncr-resizer-min-width') || settings.minWidth;
    const childSelector = childSelectors || mainElement.getAttribute('ncr-resizer-child') || settings.child;
    const children = Array.from(mainElement.querySelectorAll(childSelector));
    const parentWidth = mainElement.parentElement.clientWidth;
    const gap = parseFloat(window.getComputedStyle(mainElement).getPropertyValue('gap'));
    let numChildrenPerRow = Math.floor(parentWidth / minWidth);
    const qtyClass = mainElement.className.match(/qty-(\d+)/);
    let newClass, columns;
  
    let qty = settings.qty || Number(qtyClass[1]);

    if (qty === 2) {
      children.forEach(child => child.style.width = numChildrenPerRow < 2 ? '100%' : '50%');
      newClass = numChildrenPerRow < 2 ? 'qty-on-1' : 'qty-on-2';
      columns = 2;
      
    } else if (qty === 3) {
      children.forEach(child => child.style.width = numChildrenPerRow < 3 ? '100%' : '33.333%');
      newClass = numChildrenPerRow < 3 ? 'qty-on-1' : 'qty-on-3';
      columns = 3;
    } else if (qty === 4) {
   
      if (numChildrenPerRow >= 4) {
        children.forEach(child =>  child.style.width = '25%' );
        newClass = 'qty-on-4';
        columns = 4;
      } else if (numChildrenPerRow >= 2) {
        children.forEach(child => child.style.width = '50%');
        newClass = 'qty-on-2';
        columns = 2;
      } else {
        children.forEach(child => child.style.width = '100%');
        newClass = 'qty-on-1';
        columns = 1;
      }
    } else if (qty === 5) {
      if (numChildrenPerRow >= 5) {
        children.forEach(child => child.style.width = '20%');
        newClass = 'qty-on-5';
        columns = 5;
      } else if (numChildrenPerRow >= 3) {
        children.forEach(child => child.style.width = '33.3333%');
        newClass = 'qty-on-3';
        columns = 3;
      } else {
        children.forEach(child => child.style.width = '100%');
        newClass = 'qty-on-1';
        columns = 1;
      }
    } else if (qty === 6) {
      if (numChildrenPerRow >= 6) {
        children.forEach(child => child.style.width = '16.66666%');
        newClass = 'qty-on-6';
        columns = 6;
      } else if (numChildrenPerRow >= 4) {
        children.forEach(child => child.style.width = '25%');
        newClass = 'qty-on-4'; 
        columns = 4;
      } else if (numChildrenPerRow >= 2) {
        children.forEach(child => child.style.width = '50%');
        newClass = 'qty-on-2';
        columns = 2;
      } else {
        children.forEach(child => child.style.width = '100%');
        newClass = 'qty-on-1';
        columns = 1;
      }
    }else {
        children.forEach(child => child.style.width = '100%');
        newClass = 'qty-on-1';
        columns = 1;
    }

    // Remove existing qty-on-# classes
    mainElement.className = mainElement.className.replace(/\bqty-on-\d+\b/g, '');
    mainElement.classList.add(newClass);
    
    // Set the width for all elements using calc(), considering the gap
    children.forEach((child, index) => {
      let childWidth = child.style.width;
      child.style.width = `calc(${childWidth} - ${gap}px * (${columns} - 1) / ${columns})`;
    });
};

  const eventListeners = new Map();
  mainElements.forEach(mainElement => {
    const boundResize = resizeElements.bind(null, mainElement);
    eventListeners.set(mainElement, boundResize);
    window.addEventListener('resize', boundResize, { passive: true });
    resizeElements(mainElement);
  });

  return {
    destroy() {
      mainElements.forEach(mainElement => {
        const boundResize = eventListeners.get(mainElement);
        window.removeEventListener('resize', boundResize);
      });
    }
  };
}

function clickableDiv(){
    const divs = document.querySelectorAll('.clickable-div');
      
    divs.forEach(function(div) {
      const anchor = div.querySelector('.feature-cta a');
      if (anchor) {
  
        const href = anchor.getAttribute('href');
        
        const newAnchor = document.createElement('a');
        newAnchor.setAttribute('href', href);
        newAnchor.classList.add('clickable-div');
        
        newAnchor.innerHTML = div.innerHTML;
        
        Array.from(div.attributes).forEach(function(attr) {
          newAnchor.setAttribute(attr.name, attr.value);
        });
  
        div.parentNode.replaceChild(newAnchor, div);
      }
    });
  }

exports.clickableDiv = clickableDiv;
exports.effectOnScroll = effectOnScroll;
exports.elementResizer = elementResizer;
exports.jquerySlider = jquerySlider;
exports.jqueryTabTrapping = jqueryTabTrapping;
exports.moveElementAround = moveElementAround;
exports.moveImageToBg = moveImageToBg;
exports.ncrIcons = ncrIcons;
exports.ncrSlider = ncrSlider;
exports.tabTrapping = tabTrapping;
exports.utils = utils;
